import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** An ISO 8601-encoded date */
  ISO8601Date: any;
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: any;
  /** An ISO 8601-encoded duration. Ex: `P1M` will be a 1 month duration */
  ISO8601Duration: any;
  /** Represents untyped JSON */
  JSON: any;
  Upload: any;
};

export type AddOrUpdateCurrentEditorInput = {
  appName: AppName;
  currentEditorId: Scalars['String'];
  objectCurrentlyEditedId: Scalars['String'];
  subdomain: Scalars['String'];
};

export type Admin = {
  __typename?: 'Admin';
  createdAt: Scalars['ISO8601DateTime'];
  currentSignInAt?: Maybe<Scalars['ISO8601DateTime']>;
  currentSignInIp?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  signInCount?: Maybe<Scalars['Int']>;
  uid: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

export type AdminCollection = {
  __typename?: 'AdminCollection';
  collection: Array<Admin>;
  metadata: CollectionMetadata;
};

export type AgencyTicketCount = {
  __typename?: 'AgencyTicketCount';
  agencyName?: Maybe<Scalars['String']>;
  ticketCount?: Maybe<Scalars['Int']>;
};

export enum AppName {
  BulkMailer = 'bulk_mailer',
  ResponseApprovalQueue = 'response_approval_queue',
  ResponseLibrary = 'response_library'
}

export type AsyncBatchJob = {
  __typename?: 'AsyncBatchJob';
  childCount: Scalars['Int'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  description?: Maybe<Scalars['String']>;
  failedJobs: Array<AsyncJobFailure>;
  failurePct: Scalars['Float'];
  failures: Scalars['Int'];
  id: Scalars['ID'];
  isComplete: Scalars['Boolean'];
  isLongRunning: Scalars['Boolean'];
  isUnknown: Scalars['Boolean'];
  pending: Scalars['Int'];
  pendingPct: Scalars['Float'];
  projectedCompletionTime?: Maybe<Scalars['ISO8601DateTime']>;
  successPct: Scalars['Float'];
  total: Scalars['Int'];
};

/** Autogenerated input type of AsyncBatchJobDestroy */
export type AsyncBatchJobDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of AsyncBatchJobDestroy. */
export type AsyncBatchJobDestroyPayload = {
  __typename?: 'AsyncBatchJobDestroyPayload';
  asyncBatchJob: AsyncBatchJob;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

export type AsyncJobFailure = {
  __typename?: 'AsyncJobFailure';
  errorClass?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  jid: Scalars['ID'];
};

export type Attachment = {
  __typename?: 'Attachment';
  filename: Scalars['String'];
  url: Scalars['String'];
};

export type AudienceList = {
  __typename?: 'AudienceList';
  createdAt: Scalars['ISO8601DateTime'];
  criteria: Array<AudienceListCriteria>;
  groups: Array<AudienceListGroup>;
  id: Scalars['ID'];
  isArchived: Scalars['Boolean'];
  isDraft: Scalars['Boolean'];
  name: Scalars['String'];
  queryString?: Maybe<Scalars['String']>;
  searchedAt?: Maybe<Scalars['ISO8601DateTime']>;
  status: AudienceListStatus;
  subdomain: Subdomain;
  totalAudienceSize?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  users?: Maybe<AudienceListUserCollection>;
};


export type AudienceListUsersArgs = {
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
};

export type AudienceListAdditionalFilters = {
  audienceSize?: Maybe<Scalars['Int']>;
  isEmailValidationEnabled?: Maybe<Scalars['Boolean']>;
  isExcludeNewsSubEnabled?: Maybe<Scalars['Boolean']>;
  isOnlyInDistrictVerifiedEnabled?: Maybe<Scalars['Boolean']>;
  isOnlyNewsSubEnabled?: Maybe<Scalars['Boolean']>;
  lastCampaignDate?: Maybe<Scalars['String']>;
  sizeEstimateOnly?: Maybe<Scalars['Boolean']>;
};

export type AudienceListCollection = Collection & {
  __typename?: 'AudienceListCollection';
  collection: Array<AudienceList>;
  metadata: CollectionMetadata;
};

export type AudienceListCreateInput = {
  criteria: Array<AudienceListCriteriaInput>;
  groups: Array<AudienceListGroupInput>;
  isDraft?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  searchLink?: Maybe<Scalars['String']>;
};

export type AudienceListCriteria = {
  __typename?: 'AudienceListCriteria';
  audienceList: AudienceList;
  content: Scalars['JSON'];
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type AudienceListCriteriaInput = {
  content: Scalars['JSON'];
};

export type AudienceListGroup = {
  __typename?: 'AudienceListGroup';
  audienceList: AudienceList;
  createdAt: Scalars['ISO8601DateTime'];
  criteria: Array<AudienceListCriteria>;
  id: Scalars['ID'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type AudienceListGroupInput = {
  criteria: Array<AudienceListCriteriaInput>;
};

export type AudienceListPopulateBulkMailInput = {
  bulkMailId: Scalars['ID'];
  listId: Scalars['ID'];
};

export type AudienceListPopulateBulkMailResponse = {
  __typename?: 'AudienceListPopulateBulkMailResponse';
  audienceList: AudienceList;
  bulkMail: Campaign;
};

export type AudienceListPopulatePreviewInput = {
  listId: Scalars['ID'];
};

export type AudienceListRefreshAcrossSubdomainsResponse = {
  __typename?: 'AudienceListRefreshAcrossSubdomainsResponse';
  success: Scalars['Boolean'];
};

export enum AudienceListStatus {
  Error = 'error',
  Found = 'found',
  New = 'new',
  Searching = 'searching'
}

export type AudienceListUpdateInput = {
  criteria: Array<AudienceListCriteriaInput>;
  groups: Array<AudienceListGroupInput>;
  id: Scalars['ID'];
  isDraft?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  searchLink?: Maybe<Scalars['String']>;
};

export type AudienceListUser = {
  __typename?: 'AudienceListUser';
  id: Scalars['ID'];
  zendeskUser: BulkMailZendeskUser;
};

export type AudienceListUserCollection = Collection & {
  __typename?: 'AudienceListUserCollection';
  collection: Array<AudienceListUser>;
  metadata: CollectionMetadata;
};

export type AuditLog = {
  __typename?: 'AuditLog';
  createdAt: Scalars['ISO8601DateTime'];
  createdById: Scalars['String'];
  createdByName: Scalars['String'];
  id: Scalars['ID'];
  logType: Scalars['String'];
  payload: Scalars['JSON'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Attributes for creating an audit log */
export type AuditLogAttributes = {
  /** Zendesk user id of who created the log */
  createdById: Scalars['String'];
  /** Zendesk user name of who created the log */
  createdByName: Scalars['String'];
  /** Type of log */
  logType: Scalars['String'];
  /** Log content */
  payload: Scalars['JSON'];
};

export type AuditLogCollection = {
  __typename?: 'AuditLogCollection';
  collection: Array<AuditLog>;
  metadata: CollectionMetadata;
};

/** Autogenerated input type of AuditLogCreate */
export type AuditLogCreateInput = {
  attributes: AuditLogAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of AuditLogCreate. */
export type AuditLogCreatePayload = {
  __typename?: 'AuditLogCreatePayload';
  auditLog?: Maybe<AuditLog>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Error>>;
};

export type AuditLogFilter = {
  createdAtGteq?: Maybe<Scalars['String']>;
  createdByIdContAny?: Maybe<Array<Scalars['String']>>;
  createdByIdEq?: Maybe<Scalars['String']>;
  createdByNameContAny?: Maybe<Array<Scalars['String']>>;
  createdByNameEq?: Maybe<Scalars['String']>;
  idEq?: Maybe<Scalars['ID']>;
  logTypeEq?: Maybe<Scalars['String']>;
};

/** Warning: Deprecated - RAQ backend migration never finalized */
export type Batch = {
  __typename?: 'Batch';
  createdAt: Scalars['ISO8601DateTime'];
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  legacySlug: Scalars['String'];
  /** Metrics for the zendesk tag used for this batch */
  metrics?: Maybe<TagMetrics>;
  name: Scalars['String'];
  primer: PrimerComparison;
  response?: Maybe<Response>;
  slug: Scalars['String'];
  ticketCount: Scalars['Int'];
  topic?: Maybe<Topic>;
  updatedAt: Scalars['ISO8601DateTime'];
  zendeskFieldOptionId?: Maybe<Scalars['ID']>;
};

export type BatchBulkApiSend = {
  __typename?: 'BatchBulkApiSend';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  scheduledAt: Scalars['ISO8601DateTime'];
  status: Scalars['String'];
};

/** Autogenerated input type of BatchBulkApiSendCreate */
export type BatchBulkApiSendCreateInput = {
  batchId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  scheduledAt: Scalars['ISO8601DateTime'];
};

/** Autogenerated return type of BatchBulkApiSendCreate. */
export type BatchBulkApiSendCreatePayload = {
  __typename?: 'BatchBulkApiSendCreatePayload';
  batch?: Maybe<ZendeskBatch>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of BatchBulkApiSendUpdate */
export type BatchBulkApiSendUpdateInput = {
  batchId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

/** Autogenerated return type of BatchBulkApiSendUpdate. */
export type BatchBulkApiSendUpdatePayload = {
  __typename?: 'BatchBulkApiSendUpdatePayload';
  batch?: Maybe<ZendeskBatch>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Error>>;
};

export type BatchCancelSendResponse = {
  __typename?: 'BatchCancelSendResponse';
  success: Scalars['Boolean'];
};

export type BatchCollection = {
  __typename?: 'BatchCollection';
  collection: Array<Batch>;
  facets: BatchFacet;
  metadata: CollectionMetadata;
};

/** Autogenerated input type of BatchCreate */
export type BatchCreateInput = {
  attributes: ZendeskBatchAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of BatchCreate. */
export type BatchCreatePayload = {
  __typename?: 'BatchCreatePayload';
  batch?: Maybe<ZendeskBatch>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of BatchDelete */
export type BatchDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of BatchDelete. */
export type BatchDeletePayload = {
  __typename?: 'BatchDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Error>>;
  jobId?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of BatchExecute */
export type BatchExecuteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  macroId: Scalars['ID'];
  query: Scalars['String'];
};

/** Autogenerated return type of BatchExecute. */
export type BatchExecutePayload = {
  __typename?: 'BatchExecutePayload';
  batch?: Maybe<ZendeskBatch>;
  batchExecution?: Maybe<BatchExecution>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

export type BatchExecution = {
  __typename?: 'BatchExecution';
  appliedTicketIds?: Maybe<Array<Scalars['String']>>;
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  jobId?: Maybe<Scalars['String']>;
  macroId: Scalars['String'];
  pqTicketIds?: Maybe<Array<Scalars['String']>>;
  runAt: Scalars['ISO8601DateTime'];
  status: Scalars['String'];
  ticketIds?: Maybe<Array<Scalars['String']>>;
  userId: Scalars['String'];
  zendeskQuery: Scalars['String'];
};

/** Autogenerated input type of BatchExecutionCancel */
export type BatchExecutionCancelInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of BatchExecutionCancel. */
export type BatchExecutionCancelPayload = {
  __typename?: 'BatchExecutionCancelPayload';
  batchExecution?: Maybe<BatchExecution>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Error>>;
};

export type BatchExecutionCollection = {
  __typename?: 'BatchExecutionCollection';
  collection: Array<BatchExecution>;
  metadata: CollectionMetadata;
};

export type BatchFacet = {
  __typename?: 'BatchFacet';
  topics: Array<Facet>;
};

export type BatchFilter = {
  idEq?: Maybe<Scalars['ID']>;
  nameCont?: Maybe<Scalars['String']>;
  nameEq?: Maybe<Scalars['String']>;
  slugCont?: Maybe<Scalars['Boolean']>;
  slugEq?: Maybe<Scalars['Boolean']>;
  topicIdBlank?: Maybe<Scalars['Boolean']>;
  topicIdEq?: Maybe<Scalars['ID']>;
  topicNameCont?: Maybe<Scalars['String']>;
  topicSlugCont?: Maybe<Scalars['String']>;
};

export type BatchMetric = {
  __typename?: 'BatchMetric';
  medianAge?: Maybe<Scalars['Int']>;
  oldestDate?: Maybe<Scalars['Int']>;
  openTickets?: Maybe<Scalars['Int']>;
};

/** Autogenerated input type of BatchResetStatus */
export type BatchResetStatusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  subdomain: Scalars['ID'];
};

/** Autogenerated return type of BatchResetStatus. */
export type BatchResetStatusPayload = {
  __typename?: 'BatchResetStatusPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated input type of BatchResponseAttach */
export type BatchResponseAttachInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  responseId: Scalars['ID'];
};

/** Autogenerated return type of BatchResponseAttach. */
export type BatchResponseAttachPayload = {
  __typename?: 'BatchResponseAttachPayload';
  batch?: Maybe<ZendeskBatch>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of BatchResponseUnassign */
export type BatchResponseUnassignInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of BatchResponseUnassign. */
export type BatchResponseUnassignPayload = {
  __typename?: 'BatchResponseUnassignPayload';
  batch?: Maybe<ZendeskBatch>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Error>>;
};

export type BatchScheduleSendInput = {
  batchId: Scalars['ID'];
  batchTag: Scalars['String'];
  macroId: Scalars['ID'];
};

/** Autogenerated input type of BatchUpdate */
export type BatchUpdateInput = {
  attributes: ZendeskBatchAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of BatchUpdate. */
export type BatchUpdatePayload = {
  __typename?: 'BatchUpdatePayload';
  batch?: Maybe<ZendeskBatch>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Error>>;
  jobId?: Maybe<Scalars['String']>;
};

export type BatchesScheduleSendInput = {
  batchesToSend: Array<BatchScheduleSendInput>;
};

export type BatchesScheduleSendResponse = {
  __typename?: 'BatchesScheduleSendResponse';
  failedBatches?: Maybe<Array<Scalars['ID']>>;
  success: Scalars['Boolean'];
};

export type Blob = {
  __typename?: 'Blob';
  byteSize: Scalars['Int'];
  byteSizeHuman: Scalars['String'];
  checksum: Scalars['String'];
  contentType: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  filename: Scalars['String'];
  id: Scalars['ID'];
  key: Scalars['String'];
  name: Scalars['String'];
  serviceName: Scalars['String'];
  /**
   * Temporary download url. Accepts an optional variant input `expiresIn` allowing
   * custom specification of the number of seconds the url should be valid for.
   */
  url: Scalars['String'];
};


export type BlobUrlArgs = {
  expiresIn?: Maybe<Scalars['Int']>;
};

export type BulkJob = {
  __typename?: 'BulkJob';
  argumentsStr: Scalars['String'];
  batchId?: Maybe<Scalars['ID']>;
  createdAt: Scalars['ISO8601DateTime'];
  finishedAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  jobId?: Maybe<Scalars['String']>;
  jobType: Scalars['String'];
  metaStr: Scalars['String'];
  processingTime: Scalars['Int'];
  retryCount: Scalars['Int'];
  scheduleAt: Scalars['ISO8601DateTime'];
  startedAt?: Maybe<Scalars['ISO8601DateTime']>;
  status: BulkJobStatus;
  subdomain: Subdomain;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type BulkJobBatch = {
  __typename?: 'BulkJobBatch';
  done: Scalars['Int'];
  failed: Scalars['Int'];
  id: Scalars['ID'];
  isComplete: Scalars['Boolean'];
  percentComplete: Scalars['Float'];
  total: Scalars['Int'];
};

export type BulkJobCollection = Collection & {
  __typename?: 'BulkJobCollection';
  collection: Array<BulkJob>;
  metadata: CollectionMetadata;
};

export type BulkJobCreateInput = {
  batchId?: Maybe<Scalars['String']>;
  payload: Scalars['String'];
  type: BulkJobType;
};

export type BulkJobCreateResponse = {
  __typename?: 'BulkJobCreateResponse';
  batchId: Scalars['String'];
  success: Scalars['Boolean'];
};

export enum BulkJobStatus {
  Done = 'done',
  Failed = 'failed',
  Processing = 'processing',
  Queued = 'queued',
  Requested = 'requested'
}

export enum BulkJobType {
  RecoverSuspendedTickets = 'RecoverSuspendedTickets',
  UpdateUsers = 'UpdateUsers'
}

export type BulkJobsQueryInput = {
  status?: Maybe<Array<BulkJobStatus>>;
  subdomains?: Maybe<Array<Scalars['String']>>;
};

export type BulkMailZendeskUser = {
  __typename?: 'BulkMailZendeskUser';
  createdAt?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  updatedAt?: Maybe<Scalars['String']>;
  userFields?: Maybe<Scalars['JSON']>;
};

/** Autogenerated input type of BulkUpdateCustomer */
export type BulkUpdateCustomerInput = {
  attributes: CustomerAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  filter?: Maybe<CustomerFilter>;
};

/** Autogenerated return type of BulkUpdateCustomer. */
export type BulkUpdateCustomerPayload = {
  __typename?: 'BulkUpdateCustomerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  customers?: Maybe<Array<Customer>>;
  errors?: Maybe<Array<Error>>;
};

export type Campaign = {
  __typename?: 'Campaign';
  addTicketTags?: Maybe<Array<Scalars['String']>>;
  analytics?: Maybe<CampaignAnalytics>;
  analyticsSyncedAt?: Maybe<Scalars['ISO8601DateTime']>;
  assigneeId?: Maybe<Scalars['Int']>;
  audienceFound?: Maybe<Scalars['Int']>;
  audienceList?: Maybe<AudienceList>;
  audienceListId?: Maybe<Scalars['String']>;
  audienceSearchStartedAt?: Maybe<Scalars['ISO8601DateTime']>;
  audienceSize?: Maybe<Scalars['Int']>;
  batchId: Scalars['ID'];
  /** @deprecated no longer used */
  combineAllFilters?: Maybe<Scalars['Boolean']>;
  counties?: Maybe<Array<Scalars['String']>>;
  createdAt: Scalars['ISO8601DateTime'];
  deliveryMethod: DeliveryMethod;
  excludedUserTags?: Maybe<Array<Scalars['String']>>;
  html?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  idsOnly?: Maybe<Scalars['Boolean']>;
  invalidatedEmailZendeskUserIds?: Maybe<Array<Scalars['String']>>;
  isEmailValidationEnabled?: Maybe<Scalars['Boolean']>;
  isExcludeNewsSubEnabled?: Maybe<Scalars['Boolean']>;
  isOnlyInDistrictVerifiedEnabled?: Maybe<Scalars['Boolean']>;
  isOnlyNewsSubEnabled?: Maybe<Scalars['Boolean']>;
  jobsCompletedCount?: Maybe<Scalars['Int']>;
  jobsFailedCount?: Maybe<Scalars['Int']>;
  jobsTotalCount?: Maybe<Scalars['Int']>;
  lastActionTakenAt?: Maybe<Scalars['ISO8601DateTime']>;
  lastCampaignDate?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  physicalMailJID?: Maybe<Scalars['String']>;
  physicalMailTemplate?: Maybe<Scalars['String']>;
  physicalMailer?: Maybe<PhysicalMailer>;
  /** @deprecated no longer used */
  scheduleId?: Maybe<Scalars['Int']>;
  scheduledAt?: Maybe<Scalars['ISO8601DateTime']>;
  sizeEstimateOnly?: Maybe<Scalars['Boolean']>;
  status: CampaignStatus;
  subdomain: Subdomain;
  subject?: Maybe<Scalars['String']>;
  subscribers?: Maybe<Array<Scalars['String']>>;
  sunshineId?: Maybe<Scalars['String']>;
  /** Survey attached to the campaign */
  survey?: Maybe<Survey>;
  surveyId?: Maybe<Scalars['ID']>;
  tags?: Maybe<Array<Scalars['String']>>;
  topics?: Maybe<Array<Scalars['String']>>;
  totalAcceptedRecipients?: Maybe<Scalars['Int']>;
  totalRejectedRecipients?: Maybe<Scalars['Int']>;
  totalUnsubscribes?: Maybe<Scalars['Int']>;
  unsubscribes?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['ISO8601DateTime'];
  userTags?: Maybe<Array<Scalars['String']>>;
  zipCodes?: Maybe<Array<Scalars['String']>>;
};

export type CampaignAnalytics = {
  __typename?: 'CampaignAnalytics';
  bounce?: Maybe<Scalars['Int']>;
  deliveries?: Maybe<Scalars['Int']>;
  injected?: Maybe<Scalars['Int']>;
  invalidatedByCansend?: Maybe<Scalars['Int']>;
  linkClick?: Maybe<Scalars['Int']>;
  open?: Maybe<Scalars['Int']>;
  subscribes?: Maybe<Scalars['Int']>;
  unsubscribes?: Maybe<Scalars['Int']>;
};

export type CampaignCollection = Collection & {
  __typename?: 'CampaignCollection';
  collection: Array<Campaign>;
  metadata: CollectionMetadata;
};

export type CampaignCreateInput = {
  addTicketTags?: Maybe<Array<Scalars['String']>>;
  audienceListId?: Maybe<Scalars['ID']>;
  audienceSize?: Maybe<Scalars['Int']>;
  deliveryMethod?: Maybe<DeliveryMethod>;
  html?: Maybe<Scalars['String']>;
  isEmailValidationEnabled?: Maybe<Scalars['Boolean']>;
  isExcludeNewsSubEnabled?: Maybe<Scalars['Boolean']>;
  isOnlyInDistrictVerifiedEnabled?: Maybe<Scalars['Boolean']>;
  isOnlyNewsSubEnabled?: Maybe<Scalars['Boolean']>;
  lastCampaignDate?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  physicalMailTemplate?: Maybe<Scalars['String']>;
  scheduledAt?: Maybe<Scalars['ISO8601DateTime']>;
  status?: Maybe<CampaignStatus>;
  subject?: Maybe<Scalars['String']>;
};

export type CampaignDuplicateInput = {
  campaignId: Scalars['ID'];
  duplicateAudience?: Maybe<Scalars['Boolean']>;
  subject: Scalars['String'];
};

export type CampaignInput = {
  addTicketTags?: Maybe<Array<Scalars['String']>>;
  audienceListId?: Maybe<Scalars['ID']>;
  audienceSize?: Maybe<Scalars['Int']>;
  deliveryMethod?: Maybe<DeliveryMethod>;
  html?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isEmailValidationEnabled?: Maybe<Scalars['Boolean']>;
  isExcludeNewsSubEnabled?: Maybe<Scalars['Boolean']>;
  isOnlyInDistrictVerifiedEnabled?: Maybe<Scalars['Boolean']>;
  isOnlyNewsSubEnabled?: Maybe<Scalars['Boolean']>;
  lastCampaignDate?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  physicalMailTemplate?: Maybe<Scalars['String']>;
  scheduledAt?: Maybe<Scalars['ISO8601DateTime']>;
  skipSurveyCheck?: Maybe<Scalars['Boolean']>;
  status?: Maybe<CampaignStatus>;
  subject?: Maybe<Scalars['String']>;
};

export type CampaignNewsletterSubscriberRemovedInput = {
  campaignId: Scalars['ID'];
};

export type CampaignNewsletterSubscriberRemovedResponse = {
  __typename?: 'CampaignNewsletterSubscriberRemovedResponse';
  unsubscribes: Scalars['Int'];
};

/** Autogenerated input type of CampaignNotifyRequester */
export type CampaignNotifyRequesterInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Specify a specific comment to send, if not specified will default to the latest public comment */
  commentId?: Maybe<Scalars['ID']>;
  /** Ticket with a comment to send */
  ticketId: Scalars['ID'];
};

/** Autogenerated return type of CampaignNotifyRequester. */
export type CampaignNotifyRequesterPayload = {
  __typename?: 'CampaignNotifyRequesterPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  jobId: Scalars['String'];
};

export enum CampaignStatus {
  Cancelled = 'cancelled',
  Done = 'done',
  Draft = 'draft',
  Failed = 'failed',
  Found = 'found',
  Queued = 'queued',
  Scheduled = 'scheduled',
  Searching = 'searching',
  Sending = 'sending'
}

export type CampaignSurveyInput = {
  id: Scalars['ID'];
  surveyId?: Maybe<Scalars['ID']>;
};

export type CampaignSurveyNewsletterSubscriberAddedInput = {
  surveyId: Scalars['ID'];
  zendeskUserId?: Maybe<Scalars['String']>;
};

export type CampaignSurveyNewsletterSubscriberAddedResponse = {
  __typename?: 'CampaignSurveyNewsletterSubscriberAddedResponse';
  subscribes: Scalars['Int'];
};

export type CampaignTestSendInput = {
  campaignId: Scalars['ID'];
  recipientEmail: Scalars['String'];
};

export type CampaignUpdateSurveyInput = {
  id?: Maybe<Scalars['ID']>;
  questions: Array<CampaignUpdateSurveyQuestion>;
  teaser?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type CampaignUpdateSurveyQuestion = {
  id?: Maybe<Scalars['ID']>;
  options?: Maybe<Array<CampaignUpdateSurveyQuestionOption>>;
  query?: Maybe<Scalars['String']>;
};

export type CampaignUpdateSurveyQuestionOption = {
  tag?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

export type Cohort = {
  __typename?: 'Cohort';
  activeIPPool?: Maybe<Scalars['String']>;
  bounceDomain?: Maybe<Scalars['String']>;
  bulkmailEmailDomain?: Maybe<Scalars['String']>;
  bulkmailIPPool?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  inactiveIPPool?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  optedInIPPool?: Maybe<Scalars['String']>;
};

export type CohortCreateInput = {
  activeIPPool?: Maybe<Scalars['String']>;
  bounceDomain?: Maybe<Scalars['String']>;
  bulkmailEmailDomain?: Maybe<Scalars['String']>;
  bulkmailIPPool?: Maybe<Scalars['String']>;
  inactiveIPPool?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  optedInIPPool?: Maybe<Scalars['String']>;
};

export type CohortNormalizeInput = {
  name: Scalars['String'];
  startDate?: Maybe<Scalars['ISO8601DateTime']>;
};

export type CohortUpdateInput = {
  activeIPPool?: Maybe<Scalars['String']>;
  bounceDomain?: Maybe<Scalars['String']>;
  bulkmailEmailDomain?: Maybe<Scalars['String']>;
  bulkmailIPPool?: Maybe<Scalars['String']>;
  inactiveIPPool?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  optedInIPPool?: Maybe<Scalars['String']>;
};

export type Collection = {
  metadata: CollectionMetadata;
};

/** Standard input for a paginated collection query */
export type CollectionInput = {
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
};

export type CollectionMetadata = {
  __typename?: 'CollectionMetadata';
  currentPage: Scalars['Int'];
  limitValue: Scalars['Int'];
  totalCount: Scalars['Int'];
  totalPages: Scalars['Int'];
};

/** Warning: Deprecated - RAQ backend migration never finalized */
export type Comment = {
  __typename?: 'Comment';
  actor?: Maybe<User>;
  comment: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  /** Unread by current user */
  unread: Scalars['Boolean'];
  updatedAt: Scalars['ISO8601DateTime'];
  whodunnit?: Maybe<Scalars['String']>;
};

export type ConstituentTag = {
  __typename?: 'ConstituentTag';
  constituentTagCategory: ConstituentTagCategory;
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
  zendeskUserId?: Maybe<Scalars['String']>;
};

/** Attributes for creating a constituent tag */
export type ConstituentTagAttributes = {
  /** Zendesk category ID to be associated */
  constituentTagCategoryId?: Maybe<Scalars['ID']>;
  /** Name for the constituent tag */
  name: Scalars['String'];
  /** Zendesk user ID to be associated */
  zendeskUserId?: Maybe<Scalars['String']>;
};

export type ConstituentTagCategory = {
  __typename?: 'ConstituentTagCategory';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
  zendeskUserId?: Maybe<Scalars['String']>;
};

/** Attributes for creating or updating a constituent tag category */
export type ConstituentTagCategoryAttributes = {
  /** Name for the constituent tag */
  name?: Maybe<Scalars['String']>;
  /** Zendesk user ID to be associated */
  zendeskUserId?: Maybe<Scalars['ID']>;
};

/** Autogenerated input type of ConstituentTagCategoryCreate */
export type ConstituentTagCategoryCreateInput = {
  attributes: ConstituentTagCategoryAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of ConstituentTagCategoryCreate. */
export type ConstituentTagCategoryCreatePayload = {
  __typename?: 'ConstituentTagCategoryCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  constituentTagCategory?: Maybe<ConstituentTagCategory>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of ConstituentTagCategoryDelete */
export type ConstituentTagCategoryDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of ConstituentTagCategoryDelete. */
export type ConstituentTagCategoryDeletePayload = {
  __typename?: 'ConstituentTagCategoryDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  constituentTagCategory?: Maybe<ConstituentTagCategory>;
  errors?: Maybe<Array<Error>>;
  numDeletedTags?: Maybe<Scalars['Int']>;
};

export type ConstituentTagCategoryFilter = {
  idEq?: Maybe<Scalars['ID']>;
  nameCont?: Maybe<Scalars['String']>;
  nameEq?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of ConstituentTagCategoryUpdate */
export type ConstituentTagCategoryUpdateInput = {
  attributes: ConstituentTagCategoryAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of ConstituentTagCategoryUpdate. */
export type ConstituentTagCategoryUpdatePayload = {
  __typename?: 'ConstituentTagCategoryUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  constituentTagCategory?: Maybe<ConstituentTagCategory>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of ConstituentTagCreate */
export type ConstituentTagCreateInput = {
  attributes: ConstituentTagAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of ConstituentTagCreate. */
export type ConstituentTagCreatePayload = {
  __typename?: 'ConstituentTagCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  constituentTag?: Maybe<ConstituentTag>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of ConstituentTagDelete */
export type ConstituentTagDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of ConstituentTagDelete. */
export type ConstituentTagDeletePayload = {
  __typename?: 'ConstituentTagDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  constituentTag?: Maybe<ConstituentTag>;
  errors?: Maybe<Array<Error>>;
};

export type ConstituentTagFilter = {
  constituentTagCategoryIdEq?: Maybe<Scalars['ID']>;
  constituentTagCategoryNameCont?: Maybe<Scalars['String']>;
  idEq?: Maybe<Scalars['ID']>;
  nameCont?: Maybe<Scalars['String']>;
  nameEq?: Maybe<Scalars['String']>;
  slugCont?: Maybe<Scalars['Boolean']>;
  slugEq?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated input type of ConstituentTagUpdate */
export type ConstituentTagUpdateInput = {
  attributes: ConstituentTagAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of ConstituentTagUpdate. */
export type ConstituentTagUpdatePayload = {
  __typename?: 'ConstituentTagUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  constituentTag?: Maybe<ConstituentTag>;
  errors?: Maybe<Array<Error>>;
};

/** Get the count of constituents reached broken down by subdomain */
export type ConstituentsReachedBySubdomain = {
  __typename?: 'ConstituentsReachedBySubdomain';
  constituentsCount?: Maybe<Scalars['Int']>;
  subdomain?: Maybe<Scalars['String']>;
};

/** Get the count of constituents reached through proactive and reactive emails. */
export type ConstituentsReachedWidget = {
  __typename?: 'ConstituentsReachedWidget';
  /** count of constituents reached through reactive emails aggregated at a given cohort level. */
  totalConstituents?: Maybe<Scalars['Int']>;
  /** count of constituents reached through reactive emails broken down by subdomain. */
  totalConstituentsBySubdomain?: Maybe<Array<ConstituentsReachedBySubdomain>>;
};

export type Context = {
  __typename?: 'Context';
  currentAdmin?: Maybe<Admin>;
  customer?: Maybe<Scalars['String']>;
  rawHeaders?: Maybe<Scalars['JSON']>;
  user?: Maybe<User>;
};

export type CreateSeDashboardInput = {
  cohort: Scalars['String'];
  dashboardUserEmails: Array<Scalars['String']>;
  name: Scalars['String'];
};

export type CreateSideConversationInput = {
  existingAttachments?: Maybe<Array<OldAttachmentInput>>;
  message: Scalars['String'];
  newAttachments?: Maybe<Array<NewAttachmentInput>>;
  parentTicketId: Scalars['String'];
  subject: Scalars['String'];
  to: Array<SideConversationParticipantInput>;
};

/** Standarized response to a cron action */
export type CronJob = {
  __typename?: 'CronJob';
  success: Scalars['Boolean'];
};

export type CurrentEditor = {
  __typename?: 'CurrentEditor';
  appName: AppName;
  createdAt: Scalars['ISO8601DateTime'];
  currentEditorId: Scalars['String'];
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  objectCurrentlyEditedId: Scalars['String'];
  subdomain: Subdomain;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type CurrentEditorResponse = {
  __typename?: 'CurrentEditorResponse';
  currentEditor?: Maybe<CurrentEditor>;
};

export type Customer = {
  __typename?: 'Customer';
  attachments: CustomerAttachments;
  /** Zendesk JWT shared secret */
  authenticationToken?: Maybe<Scalars['String']>;
  batchTicketField?: Maybe<ZendeskObject>;
  churnDate?: Maybe<Scalars['ISO8601Date']>;
  createdAt: Scalars['ISO8601DateTime'];
  csmEmail?: Maybe<Scalars['String']>;
  csmName?: Maybe<Scalars['String']>;
  customTags?: Maybe<Array<Scalars['String']>>;
  customerHealthChecks?: Maybe<Array<CustomerHealthCheck>>;
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
  district?: Maybe<Scalars['String']>;
  emailTemplate?: Maybe<EmailTemplate>;
  environment?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  l2Enabled?: Maybe<Scalars['Boolean']>;
  /** Child account ID provided by L2 V2, ex: "1A34" */
  l2V2ChildAccountId?: Maybe<Scalars['String']>;
  launchDate?: Maybe<Scalars['ISO8601Date']>;
  legacyCmsProvider?: Maybe<Scalars['String']>;
  /** Overview of topics/tags/responses/batches validations */
  modelValidations?: Maybe<Scalars['JSON']>;
  /** Okta active directory for each office */
  oktaActiveDirectory?: Maybe<Scalars['String']>;
  party?: Maybe<Scalars['String']>;
  primerConfig?: Maybe<PrimerConfig>;
  profilePictureUrl?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
  sparkpostSubaccount?: Maybe<Scalars['Int']>;
  subdomain: Scalars['String'];
  supportOrganization?: Maybe<SupportOrganization>;
  tagsTicketField?: Maybe<ZendeskObject>;
  ticketConsoleFormNames?: Maybe<Array<Scalars['String']>>;
  topicTicketField?: Maybe<ZendeskObject>;
  updatedAt: Scalars['ISO8601DateTime'];
  website?: Maybe<Scalars['String']>;
  /** Zendesk token, ex: "1234,admin@indigov.com" */
  zendeskApiToken?: Maybe<Scalars['String']>;
  zendeskUsers: UserCollection;
};

export type CustomerAttachments = {
  __typename?: 'CustomerAttachments';
  bulkMailHeader?: Maybe<Blob>;
  profilePicture?: Maybe<Blob>;
  signature?: Maybe<Blob>;
  surveyHeader?: Maybe<Blob>;
};

/** Attributes for creating or updating a customer */
export type CustomerAttributes = {
  /** Zendesk JWT shared secret */
  authenticationToken?: Maybe<Scalars['String']>;
  bulkmailHeader?: Maybe<Scalars['Upload']>;
  churnDate?: Maybe<Scalars['ISO8601Date']>;
  csmEmail?: Maybe<Scalars['String']>;
  customTags?: Maybe<Array<Scalars['String']>>;
  customTagsText?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['String']>;
  environment?: Maybe<Scalars['String']>;
  /** Full name for the customer */
  fullName?: Maybe<Scalars['String']>;
  /** Child account ID provided by L2 V2, ex: "indiconglincolnabe" */
  l2V2ChildAccountId?: Maybe<Scalars['String']>;
  launchDate?: Maybe<Scalars['ISO8601Date']>;
  legacyCmsProvider?: Maybe<Scalars['String']>;
  oktaActiveDirectory?: Maybe<Scalars['String']>;
  party?: Maybe<Scalars['String']>;
  /** Primer configuration */
  primerConfig?: Maybe<PrimerConfigAttributes>;
  profilePicture?: Maybe<Scalars['Upload']>;
  scope?: Maybe<Scalars['String']>;
  signature?: Maybe<Scalars['Upload']>;
  surveyHeader?: Maybe<Scalars['Upload']>;
  ticketConsoleFormNames?: Maybe<Array<Scalars['String']>>;
  website?: Maybe<Scalars['String']>;
  /** Zendesk token, ex: "1234,admin@indigov.com" */
  zendeskApiToken?: Maybe<Scalars['String']>;
};

export type CustomerCollection = {
  __typename?: 'CustomerCollection';
  collection: Array<Customer>;
  facets: CustomerFacet;
  metadata: CollectionMetadata;
};

/** Autogenerated input type of CustomerCreate */
export type CustomerCreateInput = {
  attributes: CustomerAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  subdomain: Scalars['ID'];
};

/** Autogenerated return type of CustomerCreate. */
export type CustomerCreatePayload = {
  __typename?: 'CustomerCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  customer?: Maybe<Customer>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of CustomerDelete */
export type CustomerDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  subdomain: Scalars['ID'];
};

/** Autogenerated return type of CustomerDelete. */
export type CustomerDeletePayload = {
  __typename?: 'CustomerDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  customer?: Maybe<Customer>;
  errors?: Maybe<Array<Error>>;
};

export type CustomerFacet = {
  __typename?: 'CustomerFacet';
  cohorts: Array<Facet>;
  csms: Array<Facet>;
  customTags: Array<Facet>;
  environments: Array<Facet>;
  party: Array<Facet>;
};

export type CustomerFilter = {
  csmEmailCont?: Maybe<Scalars['String']>;
  csmEmailEq?: Maybe<Scalars['String']>;
  customTagsTextCont?: Maybe<Scalars['String']>;
  environmentEq?: Maybe<Scalars['String']>;
  fullNameOrSubdomainCont?: Maybe<Scalars['String']>;
  idEq?: Maybe<Scalars['ID']>;
  partyEq?: Maybe<Scalars['String']>;
  scopeEq?: Maybe<Scalars['String']>;
  subdomainCont?: Maybe<Scalars['String']>;
  subdomainEq?: Maybe<Scalars['String']>;
};

export type CustomerHealthCheck = {
  __typename?: 'CustomerHealthCheck';
  createdAt: Scalars['ISO8601DateTime'];
  metadata?: Maybe<Scalars['JSON']>;
  result: ResultEnum;
  subtitle: Scalars['String'];
  title: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Autogenerated input type of CustomerRename */
export type CustomerRenameInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  subdomain: Scalars['ID'];
};

/** Autogenerated return type of CustomerRename. */
export type CustomerRenamePayload = {
  __typename?: 'CustomerRenamePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  customer?: Maybe<Customer>;
};

/** Autogenerated input type of CustomerSetupL2Fields */
export type CustomerSetupL2FieldsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  subdomain: Scalars['ID'];
};

/** Autogenerated return type of CustomerSetupL2Fields. */
export type CustomerSetupL2FieldsPayload = {
  __typename?: 'CustomerSetupL2FieldsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated input type of CustomerSoftDelete */
export type CustomerSoftDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  subdomain: Scalars['ID'];
};

/** Autogenerated return type of CustomerSoftDelete. */
export type CustomerSoftDeletePayload = {
  __typename?: 'CustomerSoftDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  customer?: Maybe<Customer>;
};

/** Attributes for creating or updating a customer support organization */
export type CustomerSupportOrganizationAttributes = {
  /** Contact frequency from Casework Team */
  caseworkTeamContactFrequency?: Maybe<Scalars['String']>;
  /** Contact frequency from Communications Director */
  commsDirectorContactFrequency?: Maybe<Scalars['String']>;
  /** How happy are the DC-based staff with Indigov? */
  dcOfficeSentiment?: Maybe<Scalars['String']>;
  /** How happy are the district-based staff with Indigov? */
  districtOfficeSentimentScore?: Maybe<Scalars['String']>;
  /** List of relationships */
  keyRelationshipsPersonnelNotes?: Maybe<Scalars['String']>;
  /** Contact frequency from LC/LA */
  lcLaContactFrequency?: Maybe<Scalars['String']>;
  /** Top 3 feature requests, bugs, or product issues */
  productFriction?: Maybe<Scalars['String']>;
  /** Zendesk url */
  productionUrl?: Maybe<Scalars['String']>;
  /** Unique automations, triggers, settings, etc */
  uniqueProductConfigurationsNotes?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of CustomerSupportOrganizationUpdate */
export type CustomerSupportOrganizationUpdateInput = {
  attributes: CustomerSupportOrganizationAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  subdomain: Scalars['ID'];
};

/** Autogenerated return type of CustomerSupportOrganizationUpdate. */
export type CustomerSupportOrganizationUpdatePayload = {
  __typename?: 'CustomerSupportOrganizationUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Error>>;
  supportOrganization?: Maybe<SupportOrganization>;
};

/** Autogenerated input type of CustomerSyncHealthJob */
export type CustomerSyncHealthJobInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  subdomain: Scalars['ID'];
};

/** Autogenerated return type of CustomerSyncHealthJob. */
export type CustomerSyncHealthJobPayload = {
  __typename?: 'CustomerSyncHealthJobPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  jobId: Scalars['ID'];
};

/** Autogenerated input type of CustomerSyncJob */
export type CustomerSyncJobInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  subdomain: Scalars['ID'];
  type: Scalars['String'];
};

/** Autogenerated return type of CustomerSyncJob. */
export type CustomerSyncJobPayload = {
  __typename?: 'CustomerSyncJobPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Error>>;
  jobId?: Maybe<Scalars['ID']>;
};

/** Autogenerated input type of CustomerSyncMetricsJob */
export type CustomerSyncMetricsJobInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['ISO8601Date']>;
  endDuration?: Maybe<Scalars['ISO8601Duration']>;
  startDate?: Maybe<Scalars['ISO8601Date']>;
  startDuration?: Maybe<Scalars['ISO8601Duration']>;
  subdomain: Scalars['ID'];
};

/** Autogenerated return type of CustomerSyncMetricsJob. */
export type CustomerSyncMetricsJobPayload = {
  __typename?: 'CustomerSyncMetricsJobPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  jobId: Scalars['ID'];
};

/** Autogenerated input type of CustomerSyncResponsesJob */
export type CustomerSyncResponsesJobInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  subdomain: Scalars['ID'];
};

/** Autogenerated return type of CustomerSyncResponsesJob. */
export type CustomerSyncResponsesJobPayload = {
  __typename?: 'CustomerSyncResponsesJobPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  jobId: Scalars['ID'];
};

/** Autogenerated input type of CustomerSyncSunshineObjectsJob */
export type CustomerSyncSunshineObjectsJobInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  subdomain: Scalars['ID'];
};

/** Autogenerated return type of CustomerSyncSunshineObjectsJob. */
export type CustomerSyncSunshineObjectsJobPayload = {
  __typename?: 'CustomerSyncSunshineObjectsJobPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  jobId: Scalars['ID'];
};

/** Autogenerated input type of CustomerSyncZendeskObjectsJob */
export type CustomerSyncZendeskObjectsJobInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  subdomain: Scalars['ID'];
};

/** Autogenerated return type of CustomerSyncZendeskObjectsJob. */
export type CustomerSyncZendeskObjectsJobPayload = {
  __typename?: 'CustomerSyncZendeskObjectsJobPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  jobId: Scalars['ID'];
};

/** Autogenerated input type of CustomerUpdate */
export type CustomerUpdateInput = {
  attributes: CustomerAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  subdomain: Scalars['ID'];
};

/** Autogenerated return type of CustomerUpdate. */
export type CustomerUpdatePayload = {
  __typename?: 'CustomerUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  customer?: Maybe<Customer>;
  errors?: Maybe<Array<Error>>;
};

/** A standardized response for a successful delete */
export type DeleteResponse = {
  __typename?: 'DeleteResponse';
  id: Scalars['ID'];
  isDeleted: Scalars['Boolean'];
};

export enum DeliveryMethod {
  Digital = 'digital',
  Physical = 'physical'
}

/** Digital template for word doc response */
export type DigitalTemplate = {
  __typename?: 'DigitalTemplate';
  /** Envelop templates */
  envelopes: Array<S3Object>;
  /** Letter templates */
  letters: Array<S3Object>;
};

/** File info for a template */
export type DigitalTemplateFileInfo = {
  __typename?: 'DigitalTemplateFileInfo';
  /** Base64 word doc content */
  content: Scalars['String'];
  /** Name of the template file */
  filename: Scalars['String'];
};

/** Attributes for previewing a digital template */
export type DigitalTemplatePreviewAttributes = {
  /** File name of template */
  fileName: Scalars['String'];
  /** PrintableComment ID */
  printableCommentId: Scalars['ID'];
  /** Type of template */
  type: Scalars['String'];
  /** Zendesk::User ID */
  userId: Scalars['ID'];
};

/** Autogenerated input type of DigitalTemplatePreview */
export type DigitalTemplatePreviewInput = {
  attributes: DigitalTemplatePreviewAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of DigitalTemplatePreview. */
export type DigitalTemplatePreviewPayload = {
  __typename?: 'DigitalTemplatePreviewPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['String']>;
};

/** Attributes for printing a digital template */
export type DigitalTemplatePrintAttributes = {
  /** List of objects with printable comment id and user id */
  printableCommentIdUserIdPairs: Array<PrintableCommentIdAndUserId>;
  sort?: Maybe<DigitalTemplatePrintSort>;
  templates: Array<Template>;
};

/** Autogenerated input type of DigitalTemplatePrint */
export type DigitalTemplatePrintInput = {
  attributes: DigitalTemplatePrintAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of DigitalTemplatePrint. */
export type DigitalTemplatePrintPayload = {
  __typename?: 'DigitalTemplatePrintPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  files?: Maybe<Array<DigitalTemplateFileInfo>>;
};

export type DigitalTemplatePrintSort = {
  field: DigitalTemplatePrintSortFieldEnum;
  order: SortOrderEnum;
};

export enum DigitalTemplatePrintSortFieldEnum {
  CreatedAt = 'created_at',
  HomeAddressZipCode = 'home_address_zip_code',
  LastName = 'last_name'
}

export type DirectMailHandleResponse = {
  __typename?: 'DirectMailHandleResponse';
  success: Scalars['Boolean'];
};

export type DirectMailInput = {
  notMonitoredMacroId: Scalars['String'];
  ticketId: Scalars['String'];
};

/** Direct file upload parameters */
export type DirectUpload = {
  __typename?: 'DirectUpload';
  /** Created blob record ID */
  blobId: Scalars['ID'];
  /** HTTP request headers (JSON-encoded) */
  headers: Scalars['String'];
  /** Created blob record signed ID */
  signedBlobId: Scalars['ID'];
  /** Upload URL */
  url: Scalars['String'];
};

/** Attributes for creating a direct upload */
export type DirectUploadAttributes = {
  /** File size (bytes) */
  byteSize: Scalars['Int'];
  /** MD5 file checksum as base64 */
  checksum: Scalars['String'];
  /** File content type */
  contentType: Scalars['String'];
  /** Original file name */
  filename: Scalars['String'];
};

export type DiscoveryExport = {
  __typename?: 'DiscoveryExport';
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  downloadUrl?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['ISO8601Date']>;
  excludeTerms?: Maybe<Array<Scalars['String']>>;
  exportBatchId?: Maybe<Scalars['ID']>;
  exportedAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  includeEmails?: Maybe<Array<Scalars['String']>>;
  includeTerms?: Maybe<Array<Scalars['String']>>;
  searchBatchId?: Maybe<Scalars['ID']>;
  searchedAt?: Maybe<Scalars['ISO8601DateTime']>;
  searches: Scalars['JSON'];
  startDate?: Maybe<Scalars['ISO8601Date']>;
  subdomains?: Maybe<Array<Scalars['String']>>;
  tickets?: Maybe<Scalars['JSON']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type DiscoveryExportAttributes = {
  endDate: Scalars['ISO8601Date'];
  excludeTerms: Array<Scalars['String']>;
  includeEmails: Array<Scalars['String']>;
  includeTerms: Array<Scalars['String']>;
  startDate: Scalars['ISO8601Date'];
  subdomains: Array<Scalars['String']>;
};

export type DiscoveryExportCollection = {
  __typename?: 'DiscoveryExportCollection';
  collection: Array<DiscoveryExport>;
  metadata: CollectionMetadata;
};

/** Autogenerated input type of DiscoveryExportCombine */
export type DiscoveryExportCombineInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of DiscoveryExportCombine. */
export type DiscoveryExportCombinePayload = {
  __typename?: 'DiscoveryExportCombinePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  discoveryExport?: Maybe<DiscoveryExport>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of DiscoveryExportCreate */
export type DiscoveryExportCreateInput = {
  attributes: DiscoveryExportAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of DiscoveryExportCreate. */
export type DiscoveryExportCreatePayload = {
  __typename?: 'DiscoveryExportCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  discoveryExport?: Maybe<DiscoveryExport>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of DiscoveryExportExecute */
export type DiscoveryExportExecuteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of DiscoveryExportExecute. */
export type DiscoveryExportExecutePayload = {
  __typename?: 'DiscoveryExportExecutePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  discoveryExport?: Maybe<DiscoveryExport>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of DiscoveryExportUpdate */
export type DiscoveryExportUpdateInput = {
  attributes: DiscoveryExportAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of DiscoveryExportUpdate. */
export type DiscoveryExportUpdatePayload = {
  __typename?: 'DiscoveryExportUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  discoveryExport?: Maybe<DiscoveryExport>;
  errors?: Maybe<Array<Error>>;
};

export enum DistrictStatus {
  DistrictUnknown = 'districtUnknown',
  InDistrict = 'inDistrict',
  OutOfDistrict = 'outOfDistrict'
}

export enum DistrictStatusEnum {
  InDistrict = 'inDistrict',
  OutOfDistrict = 'outOfDistrict',
  Unknown = 'unknown'
}

export type EmailTemplate = {
  __typename?: 'EmailTemplate';
  /** Handlebars template used by sparkpost to render outgoing mail */
  body?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Attributes for creating an email template */
export type EmailTemplateAttributes = {
  body: Scalars['String'];
};

/** Autogenerated input type of EmailTemplateCreate */
export type EmailTemplateCreateInput = {
  attributes: EmailTemplateAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of EmailTemplateCreate. */
export type EmailTemplateCreatePayload = {
  __typename?: 'EmailTemplateCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  emailTemplate?: Maybe<EmailTemplate>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of EmailTemplateUpdate */
export type EmailTemplateUpdateInput = {
  attributes: EmailTemplateAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of EmailTemplateUpdate. */
export type EmailTemplateUpdatePayload = {
  __typename?: 'EmailTemplateUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  emailTemplate?: Maybe<EmailTemplate>;
  errors?: Maybe<Array<Error>>;
};

/** A user-readable error */
export type Error = {
  __typename?: 'Error';
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type ExtractTextFromAttachmentInput = {
  ticketId: Scalars['ID'];
  version?: Maybe<Scalars['Int']>;
};

export type ExtractTextFromAttachmentResponse = {
  __typename?: 'ExtractTextFromAttachmentResponse';
  success: Scalars['Boolean'];
};

export type Facet = {
  __typename?: 'Facet';
  id?: Maybe<Scalars['ID']>;
  key?: Maybe<Scalars['String']>;
  value: Scalars['Int'];
};

export type FederatedReport = {
  __typename?: 'FederatedReport';
  createdAt: Scalars['ISO8601DateTime'];
  federatedReportUsers: Array<FederatedReportUser>;
  id: Scalars['ID'];
  subdomains: Array<Subdomain>;
  title: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

export type FederatedReportBulkMailCampaign = {
  __typename?: 'FederatedReportBulkMailCampaign';
  deliveryMethod: DeliveryMethod;
  subdomainName: Scalars['String'];
  totalAcceptedRecipients: Scalars['Int'];
  unsubscribes?: Maybe<Scalars['Int']>;
};

export type FederatedReportCollection = Collection & {
  __typename?: 'FederatedReportCollection';
  collection: Array<FederatedReport>;
  metadata: CollectionMetadata;
};

export type FederatedReportCreateInput = {
  federatedReportUsers: Array<Scalars['String']>;
  subdomains: Array<Scalars['String']>;
  title: Scalars['String'];
};

export type FederatedReportUniqueConstituentsReached = {
  __typename?: 'FederatedReportUniqueConstituentsReached';
  totalConstituentsReached?: Maybe<Scalars['Int']>;
  totalConstituentsReachedBySubdomain?: Maybe<Array<Maybe<FederatedReportingConstituentsReachedBySubdomain>>>;
};

export type FederatedReportUpdateInput = {
  federatedReportUsers?: Maybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  subdomains?: Maybe<Array<Scalars['String']>>;
  title?: Maybe<Scalars['String']>;
};

export type FederatedReportUser = {
  __typename?: 'FederatedReportUser';
  createdAt: Scalars['ISO8601DateTime'];
  email: Scalars['String'];
  id: Scalars['ID'];
  syncedToOkta?: Maybe<Scalars['ISO8601DateTime']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Input attributes to get data for powering federated report widget */
export type FederatedReportWidgetInput = {
  endDate: Scalars['ISO8601DateTime'];
  startDate: Scalars['ISO8601DateTime'];
  subdomains: Array<Scalars['String']>;
};

export type FederatedReportingBulkMailCampaigns = {
  __typename?: 'FederatedReportingBulkMailCampaigns';
  campaigns?: Maybe<Array<Maybe<FederatedReportBulkMailCampaign>>>;
};

export type FederatedReportingConstituentsReachedBySubdomain = {
  __typename?: 'FederatedReportingConstituentsReachedBySubdomain';
  constituents?: Maybe<Scalars['Int']>;
  subdomain: Scalars['String'];
};

export type GetCurrentEditorInput = {
  objectCurrentlyEditedId: Scalars['String'];
  subdomain: Scalars['String'];
};

export type GraphQlResponseError = {
  __typename?: 'GraphQLResponseError';
  message: Scalars['String'];
};

/** Autogenerated input type of HelpCenterGenerateRedirect */
export type HelpCenterGenerateRedirectInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  returnTo?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['ID']>;
};

/** Autogenerated return type of HelpCenterGenerateRedirect. */
export type HelpCenterGenerateRedirectPayload = {
  __typename?: 'HelpCenterGenerateRedirectPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  redirectUrl: Scalars['String'];
};

export type IpPoolMetrics = {
  __typename?: 'IpPoolMetrics';
  count_accepted?: Maybe<Scalars['Int']>;
  count_admin_bounce?: Maybe<Scalars['Int']>;
  count_block_bounce?: Maybe<Scalars['Int']>;
  count_bounce?: Maybe<Scalars['Int']>;
  count_clicked?: Maybe<Scalars['Int']>;
  count_delayed?: Maybe<Scalars['Int']>;
  count_delayed_first?: Maybe<Scalars['Int']>;
  count_delivered?: Maybe<Scalars['Int']>;
  count_delivered_first?: Maybe<Scalars['Int']>;
  count_delivered_subsequent?: Maybe<Scalars['Int']>;
  count_generation_failed?: Maybe<Scalars['Int']>;
  count_generation_rejection?: Maybe<Scalars['Int']>;
  count_hard_bounce?: Maybe<Scalars['Int']>;
  count_inband_bounce?: Maybe<Scalars['Int']>;
  count_inbox_panel?: Maybe<Scalars['Int']>;
  count_inbox_seed?: Maybe<Scalars['Int']>;
  count_inbox_seed_private?: Maybe<Scalars['Int']>;
  count_inbox_seed_virtual?: Maybe<Scalars['Int']>;
  count_injected?: Maybe<Scalars['Int']>;
  count_moved_to_inbox?: Maybe<Scalars['Int']>;
  count_moved_to_spam?: Maybe<Scalars['Int']>;
  count_nonprefetched_rendered?: Maybe<Scalars['Int']>;
  count_nonprefetched_unique_confirmed_opened?: Maybe<Scalars['Int']>;
  count_nonprefetched_unique_rendered?: Maybe<Scalars['Int']>;
  count_outofband_bounce?: Maybe<Scalars['Int']>;
  count_policy_rejection?: Maybe<Scalars['Int']>;
  count_rejected?: Maybe<Scalars['Int']>;
  count_rendered?: Maybe<Scalars['Int']>;
  count_sent?: Maybe<Scalars['Int']>;
  count_soft_bounce?: Maybe<Scalars['Int']>;
  count_spam_complaint?: Maybe<Scalars['Int']>;
  count_spam_panel?: Maybe<Scalars['Int']>;
  count_spam_seed?: Maybe<Scalars['Int']>;
  count_spam_seed_private?: Maybe<Scalars['Int']>;
  count_spam_seed_virtual?: Maybe<Scalars['Int']>;
  count_targeted?: Maybe<Scalars['Int']>;
  count_undetermined_bounce?: Maybe<Scalars['Int']>;
  count_unique_clicked?: Maybe<Scalars['Int']>;
  count_unique_confirmed_opened?: Maybe<Scalars['Int']>;
  count_unique_rendered?: Maybe<Scalars['Int']>;
  total_delivery_time_first?: Maybe<Scalars['Int']>;
  total_delivery_time_subsequent?: Maybe<Scalars['Int']>;
  total_msg_volume?: Maybe<Scalars['Int']>;
};

export type MacroClone = {
  __typename?: 'MacroClone';
  active: Scalars['Boolean'];
  cloneBatchId?: Maybe<Scalars['ID']>;
  clonedAt?: Maybe<Scalars['ISO8601DateTime']>;
  createdAt: Scalars['ISO8601DateTime'];
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  responseHtml?: Maybe<Scalars['String']>;
  subdomains: Array<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  title?: Maybe<Scalars['String']>;
  topic?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type MacroCloneAttributes = {
  active: Scalars['Boolean'];
  responseHtml: Scalars['String'];
  subdomains: Array<Scalars['String']>;
  tags: Array<Scalars['String']>;
  title: Scalars['String'];
  topic: Scalars['String'];
};

export type MacroCloneCollection = {
  __typename?: 'MacroCloneCollection';
  collection: Array<MacroClone>;
  metadata: CollectionMetadata;
};

/** Autogenerated input type of MacroCloneCreate */
export type MacroCloneCreateInput = {
  attributes: MacroCloneAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of MacroCloneCreate. */
export type MacroCloneCreatePayload = {
  __typename?: 'MacroCloneCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Error>>;
  macroClone?: Maybe<MacroClone>;
};

/** Autogenerated input type of MacroCloneExecute */
export type MacroCloneExecuteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of MacroCloneExecute. */
export type MacroCloneExecutePayload = {
  __typename?: 'MacroCloneExecutePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Error>>;
  macroClone?: Maybe<MacroClone>;
};

/** Autogenerated input type of MacroCloneUpdate */
export type MacroCloneUpdateInput = {
  attributes: MacroCloneAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of MacroCloneUpdate. */
export type MacroCloneUpdatePayload = {
  __typename?: 'MacroCloneUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Error>>;
  macroClone?: Maybe<MacroClone>;
};

export enum MessageStatus {
  Failed = 'failed',
  Sending = 'sending',
  Sent = 'sent'
}

export enum MessageType {
  Incoming = 'incoming',
  Outgoing = 'outgoing'
}

export type Mutation = {
  __typename?: 'Mutation';
  asyncBatchJobDestroy?: Maybe<AsyncBatchJobDestroyPayload>;
  /** Archives a given audience list */
  audienceListArchive: AudienceList;
  /** Create a new audience list */
  audienceListCreate: AudienceList;
  /** Populate the audience of a bulk mail campaign based on a list's search filters */
  audienceListPopulateBulkMail: AudienceListPopulateBulkMailResponse;
  /** Search the audience based on its filters and save the result as audience list users */
  audienceListPopulatePreview: AudienceList;
  /** Trigger audience list refresh across all subdomains */
  audienceListRefreshAcrossSubdomains: AudienceListRefreshAcrossSubdomainsResponse;
  /** Update a given audience list */
  audienceListUpdate: AudienceList;
  auditLogCreate?: Maybe<AuditLogCreatePayload>;
  batchBulkApiSendCreate?: Maybe<BatchBulkApiSendCreatePayload>;
  batchBulkApiSendUpdate?: Maybe<BatchBulkApiSendUpdatePayload>;
  /** Cancel a batch send */
  batchCancelSend: BatchCancelSendResponse;
  batchCreate?: Maybe<BatchCreatePayload>;
  batchDelete?: Maybe<BatchDeletePayload>;
  batchExecute?: Maybe<BatchExecutePayload>;
  batchExecutionCancel?: Maybe<BatchExecutionCancelPayload>;
  batchResetStatus?: Maybe<BatchResetStatusPayload>;
  batchResponseAttach?: Maybe<BatchResponseAttachPayload>;
  batchResponseUnassign?: Maybe<BatchResponseUnassignPayload>;
  batchUpdate?: Maybe<BatchUpdatePayload>;
  /** Schedule one or more batch sends */
  batchesScheduleSend: BatchesScheduleSendResponse;
  bulkJobCreate: BulkJobCreateResponse;
  bulkUpdateCustomer?: Maybe<BulkUpdateCustomerPayload>;
  /** Update a bulk mail campaign */
  campaignCreate: Campaign;
  campaignDelete: DeleteResponse;
  /** Create a new campaign based on another campaign */
  campaignDuplicate: Campaign;
  /** Count a newsletter subscriber as unsubscribed from a campaign */
  campaignNewsletterSubscriberRemoved: CampaignNewsletterSubscriberRemovedResponse;
  /** Email ticket requester a ticket comment */
  campaignNotifyRequester?: Maybe<CampaignNotifyRequesterPayload>;
  campaignPhysicalMailCreate: PhysicalMailer;
  campaignPhysicalMailPreview: PhysicalMailerPreview;
  /** Send a campaign */
  campaignSend: Campaign;
  /** Count a new newsletter subscriber that subscribed based on a survey */
  campaignSurveyNewsletterSubscriberAdded: CampaignSurveyNewsletterSubscriberAddedResponse;
  /** Update survey value of a bulk mail  */
  campaignSurveyUpdate: Campaign;
  /** Create a campaign and send a test mailer to a single provided email */
  campaignTestSend: Campaign;
  /** Update a bulk mail campaign */
  campaignUpdate: Campaign;
  /** Override email subdomain used in bulkmail campaigns */
  campaignUpdateEmailSubdomain?: Maybe<Subdomain>;
  /** Create a new cohort */
  cohortCreate: Cohort;
  /** Reprocess an entire cohort with zd-normalizer */
  cohortNormalize: Cohort;
  /** Update cohort data */
  cohortUpdate: Cohort;
  constituentTagCategoryCreate?: Maybe<ConstituentTagCategoryCreatePayload>;
  constituentTagCategoryDelete?: Maybe<ConstituentTagCategoryDeletePayload>;
  constituentTagCategoryUpdate?: Maybe<ConstituentTagCategoryUpdatePayload>;
  constituentTagCreate?: Maybe<ConstituentTagCreatePayload>;
  constituentTagDelete?: Maybe<ConstituentTagDeletePayload>;
  constituentTagUpdate?: Maybe<ConstituentTagUpdatePayload>;
  /** Create a Search & Export dashboard */
  createSEDashboard: SeDashboard;
  /** Create a SideConversation */
  createSideConversation: SideConversation;
  /** poll for actionable bulk jobs, this mutation is meant to be called on a schedule by a cron job */
  cronBulkJobScheduler?: Maybe<CronJob>;
  /** poll for bulkmailers that are scheduled to be sent last 5 minutes, this mutation is meant to be called on a schedule by a cron job */
  cronScheduledBulkMailerScheduler?: Maybe<CronJob>;
  currentEditorAddOrUpdate: CurrentEditor;
  currentEditorDelete: CurrentEditor;
  customerCreate?: Maybe<CustomerCreatePayload>;
  customerDelete?: Maybe<CustomerDeletePayload>;
  customerRename?: Maybe<CustomerRenamePayload>;
  customerSetupL2Fields?: Maybe<CustomerSetupL2FieldsPayload>;
  customerSoftDelete?: Maybe<CustomerSoftDeletePayload>;
  customerSupportOrganizationUpdate?: Maybe<CustomerSupportOrganizationUpdatePayload>;
  customerSyncHealthJob?: Maybe<CustomerSyncHealthJobPayload>;
  customerSyncJob?: Maybe<CustomerSyncJobPayload>;
  customerSyncMetricsJob?: Maybe<CustomerSyncMetricsJobPayload>;
  customerSyncResponsesJob?: Maybe<CustomerSyncResponsesJobPayload>;
  customerSyncSunshineObjectsJob?: Maybe<CustomerSyncSunshineObjectsJobPayload>;
  customerSyncZendeskObjectsJob?: Maybe<CustomerSyncZendeskObjectsJobPayload>;
  customerUpdate?: Maybe<CustomerUpdatePayload>;
  /** Delete a Search & Export dashboard */
  deleteSEDashboard: SeDashboard;
  digitalTemplatePreview?: Maybe<DigitalTemplatePreviewPayload>;
  digitalTemplatePrint?: Maybe<DigitalTemplatePrintPayload>;
  /** Handle direct incoming mail */
  directMailHandle: DirectMailHandleResponse;
  discoveryExportCombine?: Maybe<DiscoveryExportCombinePayload>;
  discoveryExportCreate?: Maybe<DiscoveryExportCreatePayload>;
  discoveryExportExecute?: Maybe<DiscoveryExportExecutePayload>;
  discoveryExportUpdate?: Maybe<DiscoveryExportUpdatePayload>;
  emailTemplateCreate?: Maybe<EmailTemplateCreatePayload>;
  emailTemplateUpdate?: Maybe<EmailTemplateUpdatePayload>;
  /** Extract text from PDF attachments in a ticket */
  extractTextFromAttachment: ExtractTextFromAttachmentResponse;
  federatedReportCreate: FederatedReport;
  federatedReportDelete: FederatedReport;
  federatedReportUpdate: FederatedReport;
  helpCenterGenerateRedirect?: Maybe<HelpCenterGenerateRedirectPayload>;
  macroCloneCreate?: Maybe<MacroCloneCreatePayload>;
  macroCloneExecute?: Maybe<MacroCloneExecutePayload>;
  macroCloneUpdate?: Maybe<MacroCloneUpdatePayload>;
  physicalMailerTemplateCreate?: Maybe<PhysicalMailerTemplateCreatePayload>;
  physicalMailerTemplateDelete?: Maybe<PhysicalMailerTemplateDeletePayload>;
  physicalMailerTemplateUpload?: Maybe<PhysicalMailerTemplateUploadPayload>;
  /** Backfill all print queue objects across subdomains */
  printBackfillJobStart: PrintBackfillSuccess;
  /** Create a PrintComment */
  printCommentCreate: PrintComment;
  /** Create a PrintComment from the 'Tag non-emailable comment updates' trigger */
  printCommentCreateFromTrigger: PrintCommentCreateFromTriggerSuccess;
  /** Create many random PrintComments and associated zendesk tickets */
  printCommentCreateMany: PrintCommentCreateManySuccess;
  /** Update a PrintComment after its equivalent PrintableComment has been created/updated in admin-rails */
  printCommentSyncFromAdmin: PrintSyncSuccess;
  /** Updates the text of a PrintComment */
  printCommentUpdate: PrintComment;
  /** Closes one or more Print Comments and associated tickets without printing them */
  printCommentsClose: PrintCloseResponse;
  /** Print one or more printable comments */
  printCommentsPrint: PrintResponse;
  printJobCreate?: Maybe<PrintJobCreatePayload>;
  printJobDelete?: Maybe<PrintJobDeletePayload>;
  /** Update a PrintQueueJob after its equivalent PrintJob has been created/updated in admin-rails */
  printJobSyncFromAdmin: PrintSyncSuccess;
  /** Delete a print queue job */
  printQueueJobDelete: PrintQueueJobDeleteSuccess;
  /** Generates and returns a template preview for display in Print Queue */
  printTemplatePreview: PrintTemplatePreviewResponse;
  /** Print a new ticket comment from the Print app */
  printTicketComment: PrintCommentResponse;
  /** Updates a ZendeskUser from Print Queue; also updates the corresponding user in Zendesk */
  printUserUpdate: PrintUserUpdateSuccess;
  printableCommentCreate?: Maybe<PrintableCommentCreatePayload>;
  printableCommentCreateFromTrigger?: Maybe<PrintableCommentCreateFromTriggerPayload>;
  printableCommentCreateFromView?: Maybe<PrintableCommentCreateFromViewPayload>;
  printableCommentDelete?: Maybe<PrintableCommentDeletePayload>;
  /** Bulk update tickets and printable comments */
  printableCommentPrint?: Maybe<PrintableCommentPrintPayload>;
  /** Update a printable comment */
  printableCommentUpdate?: Maybe<PrintableCommentUpdatePayload>;
  printableCommentUpdateUser?: Maybe<PrintableCommentUpdateUserPayload>;
  /** Reply to a SideConversation */
  replyToSideConversation: SideConversation;
  responseCardDelete?: Maybe<ResponseCardDeletePayload>;
  responseCardMove?: Maybe<ResponseCardMovePayload>;
  responseColumnsUpdate?: Maybe<ResponseColumnsUpdatePayload>;
  responseCommentCreate?: Maybe<ResponseCommentCreatePayload>;
  responseCommentUpdate?: Maybe<ResponseCommentUpdatePayload>;
  /** @deprecated RAQ backend migration never finalized */
  responseCreate?: Maybe<ResponseCreatePayload>;
  /** @deprecated RAQ backend migration never finalized */
  responseDelete?: Maybe<ResponseDeletePayload>;
  /** @deprecated RAQ backend migration never finalized */
  responseProgressApproval?: Maybe<ResponseProgressApprovalPayload>;
  /** @deprecated RAQ backend migration never finalized */
  responseUpdate?: Maybe<ResponseUpdatePayload>;
  /** @deprecated RAQ backend migration never finalized */
  responseViewUpdate?: Maybe<ResponseViewUpdatePayload>;
  /** Create a new SERecord with a set of search queries */
  seRecordCreate: SeRecord;
  /** Deletes a SERecord */
  seRecordDelete: Scalars['String'];
  /** Downloads a SERecord's results from S3 */
  seRecordDownload: Scalars['String'];
  /** Apply macro to relevant tickets (async) */
  searchApplyMacro?: Maybe<SearchApplyMacroPayload>;
  sparkpostIpPoolCreate: SparkpostIpPoolCreateResponse;
  sparkpostIpPoolDelete: SparkpostIpPoolDeleteResponse;
  sparkpostIpUpdate: SparkpostIpPoolUpdateResponse;
  /** Reprocess a subdomain via zd-normalizer */
  subdomainNormalize?: Maybe<Subdomain>;
  subdomainUpdateBulkMailUnsubscribeLink?: Maybe<Subdomain>;
  subdomainUpdateProactiveMailPool?: Maybe<Subdomain>;
  surveyCreate?: Maybe<SurveyCreatePayload>;
  surveyResponseCreate?: Maybe<SurveyResponseCreatePayload>;
  surveyUpdate?: Maybe<SurveyUpdatePayload>;
  /** @deprecated RAQ backend migration never finalized */
  tagCreate?: Maybe<TagCreatePayload>;
  /** @deprecated RAQ backend migration never finalized */
  tagDelete?: Maybe<TagDeletePayload>;
  /** @deprecated RAQ backend migration never finalized */
  tagUpdate?: Maybe<TagUpdatePayload>;
  /**
   * Apply macro on a ticket (async)
   * @deprecated Use ZendeskTicketApplyResponse instead
   */
  ticketApplyMacro?: Maybe<TicketApplyMacroPayload>;
  /** Apply a macro to a given ticket */
  ticketApplyResponse: TicketApplyResponseSuccess;
  /** Gets .eml (Email File) from ticket and attaches it to the ticket as a comment */
  ticketAttachEml: TicketAttachEmlSuccess;
  /** Notify requester of comment via Sparkpost Email */
  ticketNotifyRequester?: Maybe<TicketNotifyRequesterPayload>;
  /** Add a batch tag to tickets matching the trigger */
  ticketSearchByTriggerAddBatch: TicketAddBatchSuccess;
  /** Apply a macro to tickets matching the trigger */
  ticketSearchByTriggerApplyResponse: TicketApplyResponseSuccess;
  /** Update a ZendeskTicket in our database */
  ticketUpdateInDatabase: TicketUpdateInDatabaseSuccess;
  /** @deprecated RAQ backend migration never finalized */
  topicCreate?: Maybe<TopicCreatePayload>;
  /** Allows for single transactional email sends using Sparkpost */
  transactionalEmailSend?: Maybe<TransactionalEmailSendResponse>;
  /** Create an auto-batch trigger */
  triggerCreateAutoBatch?: Maybe<TriggerCreateAutoBatchPayload>;
  /** Create an auto-response trigger */
  triggerCreateAutoResponse?: Maybe<TriggerCreateAutoResponsePayload>;
  universesRefreshJob?: Maybe<UniversesRefreshJobPayload>;
  /** Update an office's facts - this is a merge operation */
  updateCustomerFacts: UpdateCustomerFactsResponse;
  /** Update a Search & Export dashboard */
  updateSEDashboard: SeDashboard;
  userDowngrade?: Maybe<UserDowngradePayload>;
  userUpdate?: Maybe<UserUpdatePayload>;
  userUpdateBatchCreate?: Maybe<UserUpdateBatchCreatePayload>;
  userUpdateBatchCsvUpload?: Maybe<UserUpdateBatchCsvUploadPayload>;
  userUpdateBatchExecute?: Maybe<UserUpdateBatchExecutePayload>;
  userUpdateBatchUpdate?: Maybe<UserUpdateBatchUpdatePayload>;
  userUploadRerunProcessCSV: UserUpload;
  ushorZipsStateSyncJob?: Maybe<UshorZipsStateSyncJobPayload>;
  ushorZipsSyncJob?: Maybe<UshorZipsSyncJobPayload>;
  validateXml: ValidateXmlResponse;
  /** Create a new webform */
  webformCreate: Webform;
  /** Update webform schema */
  webformUpdate: Webform;
  /** Hold a ZD Ticket */
  zdTicketRetentionHold: ZdTicketRetention;
  /** Hold multiple ZD Tickets */
  zdTicketRetentionHoldMany: MutationResult;
  /** Release a ZD Ticket */
  zdTicketRetentionRelease: ZdTicketRetention;
  /** Release multiple ZD Tickets */
  zdTicketRetentionReleaseMany: MutationResult;
  /** Upsert a ZDTicketRetention row; typically called via Zendesk webhook */
  zdTicketRetentionWebhookHandler: ZdTicketRetention;
  zendeskObjectSync?: Maybe<ZendeskObjectSyncPayload>;
  zendeskObjectToggleDestroy?: Maybe<ZendeskObjectToggleDestroyPayload>;
  zendeskUserUpdate?: Maybe<ZendeskUserUpdatePayload>;
};


export type MutationAsyncBatchJobDestroyArgs = {
  input: AsyncBatchJobDestroyInput;
};


export type MutationAudienceListArchiveArgs = {
  id: Scalars['ID'];
};


export type MutationAudienceListCreateArgs = {
  input: AudienceListCreateInput;
};


export type MutationAudienceListPopulateBulkMailArgs = {
  input: AudienceListPopulateBulkMailInput;
};


export type MutationAudienceListPopulatePreviewArgs = {
  input: AudienceListPopulatePreviewInput;
};


export type MutationAudienceListUpdateArgs = {
  input: AudienceListUpdateInput;
};


export type MutationAuditLogCreateArgs = {
  input: AuditLogCreateInput;
};


export type MutationBatchBulkApiSendCreateArgs = {
  input: BatchBulkApiSendCreateInput;
};


export type MutationBatchBulkApiSendUpdateArgs = {
  input: BatchBulkApiSendUpdateInput;
};


export type MutationBatchCancelSendArgs = {
  batchId: Scalars['ID'];
};


export type MutationBatchCreateArgs = {
  input: BatchCreateInput;
};


export type MutationBatchDeleteArgs = {
  input: BatchDeleteInput;
};


export type MutationBatchExecuteArgs = {
  input: BatchExecuteInput;
};


export type MutationBatchExecutionCancelArgs = {
  input: BatchExecutionCancelInput;
};


export type MutationBatchResetStatusArgs = {
  input: BatchResetStatusInput;
};


export type MutationBatchResponseAttachArgs = {
  input: BatchResponseAttachInput;
};


export type MutationBatchResponseUnassignArgs = {
  input: BatchResponseUnassignInput;
};


export type MutationBatchUpdateArgs = {
  input: BatchUpdateInput;
};


export type MutationBatchesScheduleSendArgs = {
  input: BatchesScheduleSendInput;
};


export type MutationBulkJobCreateArgs = {
  input: BulkJobCreateInput;
};


export type MutationBulkUpdateCustomerArgs = {
  input: BulkUpdateCustomerInput;
};


export type MutationCampaignCreateArgs = {
  input: CampaignCreateInput;
};


export type MutationCampaignDeleteArgs = {
  id: Scalars['ID'];
};


export type MutationCampaignDuplicateArgs = {
  input: CampaignDuplicateInput;
};


export type MutationCampaignNewsletterSubscriberRemovedArgs = {
  input: CampaignNewsletterSubscriberRemovedInput;
};


export type MutationCampaignNotifyRequesterArgs = {
  input: CampaignNotifyRequesterInput;
};


export type MutationCampaignPhysicalMailCreateArgs = {
  input: PhysicalMailInput;
};


export type MutationCampaignPhysicalMailPreviewArgs = {
  input: PhysicalMailInput;
};


export type MutationCampaignSendArgs = {
  id: Scalars['ID'];
};


export type MutationCampaignSurveyNewsletterSubscriberAddedArgs = {
  input: CampaignSurveyNewsletterSubscriberAddedInput;
};


export type MutationCampaignSurveyUpdateArgs = {
  input: CampaignSurveyInput;
};


export type MutationCampaignTestSendArgs = {
  input: CampaignTestSendInput;
};


export type MutationCampaignUpdateArgs = {
  input: CampaignInput;
};


export type MutationCampaignUpdateEmailSubdomainArgs = {
  input: SubdomainEmailUpdateInput;
};


export type MutationCohortCreateArgs = {
  input: CohortCreateInput;
};


export type MutationCohortNormalizeArgs = {
  input: CohortNormalizeInput;
};


export type MutationCohortUpdateArgs = {
  input: CohortUpdateInput;
};


export type MutationConstituentTagCategoryCreateArgs = {
  input: ConstituentTagCategoryCreateInput;
};


export type MutationConstituentTagCategoryDeleteArgs = {
  input: ConstituentTagCategoryDeleteInput;
};


export type MutationConstituentTagCategoryUpdateArgs = {
  input: ConstituentTagCategoryUpdateInput;
};


export type MutationConstituentTagCreateArgs = {
  input: ConstituentTagCreateInput;
};


export type MutationConstituentTagDeleteArgs = {
  input: ConstituentTagDeleteInput;
};


export type MutationConstituentTagUpdateArgs = {
  input: ConstituentTagUpdateInput;
};


export type MutationCreateSeDashboardArgs = {
  input: CreateSeDashboardInput;
};


export type MutationCreateSideConversationArgs = {
  input: CreateSideConversationInput;
};


export type MutationCurrentEditorAddOrUpdateArgs = {
  input: AddOrUpdateCurrentEditorInput;
};


export type MutationCurrentEditorDeleteArgs = {
  id: Scalars['ID'];
};


export type MutationCustomerCreateArgs = {
  input: CustomerCreateInput;
};


export type MutationCustomerDeleteArgs = {
  input: CustomerDeleteInput;
};


export type MutationCustomerRenameArgs = {
  input: CustomerRenameInput;
};


export type MutationCustomerSetupL2FieldsArgs = {
  input: CustomerSetupL2FieldsInput;
};


export type MutationCustomerSoftDeleteArgs = {
  input: CustomerSoftDeleteInput;
};


export type MutationCustomerSupportOrganizationUpdateArgs = {
  input: CustomerSupportOrganizationUpdateInput;
};


export type MutationCustomerSyncHealthJobArgs = {
  input: CustomerSyncHealthJobInput;
};


export type MutationCustomerSyncJobArgs = {
  input: CustomerSyncJobInput;
};


export type MutationCustomerSyncMetricsJobArgs = {
  input: CustomerSyncMetricsJobInput;
};


export type MutationCustomerSyncResponsesJobArgs = {
  input: CustomerSyncResponsesJobInput;
};


export type MutationCustomerSyncSunshineObjectsJobArgs = {
  input: CustomerSyncSunshineObjectsJobInput;
};


export type MutationCustomerSyncZendeskObjectsJobArgs = {
  input: CustomerSyncZendeskObjectsJobInput;
};


export type MutationCustomerUpdateArgs = {
  input: CustomerUpdateInput;
};


export type MutationDeleteSeDashboardArgs = {
  id: Scalars['ID'];
};


export type MutationDigitalTemplatePreviewArgs = {
  input: DigitalTemplatePreviewInput;
};


export type MutationDigitalTemplatePrintArgs = {
  input: DigitalTemplatePrintInput;
};


export type MutationDirectMailHandleArgs = {
  input: DirectMailInput;
};


export type MutationDiscoveryExportCombineArgs = {
  input: DiscoveryExportCombineInput;
};


export type MutationDiscoveryExportCreateArgs = {
  input: DiscoveryExportCreateInput;
};


export type MutationDiscoveryExportExecuteArgs = {
  input: DiscoveryExportExecuteInput;
};


export type MutationDiscoveryExportUpdateArgs = {
  input: DiscoveryExportUpdateInput;
};


export type MutationEmailTemplateCreateArgs = {
  input: EmailTemplateCreateInput;
};


export type MutationEmailTemplateUpdateArgs = {
  input: EmailTemplateUpdateInput;
};


export type MutationExtractTextFromAttachmentArgs = {
  input: ExtractTextFromAttachmentInput;
};


export type MutationFederatedReportCreateArgs = {
  input: FederatedReportCreateInput;
};


export type MutationFederatedReportDeleteArgs = {
  id: Scalars['ID'];
};


export type MutationFederatedReportUpdateArgs = {
  input: FederatedReportUpdateInput;
};


export type MutationHelpCenterGenerateRedirectArgs = {
  input: HelpCenterGenerateRedirectInput;
};


export type MutationMacroCloneCreateArgs = {
  input: MacroCloneCreateInput;
};


export type MutationMacroCloneExecuteArgs = {
  input: MacroCloneExecuteInput;
};


export type MutationMacroCloneUpdateArgs = {
  input: MacroCloneUpdateInput;
};


export type MutationPhysicalMailerTemplateCreateArgs = {
  input: PhysicalMailerTemplateCreateInput;
};


export type MutationPhysicalMailerTemplateDeleteArgs = {
  input: PhysicalMailerTemplateDeleteInput;
};


export type MutationPhysicalMailerTemplateUploadArgs = {
  input: PhysicalMailerTemplateUploadInput;
};


export type MutationPrintCommentCreateArgs = {
  input: PrintCommentCreateInput;
};


export type MutationPrintCommentCreateFromTriggerArgs = {
  input: PrintCommentCreateFromTriggerInput;
};


export type MutationPrintCommentCreateManyArgs = {
  input: PrintCommentCreateManyInput;
};


export type MutationPrintCommentSyncFromAdminArgs = {
  input: PrintCommentSyncInput;
};


export type MutationPrintCommentUpdateArgs = {
  input: PrintCommentUpdateInput;
};


export type MutationPrintCommentsCloseArgs = {
  input: PrintCommentsCloseInput;
};


export type MutationPrintCommentsPrintArgs = {
  input: PrintCommentsPrintInput;
};


export type MutationPrintJobCreateArgs = {
  input: PrintJobCreateInput;
};


export type MutationPrintJobDeleteArgs = {
  input: PrintJobDeleteInput;
};


export type MutationPrintJobSyncFromAdminArgs = {
  input: PrintJobSyncInput;
};


export type MutationPrintQueueJobDeleteArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type MutationPrintTemplatePreviewArgs = {
  input: PrintTemplatePreviewInput;
};


export type MutationPrintTicketCommentArgs = {
  input: PrintTicketCommentInput;
};


export type MutationPrintUserUpdateArgs = {
  input: PrintUserUpdateInput;
};


export type MutationPrintableCommentCreateArgs = {
  input: PrintableCommentCreateInput;
};


export type MutationPrintableCommentCreateFromTriggerArgs = {
  input: PrintableCommentCreateFromTriggerInput;
};


export type MutationPrintableCommentCreateFromViewArgs = {
  input: PrintableCommentCreateFromViewInput;
};


export type MutationPrintableCommentDeleteArgs = {
  input: PrintableCommentDeleteInput;
};


export type MutationPrintableCommentPrintArgs = {
  input: PrintableCommentPrintInput;
};


export type MutationPrintableCommentUpdateArgs = {
  input: PrintableCommentUpdateInput;
};


export type MutationPrintableCommentUpdateUserArgs = {
  input: PrintableCommentUpdateUserInput;
};


export type MutationReplyToSideConversationArgs = {
  input: ReplyToSideConversationInput;
};


export type MutationResponseCardDeleteArgs = {
  input: ResponseCardDeleteInput;
};


export type MutationResponseCardMoveArgs = {
  input: ResponseCardMoveInput;
};


export type MutationResponseColumnsUpdateArgs = {
  input: ResponseColumnsUpdateInput;
};


export type MutationResponseCommentCreateArgs = {
  input: ResponseCommentCreateInput;
};


export type MutationResponseCommentUpdateArgs = {
  input: ResponseCommentUpdateInput;
};


export type MutationResponseCreateArgs = {
  input: ResponseCreateInput;
};


export type MutationResponseDeleteArgs = {
  input: ResponseDeleteInput;
};


export type MutationResponseProgressApprovalArgs = {
  input: ResponseProgressApprovalInput;
};


export type MutationResponseUpdateArgs = {
  input: ResponseUpdateInput;
};


export type MutationResponseViewUpdateArgs = {
  input: ResponseViewUpdateInput;
};


export type MutationSeRecordCreateArgs = {
  input: SeRecordCreateInput;
};


export type MutationSeRecordDeleteArgs = {
  id: Scalars['ID'];
};


export type MutationSeRecordDownloadArgs = {
  id: Scalars['ID'];
};


export type MutationSearchApplyMacroArgs = {
  input: SearchApplyMacroInput;
};


export type MutationSparkpostIpPoolCreateArgs = {
  input: SparkpostIpPoolCreateInput;
};


export type MutationSparkpostIpPoolDeleteArgs = {
  id: Scalars['ID'];
};


export type MutationSparkpostIpUpdateArgs = {
  input: SparkpostIpUpdateInput;
};


export type MutationSubdomainNormalizeArgs = {
  input: SubdomainNormalizeInput;
};


export type MutationSubdomainUpdateBulkMailUnsubscribeLinkArgs = {
  input: SubdomainUpdateBulkMailUnsubscribeLinkInput;
};


export type MutationSubdomainUpdateProactiveMailPoolArgs = {
  input: SubdomainUpdateProactivePoolInput;
};


export type MutationSurveyCreateArgs = {
  input: SurveyCreateInput;
};


export type MutationSurveyResponseCreateArgs = {
  input: SurveyResponseCreateInput;
};


export type MutationSurveyUpdateArgs = {
  input: SurveyUpdateInput;
};


export type MutationTagCreateArgs = {
  input: TagCreateInput;
};


export type MutationTagDeleteArgs = {
  input: TagDeleteInput;
};


export type MutationTagUpdateArgs = {
  input: TagUpdateInput;
};


export type MutationTicketApplyMacroArgs = {
  input: TicketApplyMacroInput;
};


export type MutationTicketApplyResponseArgs = {
  input: TicketApplyResponseInput;
};


export type MutationTicketAttachEmlArgs = {
  input: TicketAttachEmlInput;
};


export type MutationTicketNotifyRequesterArgs = {
  input: TicketNotifyRequesterInput;
};


export type MutationTicketSearchByTriggerAddBatchArgs = {
  input: TicketSearchByTriggerAddBatchInput;
};


export type MutationTicketSearchByTriggerApplyResponseArgs = {
  input: TicketSearchByTriggerApplyResponseInput;
};


export type MutationTicketUpdateInDatabaseArgs = {
  input: TicketUpdateInDatabaseInput;
};


export type MutationTopicCreateArgs = {
  input: TopicCreateInput;
};


export type MutationTransactionalEmailSendArgs = {
  input: TransactionalEmailSendInput;
};


export type MutationTriggerCreateAutoBatchArgs = {
  input: TriggerCreateAutoBatchInput;
};


export type MutationTriggerCreateAutoResponseArgs = {
  input: TriggerCreateAutoResponseInput;
};


export type MutationUniversesRefreshJobArgs = {
  input: UniversesRefreshJobInput;
};


export type MutationUpdateCustomerFactsArgs = {
  input: UpdateCustomerFactsInput;
};


export type MutationUpdateSeDashboardArgs = {
  input: UpdateSeDashboardInput;
};


export type MutationUserDowngradeArgs = {
  input: UserDowngradeInput;
};


export type MutationUserUpdateArgs = {
  input: UserUpdateInput;
};


export type MutationUserUpdateBatchCreateArgs = {
  input: UserUpdateBatchCreateInput;
};


export type MutationUserUpdateBatchCsvUploadArgs = {
  input: UserUpdateBatchCsvUploadInput;
};


export type MutationUserUpdateBatchExecuteArgs = {
  input: UserUpdateBatchExecuteInput;
};


export type MutationUserUpdateBatchUpdateArgs = {
  input: UserUpdateBatchUpdateInput;
};


export type MutationUserUploadRerunProcessCsvArgs = {
  id: Scalars['Int'];
};


export type MutationUshorZipsStateSyncJobArgs = {
  input: UshorZipsStateSyncJobInput;
};


export type MutationUshorZipsSyncJobArgs = {
  input: UshorZipsSyncJobInput;
};


export type MutationValidateXmlArgs = {
  input: ValidateXmlInput;
};


export type MutationWebformCreateArgs = {
  input: WebformCreateInput;
};


export type MutationWebformUpdateArgs = {
  input: WebformUpdateInput;
};


export type MutationZdTicketRetentionHoldArgs = {
  input: ZdTicketRetentionHoldInput;
};


export type MutationZdTicketRetentionHoldManyArgs = {
  input: ZdTicketRetentionHoldManyInput;
};


export type MutationZdTicketRetentionReleaseArgs = {
  input: ZdTicketRetentionReleaseInput;
};


export type MutationZdTicketRetentionReleaseManyArgs = {
  input: ZdTicketRetentionReleaseManyInput;
};


export type MutationZdTicketRetentionWebhookHandlerArgs = {
  input: ZdTicketRetentionWebhookHandlerInput;
};


export type MutationZendeskObjectSyncArgs = {
  input: ZendeskObjectSyncInput;
};


export type MutationZendeskObjectToggleDestroyArgs = {
  input: ZendeskObjectToggleDestroyInput;
};


export type MutationZendeskUserUpdateArgs = {
  input: ZendeskUserUpdateInput;
};

export type MutationResult = {
  __typename?: 'MutationResult';
  count: Scalars['Int'];
};

export type NewAttachmentInput = {
  /** Base64 encoded file data for an attachment that needs to be uploaded */
  data: Scalars['String'];
  filename: Scalars['String'];
};

/** Get the count of subscribers broken down by subdomain */
export type NewsletterSubscriberBySubdomain = {
  __typename?: 'NewsletterSubscriberBySubdomain';
  subdomain?: Maybe<Scalars['String']>;
  subscribers?: Maybe<Scalars['Int']>;
};

/** Get the count of newsletter subscribers & unsubscribers by subdomain and across a cohort. */
export type NewsletterSubscriptionCount = {
  __typename?: 'NewsletterSubscriptionCount';
  /** count of subscribers aggregated at a given cohort level. */
  newSubscribersAcrossSubdomains?: Maybe<Scalars['Int']>;
  /** count of subscribers during a given timeframe broken down by subdomain. */
  newSubscribersBySubdomain?: Maybe<Array<NewsletterSubscriberBySubdomain>>;
  /** total subscribers till date across a cohort. */
  totalSubscribersCountAcrossSubdomains?: Maybe<Scalars['Int']>;
};

export enum OcrJobStatus {
  Completed = 'completed',
  Failed = 'failed'
}

export type OcrMetadataAttachment = {
  __typename?: 'OCRMetadataAttachment';
  attachmentId: Scalars['String'];
  attachmentUrl: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  ocrJobStatus?: Maybe<OcrJobStatus>;
  subdomain: Subdomain;
  updatedAt: Scalars['ISO8601DateTime'];
  zendeskTicketId: Scalars['String'];
};

export type OldAttachmentInput = {
  filename: Scalars['String'];
  /** An existing attachment from another comment */
  url: Scalars['String'];
};

export type PhysicalMailInput = {
  campaignId: Scalars['ID'];
  isActiveStorage?: Maybe<Scalars['Boolean']>;
  message: Scalars['String'];
  templateKey: Scalars['String'];
  templatesPerPage: Scalars['Int'];
  users: Array<PhysicalMailUser>;
};

export type PhysicalMailUser = {
  firstName?: Maybe<Scalars['String']>;
  homeAddressCity?: Maybe<Scalars['String']>;
  homeAddressLine1?: Maybe<Scalars['String']>;
  homeAddressLine2?: Maybe<Scalars['String']>;
  homeAddressState?: Maybe<Scalars['String']>;
  homeAddressZipCode?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  prefix?: Maybe<Scalars['String']>;
  salutation?: Maybe<Scalars['String']>;
};

export type PhysicalMailer = {
  __typename?: 'PhysicalMailer';
  jid: Scalars['ID'];
  status: PhysicalMailerStatus;
  url?: Maybe<Scalars['String']>;
};

export type PhysicalMailerPreview = {
  __typename?: 'PhysicalMailerPreview';
  content: Scalars['String'];
};

export enum PhysicalMailerStatus {
  Done = 'done',
  Queued = 'queued',
  Started = 'started'
}

export type PhysicalMailerTemplate = {
  __typename?: 'PhysicalMailerTemplate';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  /** Human friendly name of the template */
  name?: Maybe<Scalars['String']>;
  template: Blob;
  /** Number of cards per template page */
  templatesPerPage: Scalars['Int'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Attributes for creating a physical mailer template */
export type PhysicalMailerTemplateAttributes = {
  name: Scalars['String'];
  /** Signed blob ID generated via `physicalMailerTemplateUpload` mutation */
  templateBlobId: Scalars['ID'];
  templatesPerPage: Scalars['Int'];
};

export type PhysicalMailerTemplateCollection = {
  __typename?: 'PhysicalMailerTemplateCollection';
  collection: Array<PhysicalMailerTemplate>;
  metadata: CollectionMetadata;
};

/** Autogenerated input type of PhysicalMailerTemplateCreate */
export type PhysicalMailerTemplateCreateInput = {
  attributes: PhysicalMailerTemplateAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of PhysicalMailerTemplateCreate. */
export type PhysicalMailerTemplateCreatePayload = {
  __typename?: 'PhysicalMailerTemplateCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Error>>;
  physicalMailerTemplate?: Maybe<PhysicalMailerTemplate>;
};

/** Autogenerated input type of PhysicalMailerTemplateDelete */
export type PhysicalMailerTemplateDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of PhysicalMailerTemplateDelete. */
export type PhysicalMailerTemplateDeletePayload = {
  __typename?: 'PhysicalMailerTemplateDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Error>>;
  physicalMailerTemplate?: Maybe<PhysicalMailerTemplate>;
};

/** Autogenerated input type of PhysicalMailerTemplateUpload */
export type PhysicalMailerTemplateUploadInput = {
  attributes: DirectUploadAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of PhysicalMailerTemplateUpload. */
export type PhysicalMailerTemplateUploadPayload = {
  __typename?: 'PhysicalMailerTemplateUploadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  directUpload?: Maybe<DirectUpload>;
};

export type PrimerComparison = {
  __typename?: 'PrimerComparison';
  currentPayload: Scalars['JSON'];
  expectedPayload: Scalars['JSON'];
  /** Type of operation needed */
  type: Scalars['String'];
};

export type PrimerConfig = {
  __typename?: 'PrimerConfig';
  closeTicketHours: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  delayHours: Scalars['Int'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Primer configuration */
export type PrimerConfigAttributes = {
  /** Value used in close automation */
  closeTicketHours: Scalars['JSON'];
  /** Value used in delay1 automation */
  delayHours: Scalars['JSON'];
};

export type PrintBackfillSuccess = {
  __typename?: 'PrintBackfillSuccess';
  success: Scalars['Boolean'];
};

export type PrintCloseResponse = {
  __typename?: 'PrintCloseResponse';
  updateTicketsJobIds: Array<Maybe<Scalars['String']>>;
};

export type PrintComment = {
  __typename?: 'PrintComment';
  commentHtml: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  printQueueJob?: Maybe<PrintQueueJob>;
  printed: Scalars['Boolean'];
  updatedAt: Scalars['ISO8601DateTime'];
  zendeskCommentId?: Maybe<Scalars['String']>;
  zendeskTicket: PrintZendeskTicket;
};

export type PrintCommentCreateFromTriggerInput = {
  zendeskCommentId: Scalars['String'];
  zendeskTicketId: Scalars['String'];
};

export type PrintCommentCreateFromTriggerSuccess = {
  __typename?: 'PrintCommentCreateFromTriggerSuccess';
  success: Scalars['Boolean'];
};

export type PrintCommentCreateInput = {
  comment: Scalars['String'];
  zendeskTicketId: Scalars['String'];
};

export type PrintCommentCreateManyInput = {
  numToCreate: Scalars['Int'];
};

export type PrintCommentCreateManySuccess = {
  __typename?: 'PrintCommentCreateManySuccess';
  success: Scalars['Boolean'];
};

export type PrintCommentFilter = {
  commentText?: Maybe<Scalars['String']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  printed?: Maybe<Scalars['Boolean']>;
  ticketStatus?: Maybe<PrintCommentTicketStatus>;
};

export type PrintCommentResponse = {
  __typename?: 'PrintCommentResponse';
  file: PrintFile;
};

export type PrintCommentSort = {
  field?: Maybe<PrintCommentSortEnum>;
  order?: Maybe<SortOrder>;
};

export enum PrintCommentSortEnum {
  BatchName = 'batchName',
  CreatedAt = 'createdAt',
  FormType = 'formType',
  Id = 'id',
  Requester = 'requester'
}

export type PrintCommentSyncInput = {
  adminRailsCommentId: Scalars['Int'];
  adminRailsPrintJobId?: Maybe<Scalars['Int']>;
  comment?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  printed?: Maybe<Scalars['Boolean']>;
  zendeskTicketId?: Maybe<Scalars['String']>;
};

export enum PrintCommentTicketStatus {
  Closed = 'closed',
  Current = 'current'
}

export type PrintCommentUpdateInput = {
  commentHtml: Scalars['String'];
  id: Scalars['ID'];
};

export type PrintCommentsCloseInput = {
  commentIds: Array<Scalars['ID']>;
  creatorZendeskId: Scalars['ID'];
};

export type PrintCommentsFetchResponse = {
  __typename?: 'PrintCommentsFetchResponse';
  printComments: Array<PrintComment>;
  totalComments: Scalars['Int'];
};

export type PrintCommentsPrintInput = {
  commentIds: Array<Scalars['ID']>;
  creatorZendeskId: Scalars['ID'];
  envelopeName?: Maybe<Scalars['String']>;
  letterName?: Maybe<Scalars['String']>;
  templates: Array<PrintTemplate>;
  ticketResolution: TicketResolution;
};

export type PrintFile = {
  __typename?: 'PrintFile';
  content: Scalars['String'];
  fileName: Scalars['String'];
};

export type PrintJob = {
  __typename?: 'PrintJob';
  createdAt: Scalars['ISO8601DateTime'];
  createdBy: Scalars['String'];
  /** User who created the print job */
  createdByUser?: Maybe<User>;
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  printableCommentIds: Array<Scalars['String']>;
  /** Printable comments printed in the print job */
  printableComments: Array<PrintableComment>;
  sunshineIds: Array<Scalars['String']>;
  ticketIds: Array<Scalars['String']>;
  ticketResolution: Scalars['String'];
  /** Tickets printed in the print job */
  tickets?: Maybe<Array<Maybe<Ticket>>>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Attributes for creating a print job */
export type PrintJobAttributes = {
  createdBy: Scalars['String'];
  printableCommentIds?: Maybe<Array<Scalars['String']>>;
  sunshineIds?: Maybe<Array<Scalars['String']>>;
  ticketIds: Array<Scalars['String']>;
  /** Ticket status update for tickets */
  ticketResolution: Scalars['String'];
};

export type PrintJobCollection = {
  __typename?: 'PrintJobCollection';
  collection: Array<PrintJob>;
  metadata: CollectionMetadata;
};

/** Autogenerated input type of PrintJobCreate */
export type PrintJobCreateInput = {
  attributes: PrintJobAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  subdomain: Scalars['ID'];
};

/** Autogenerated return type of PrintJobCreate. */
export type PrintJobCreatePayload = {
  __typename?: 'PrintJobCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Error>>;
  printJob?: Maybe<PrintJob>;
};

/** Autogenerated input type of PrintJobDelete */
export type PrintJobDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of PrintJobDelete. */
export type PrintJobDeletePayload = {
  __typename?: 'PrintJobDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Error>>;
  printJob?: Maybe<PrintJob>;
};

export type PrintJobFilter = {
  printableCommentsCommentCont?: Maybe<Scalars['String']>;
  sunshineIdsArrayContAny?: Maybe<Array<Scalars['String']>>;
  ticketIdsArrayCont?: Maybe<Array<Scalars['String']>>;
  ticketIdsArrayContAny?: Maybe<Array<Scalars['String']>>;
  ticketResolutionEq?: Maybe<Scalars['String']>;
};

export type PrintJobSort = {
  field: PrintJobsSortFieldEnum;
  order: SortOrderEnum;
};

export type PrintJobSyncInput = {
  adminRailsPrintJobId: Scalars['Int'];
  creatorZendeskId: Scalars['String'];
  ticketResolution: TicketResolution;
};

export enum PrintJobsSortFieldEnum {
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  Id = 'id',
  NumPrintableComments = 'numPrintableComments',
  RequesterId = 'requesterId',
  TicketResolution = 'ticketResolution'
}

export type PrintQueueJob = {
  __typename?: 'PrintQueueJob';
  createdAt: Scalars['ISO8601DateTime'];
  creator: PrintZendeskUser;
  documentUrls?: Maybe<Array<Scalars['String']>>;
  downloadable?: Maybe<Scalars['Boolean']>;
  failedCommentCount?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  printComments?: Maybe<Array<PrintComment>>;
  succeededCommentCount?: Maybe<Scalars['Int']>;
  ticketResolution: TicketResolution;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type PrintQueueJobDeleteSuccess = {
  __typename?: 'PrintQueueJobDeleteSuccess';
  success: Scalars['Boolean'];
};

export type PrintQueueJobFilter = {
  creatorId?: Maybe<Scalars['String']>;
  excludeEmpty?: Maybe<Scalars['Boolean']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  ticketResolution?: Maybe<TicketResolution>;
};

export type PrintQueueJobSort = {
  field?: Maybe<PrintQueueJobSortEnum>;
  order?: Maybe<SortOrder>;
};

export enum PrintQueueJobSortEnum {
  CommentCount = 'commentCount',
  CreatedAt = 'createdAt',
  CreatorId = 'creatorId',
  Id = 'id',
  TicketResolution = 'ticketResolution',
  UpdatedAt = 'updatedAt'
}

export type PrintQueueJobsFetchResponse = {
  __typename?: 'PrintQueueJobsFetchResponse';
  printJobs: Array<PrintQueueJob>;
  totalJobs: Scalars['Int'];
};

export type PrintResponse = {
  __typename?: 'PrintResponse';
  printQueueJob: PrintQueueJob;
};

export type PrintSyncSuccess = {
  __typename?: 'PrintSyncSuccess';
  success: Scalars['Boolean'];
};

export type PrintTemplate = {
  fileName: Scalars['String'];
  type: Scalars['String'];
};

export type PrintTemplatePreviewInput = {
  commentId: Scalars['ID'];
  fileName: Scalars['String'];
  type: Scalars['String'];
};

export type PrintTemplatePreviewResponse = {
  __typename?: 'PrintTemplatePreviewResponse';
  url: Scalars['String'];
};

export type PrintTicketCommentInput = {
  comment: Scalars['String'];
  templateName: Scalars['String'];
  ticketId: Scalars['String'];
};

export type PrintUserUpdateInput = {
  addressLineOne?: Maybe<Scalars['String']>;
  addressLineTwo?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  prefix?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  suffix?: Maybe<Scalars['String']>;
  userZendeskId: Scalars['ID'];
  zipCode?: Maybe<Scalars['String']>;
};

export type PrintUserUpdateSuccess = {
  __typename?: 'PrintUserUpdateSuccess';
  success: Scalars['Boolean'];
};

export type PrintZendeskTicket = {
  __typename?: 'PrintZendeskTicket';
  assignee?: Maybe<PrintZendeskUser>;
  batchName?: Maybe<Scalars['String']>;
  formType?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  requester?: Maybe<PrintZendeskUser>;
  status?: Maybe<Scalars['String']>;
  zendeskId: Scalars['String'];
};

export type PrintZendeskUser = {
  __typename?: 'PrintZendeskUser';
  districtStatus?: Maybe<DistrictStatus>;
  hasValidAddress?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  zendeskId: Scalars['String'];
};

export type PrintableComment = {
  __typename?: 'PrintableComment';
  comment: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  /** Does the requester have full address */
  hasFullAddress: Scalars['Boolean'];
  /** Does the ticket have all required fields filled out */
  hasRequiredTicketFields: Scalars['Boolean'];
  id: Scalars['ID'];
  printed: Scalars['Boolean'];
  requesterId?: Maybe<Scalars['ID']>;
  /** Ticket for the print queue records */
  ticket?: Maybe<Ticket>;
  ticketId: Scalars['Int'];
  updatedAt: Scalars['ISO8601DateTime'];
  /** User for the print queue records */
  user?: Maybe<User>;
};

/** Attributes for creating or updating a printable comment */
export type PrintableCommentAttributes = {
  /** Comment to be printed */
  comment?: Maybe<Scalars['String']>;
  /** Has the comment been printed */
  printed?: Maybe<Scalars['Boolean']>;
  /** User id of ticket requester */
  requesterId?: Maybe<Scalars['String']>;
  /** Zendesk ticket id for printable comment */
  ticketId?: Maybe<Scalars['Int']>;
  /** Status for ticket */
  ticketStatus?: Maybe<Scalars['String']>;
};

export type PrintableCommentCollection = {
  __typename?: 'PrintableCommentCollection';
  collection: Array<PrintableComment>;
  metadata: CollectionMetadata;
};

/** Autogenerated input type of PrintableCommentCreateFromTrigger */
export type PrintableCommentCreateFromTriggerInput = {
  attributes: PrintableCommentFromTriggerAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of PrintableCommentCreateFromTrigger. */
export type PrintableCommentCreateFromTriggerPayload = {
  __typename?: 'PrintableCommentCreateFromTriggerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  printableComment?: Maybe<PrintableComment>;
};

/** Autogenerated input type of PrintableCommentCreateFromView */
export type PrintableCommentCreateFromViewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  viewName?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of PrintableCommentCreateFromView. */
export type PrintableCommentCreateFromViewPayload = {
  __typename?: 'PrintableCommentCreateFromViewPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Error>>;
  printableComments: Array<PrintableComment>;
};

/** Autogenerated input type of PrintableCommentCreate */
export type PrintableCommentCreateInput = {
  attributes: PrintableCommentAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of PrintableCommentCreate. */
export type PrintableCommentCreatePayload = {
  __typename?: 'PrintableCommentCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Error>>;
  printableComment?: Maybe<PrintableComment>;
};

/** Autogenerated input type of PrintableCommentDelete */
export type PrintableCommentDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of PrintableCommentDelete. */
export type PrintableCommentDeletePayload = {
  __typename?: 'PrintableCommentDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Error>>;
  printableComment?: Maybe<PrintableComment>;
};

export type PrintableCommentFilter = {
  commentCont?: Maybe<Scalars['String']>;
  idEq?: Maybe<Scalars['ID']>;
  printedEq?: Maybe<Scalars['Boolean']>;
};

/** Attributes for creating a printable comment from trigger run */
export type PrintableCommentFromTriggerAttributes = {
  /** Comment ID to fetch comment */
  commentId: Scalars['ID'];
  /** User id of ticket requester */
  requesterId?: Maybe<Scalars['String']>;
  /** Zendesk ticket id for printable comment */
  ticketId: Scalars['ID'];
};

/** Printable comment id and user id for each comment */
export type PrintableCommentIdAndUserId = {
  /** Type of template */
  printableCommentId: Scalars['ID'];
  /** Name of template */
  userId: Scalars['ID'];
};

/** Attributes for printing a printable comment */
export type PrintableCommentPrintAttributes = {
  envelopeName?: Maybe<Scalars['String']>;
  letterName?: Maybe<Scalars['String']>;
  printableCommentIds: Array<Scalars['ID']>;
  ticketStatus?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of PrintableCommentPrint */
export type PrintableCommentPrintInput = {
  attributes: PrintableCommentPrintAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of PrintableCommentPrint. */
export type PrintableCommentPrintPayload = {
  __typename?: 'PrintableCommentPrintPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Error>>;
  jobId?: Maybe<Scalars['String']>;
  printableComments: Array<PrintableComment>;
};

export type PrintableCommentSort = {
  field: PrintableCommentsSortFieldEnum;
  order: SortOrderEnum;
};

/** Autogenerated input type of PrintableCommentUpdate */
export type PrintableCommentUpdateInput = {
  attributes: PrintableCommentAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of PrintableCommentUpdate. */
export type PrintableCommentUpdatePayload = {
  __typename?: 'PrintableCommentUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Error>>;
  printableComment?: Maybe<PrintableComment>;
};

/** Attributes for updating the user associated with a printable comment */
export type PrintableCommentUpdateUserAttributes = {
  /** Printable Comment id */
  printableCommentId: Scalars['String'];
  /** Zendesk user definition */
  userDefinition: UserAttributes;
};

/** Autogenerated input type of PrintableCommentUpdateUser */
export type PrintableCommentUpdateUserInput = {
  attributes: PrintableCommentUpdateUserAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of PrintableCommentUpdateUser. */
export type PrintableCommentUpdateUserPayload = {
  __typename?: 'PrintableCommentUpdateUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  printableComment: PrintableComment;
};

export enum PrintableCommentsSortFieldEnum {
  Comment = 'comment',
  CreatedAt = 'createdAt',
  RequesterId = 'requesterId',
  TicketId = 'ticketId'
}

export type Query = {
  __typename?: 'Query';
  /** Get a SEDashboard */
  SEDashboard: SeDashboard;
  /** Get a list of SEDashboards */
  SEDashboards: SeDashBoardsCollection;
  /** List admins */
  admins: AdminCollection;
  /** Get async batch job status */
  asyncBatchJob: AsyncBatchJob;
  /** List async batch jobs */
  asyncBatchJobs: Array<AsyncBatchJob>;
  /** Return a specific audience list */
  audienceList: AudienceList;
  /** Return a list of audience lists */
  audienceLists: AudienceListCollection;
  /** List audit logs */
  auditLogs: AuditLogCollection;
  /**
   * Get batch
   * @deprecated RAQ backend migration never finalized
   */
  batch: Batch;
  /** get batch execution */
  batchExecution: BatchExecution;
  /** List batch executions */
  batchExecutions: BatchExecutionCollection;
  /**
   * List batches
   * @deprecated RAQ backend migration never finalized
   */
  batches: BatchCollection;
  bulkJob: BulkJob;
  bulkJobBatch: BulkJobBatch;
  bulkJobs: BulkJobCollection;
  /** Fetch an individual bulkmail */
  campaign: Campaign;
  /** Fetches all bulkmail campaigns */
  campaigns: CampaignCollection;
  /** Fetch an individual cohort by name */
  cohort: Cohort;
  /** Fetches all cohorts */
  cohorts: Array<Cohort>;
  /** Get ConstituentTag */
  constituentTag: ConstituentTag;
  /** List Constituent Tag Categories */
  constituentTagCategories: Array<ConstituentTagCategory>;
  /** Get ConstituentTagCategory */
  constituentTagCategory: ConstituentTagCategory;
  /** List Constituent Tags */
  constituentTags: Array<ConstituentTag>;
  /** Get constituents reached through reactive emails count during a given time frame and by subdomain */
  constituentsReached?: Maybe<ConstituentsReachedWidget>;
  /** Show context */
  context: Context;
  currentEditor: CurrentEditorResponse;
  /** Get customer */
  customer?: Maybe<Customer>;
  /** List customers */
  customers: CustomerCollection;
  /** List digital templates */
  digitalTemplates: DigitalTemplate;
  discoveryExport: DiscoveryExport;
  /** List discovery exports */
  discoveryExports: DiscoveryExportCollection;
  /** Get sparkpost email template */
  emailTemplate?: Maybe<EmailTemplate>;
  federatedReport: FederatedReport;
  /** Returns a set of bulk mail campaigns */
  federatedReportingBulkMailCampaigns: FederatedReportingBulkMailCampaigns;
  federatedReports: FederatedReportCollection;
  fetchEditorTemplates: Array<Maybe<Scalars['String']>>;
  /** Get batch id by batch tag */
  getBatchByBatchTag: ZendeskBatchFieldOption;
  /** Get macro clone */
  macroClone: MacroClone;
  /** List macro clones */
  macroClones: MacroCloneCollection;
  /** Get newsletter subscribers & unsubscribers count within a given time frame by subdomain */
  newsletterSubscriptions?: Maybe<NewsletterSubscriptionCount>;
  /** Fetch a physical mailer */
  physicalMailer: PhysicalMailer;
  /** Get physical mailer template */
  physicalMailerTemplate: PhysicalMailerTemplate;
  /** List physical mailer templates */
  physicalMailerTemplates: PhysicalMailerTemplateCollection;
  /** Retrieve paginated printable comments */
  printCommentsFetch: PrintCommentsFetchResponse;
  /** List print jobs */
  printJobs: PrintJobCollection;
  /** Retrieve a single PrintQueueJob */
  printQueueJobFetch?: Maybe<PrintQueueJob>;
  /** Retrieve paginated completed print jobs */
  printQueueJobsFetch: PrintQueueJobsFetchResponse;
  /** Get printable comment */
  printableComment: PrintableComment;
  /** List printable comments */
  printableComments: PrintableCommentCollection;
  /**
   * Get response
   * @deprecated RAQ backend migration never finalized
   */
  response?: Maybe<Response>;
  /** Get response card */
  responseCard?: Maybe<ResponseCard>;
  /** List response cards */
  responseCards: Array<ResponseCard>;
  /** List response columns */
  responseColumns: Array<ResponseColumn>;
  /**
   * List responses
   * @deprecated RAQ backend migration never finalized
   */
  responses: ResponseCollection;
  /** Get a SERecord by ID */
  seRecord: SeRecord;
  /** Gets a SERecord's status */
  seRecordStatus: SeRecordJobStatus;
  /** Get a list of SERecords for a given SEDashboard ID */
  seRecords: SeRecordsCollection;
  /** Retrieve a count of casework tickets broken down by agency in the last n days */
  servicesProvided?: Maybe<ServicesProvidedWidget>;
  /** Fetch an individual side conversation */
  sideConversation: SideConversation;
  /** Fetches all side conversations */
  sideConversations: SideConversationCollection;
  sparkpostIpPool?: Maybe<SparkpostIpPool>;
  /** Return a list of IP pools from Sparkpost */
  sparkpostIpPools: Array<Maybe<SparkpostIpPool>>;
  /** Fetch an individual subdomain by name */
  subdomain?: Maybe<Subdomain>;
  /** Fetch all subdomains and their associated cohorts */
  subdomains: Array<Subdomain>;
  /** Get a list of subdomains for a given SEDashboard ID */
  subdomainsFetchByDashboardID: Array<Subdomain>;
  /** Get survey */
  survey: Survey;
  /** List surveys */
  surveys: SurveyCollection;
  /**
   * Get tag
   * @deprecated RAQ backend migration never finalized
   */
  tag: Tag;
  /**
   * List tags
   * @deprecated RAQ backend migration never finalized
   */
  tags: TagCollection;
  /** Count the number of tickets matching the trigger */
  ticketCountMatchingTrigger: TicketCountMatchingResponse;
  /** Retrieve the average time to solve tickets in the last n days */
  ticketResponseTime?: Maybe<TicketResponseTime>;
  /**
   * Get topic
   * @deprecated RAQ backend migration never finalized
   */
  topic: Topic;
  /**
   * List topics
   * @deprecated RAQ backend migration never finalized
   */
  topics: TopicCollection;
  /** List ticket count broken down by subdomain, issue/topic name. */
  trendingIssuesAndTickets?: Maybe<TrendingIssuesWidgetData>;
  uniqueConstituentsReachedThroughCampaigns: FederatedReportUniqueConstituentsReached;
  /** Get universe */
  universe?: Maybe<Universe>;
  /** List universes */
  universes: UniverseCollection;
  userUpdateBatch: UserUpdateBatch;
  /** List user update batches */
  userUpdateBatches: UserUpdateBatchCollection;
  /** Fetch an individual user upload */
  userUpload: UserUpload;
  /** Fetches all user uploads */
  userUploads: UserUploadCollection;
  /** Fetch an individual webform by id */
  webform: Webform;
  /** Fetches webforms */
  webforms: WebformCollection;
  zendeskApiUsers: ZendeskUserCollection;
  /** Get a single zendesk batch */
  zendeskBatch: ZendeskBatch;
  /** List batches */
  zendeskBatches: ZendeskBatchCollection;
  /** Get zendesk object */
  zendeskObject?: Maybe<ZendeskObject>;
  /** List zendesk objects */
  zendeskObjects: ZendeskObjectCollection;
  /** List response card sunshine records */
  zendeskResponseCards: ZendeskResponseCardCollection;
  /** Get ticket */
  zendeskTicket: Ticket;
  /** List Zendesk Ticket Fields */
  zendeskTicketFields: ZendeskTicketFieldCollection;
  /** Zendesk Ticket Form By Id */
  zendeskTicketForm: ZendeskTicketForm;
  /** List Zendesk Ticket Forms */
  zendeskTicketForms: ZendeskTicketFormCollection;
  /** List topics */
  zendeskTopics: ZendeskTopicCollection;
  /** Get user from admin-rails database, which contains zendesk users who are agents or admins */
  zendeskUser: User;
  /** Get user from zendesk via a user search */
  zendeskUserSearch?: Maybe<User>;
  /** List Users */
  zendeskUsers: UserCollection;
};


export type QuerySeDashboardArgs = {
  id: Scalars['ID'];
};


export type QuerySeDashboardsArgs = {
  input: CollectionInput;
};


export type QueryAdminsArgs = {
  filter?: Maybe<Scalars['JSON']>;
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
};


export type QueryAsyncBatchJobArgs = {
  id: Scalars['ID'];
};


export type QueryAsyncBatchJobsArgs = {
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
};


export type QueryAudienceListArgs = {
  id: Scalars['ID'];
};


export type QueryAudienceListsArgs = {
  isArchived?: Maybe<Scalars['Boolean']>;
  isDraft?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  query?: Maybe<Scalars['String']>;
};


export type QueryAuditLogsArgs = {
  filter?: Maybe<AuditLogFilter>;
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
};


export type QueryBatchArgs = {
  id: Scalars['ID'];
};


export type QueryBatchExecutionArgs = {
  id: Scalars['ID'];
};


export type QueryBatchExecutionsArgs = {
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
};


export type QueryBatchesArgs = {
  filter?: Maybe<BatchFilter>;
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
};


export type QueryBulkJobArgs = {
  id: Scalars['ID'];
};


export type QueryBulkJobBatchArgs = {
  id: Scalars['ID'];
};


export type QueryBulkJobsArgs = {
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  query: BulkJobsQueryInput;
};


export type QueryCampaignArgs = {
  id: Scalars['ID'];
};


export type QueryCampaignsArgs = {
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  query?: Maybe<Scalars['String']>;
  statusIn?: Maybe<Array<CampaignStatus>>;
  statusNotIn?: Maybe<Array<CampaignStatus>>;
};


export type QueryCohortArgs = {
  name: Scalars['String'];
};


export type QueryConstituentTagArgs = {
  id: Scalars['ID'];
};


export type QueryConstituentTagCategoriesArgs = {
  filter?: Maybe<ConstituentTagCategoryFilter>;
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
};


export type QueryConstituentTagCategoryArgs = {
  id: Scalars['ID'];
};


export type QueryConstituentTagsArgs = {
  filter?: Maybe<ConstituentTagFilter>;
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
};


export type QueryConstituentsReachedArgs = {
  attributes: FederatedReportWidgetInput;
};


export type QueryCurrentEditorArgs = {
  input: GetCurrentEditorInput;
};


export type QueryCustomerArgs = {
  subdomain: Scalars['ID'];
};


export type QueryCustomersArgs = {
  filter?: Maybe<CustomerFilter>;
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
};


export type QueryDiscoveryExportArgs = {
  id: Scalars['ID'];
};


export type QueryDiscoveryExportsArgs = {
  filter?: Maybe<Scalars['JSON']>;
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
};


export type QueryFederatedReportArgs = {
  id: Scalars['ID'];
};


export type QueryFederatedReportingBulkMailCampaignsArgs = {
  input: FederatedReportWidgetInput;
};


export type QueryFederatedReportsArgs = {
  input: CollectionInput;
};


export type QueryGetBatchByBatchTagArgs = {
  batchTag: Scalars['String'];
};


export type QueryMacroCloneArgs = {
  id: Scalars['ID'];
};


export type QueryMacroClonesArgs = {
  filter?: Maybe<Scalars['JSON']>;
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
};


export type QueryNewsletterSubscriptionsArgs = {
  attributes: FederatedReportWidgetInput;
};


export type QueryPhysicalMailerArgs = {
  jid: Scalars['ID'];
};


export type QueryPhysicalMailerTemplateArgs = {
  id: Scalars['ID'];
};


export type QueryPhysicalMailerTemplatesArgs = {
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
};


export type QueryPrintCommentsFetchArgs = {
  filter?: Maybe<PrintCommentFilter>;
  limit: Scalars['Int'];
  offset?: Maybe<Scalars['Int']>;
  sort?: Maybe<PrintCommentSort>;
};


export type QueryPrintJobsArgs = {
  filter?: Maybe<PrintJobFilter>;
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  sort?: Maybe<PrintJobSort>;
};


export type QueryPrintQueueJobFetchArgs = {
  id: Scalars['ID'];
};


export type QueryPrintQueueJobsFetchArgs = {
  filter?: Maybe<PrintQueueJobFilter>;
  limit: Scalars['Int'];
  offset?: Maybe<Scalars['Int']>;
  sort?: Maybe<PrintQueueJobSort>;
};


export type QueryPrintableCommentArgs = {
  id: Scalars['ID'];
};


export type QueryPrintableCommentsArgs = {
  filter?: Maybe<PrintableCommentFilter>;
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  sort?: Maybe<PrintableCommentSort>;
};


export type QueryResponseArgs = {
  id: Scalars['ID'];
};


export type QueryResponseCardArgs = {
  id: Scalars['ID'];
};


export type QueryResponseCardsArgs = {
  filter?: Maybe<Scalars['JSON']>;
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
};


export type QueryResponsesArgs = {
  filter?: Maybe<ResponseFilter>;
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  sort?: Maybe<ResponseSort>;
};


export type QuerySeRecordArgs = {
  id: Scalars['ID'];
};


export type QuerySeRecordStatusArgs = {
  id: Scalars['ID'];
};


export type QuerySeRecordsArgs = {
  input: CollectionInput;
  seDashboardID: Scalars['ID'];
};


export type QueryServicesProvidedArgs = {
  attributes: FederatedReportWidgetInput;
};


export type QuerySideConversationArgs = {
  id: Scalars['ID'];
};


export type QuerySideConversationsArgs = {
  parentTicketId?: Maybe<Scalars['String']>;
};


export type QuerySparkpostIpPoolArgs = {
  id: Scalars['ID'];
};


export type QuerySparkpostIpPoolsArgs = {
  ids?: Maybe<Array<Scalars['ID']>>;
};


export type QuerySubdomainArgs = {
  name: Scalars['String'];
};


export type QuerySubdomainsFetchByDashboardIdArgs = {
  id: Scalars['ID'];
};


export type QuerySurveyArgs = {
  id: Scalars['ID'];
};


export type QuerySurveysArgs = {
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
};


export type QueryTagArgs = {
  id: Scalars['ID'];
};


export type QueryTagsArgs = {
  filter?: Maybe<TagFilter>;
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
};


export type QueryTicketCountMatchingTriggerArgs = {
  input: TicketCountMatchingTriggerInput;
};


export type QueryTicketResponseTimeArgs = {
  attributes: FederatedReportWidgetInput;
};


export type QueryTopicArgs = {
  id: Scalars['ID'];
};


export type QueryTopicsArgs = {
  filter?: Maybe<TopicFilter>;
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
};


export type QueryTrendingIssuesAndTicketsArgs = {
  attributes: FederatedReportWidgetInput;
};


export type QueryUniqueConstituentsReachedThroughCampaignsArgs = {
  input: FederatedReportWidgetInput;
};


export type QueryUniverseArgs = {
  id: Scalars['ID'];
};


export type QueryUniversesArgs = {
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
};


export type QueryUserUpdateBatchArgs = {
  id: Scalars['ID'];
};


export type QueryUserUpdateBatchesArgs = {
  filter?: Maybe<Scalars['JSON']>;
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
};


export type QueryUserUploadArgs = {
  id: Scalars['Int'];
};


export type QueryUserUploadsArgs = {
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  query?: Maybe<Scalars['String']>;
};


export type QueryWebformArgs = {
  id: Scalars['ID'];
};


export type QueryWebformsArgs = {
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  query?: Maybe<WebformsQueryInput>;
};


export type QueryZendeskApiUsersArgs = {
  emails?: Maybe<Array<Scalars['String']>>;
  externalIds?: Maybe<Array<Scalars['ID']>>;
  ids?: Maybe<Array<Scalars['ID']>>;
  subdomain: Scalars['String'];
};


export type QueryZendeskBatchArgs = {
  id: Scalars['ID'];
};


export type QueryZendeskBatchesArgs = {
  filter?: Maybe<ZendeskBatchFilter>;
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  sort?: Maybe<ZendeskBatchSort>;
};


export type QueryZendeskObjectArgs = {
  id: Scalars['ID'];
  type: Scalars['String'];
};


export type QueryZendeskObjectsArgs = {
  filter?: Maybe<Scalars['JSON']>;
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
};


export type QueryZendeskResponseCardsArgs = {
  filter?: Maybe<ZendeskResponseCardFilter>;
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
};


export type QueryZendeskTicketArgs = {
  id: Scalars['ID'];
};


export type QueryZendeskTicketFieldsArgs = {
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
};


export type QueryZendeskTicketFormArgs = {
  id: Scalars['ID'];
};


export type QueryZendeskTicketFormsArgs = {
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
};


export type QueryZendeskTopicsArgs = {
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
};


export type QueryZendeskUserArgs = {
  id: Scalars['ID'];
};


export type QueryZendeskUserSearchArgs = {
  query: Scalars['String'];
};


export type QueryZendeskUsersArgs = {
  filter?: Maybe<UserFilter>;
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
};

export type ReplyToSideConversationInput = {
  existingAttachments?: Maybe<Array<OldAttachmentInput>>;
  from?: Maybe<SideConversationParticipantInput>;
  isEmailReply: Scalars['Boolean'];
  message: Scalars['String'];
  newAttachments?: Maybe<Array<NewAttachmentInput>>;
  sideConversationId: Scalars['String'];
  to: Array<SideConversationParticipantInput>;
};

/** Warning: Deprecated - RAQ backend migration never finalized */
export type Response = {
  __typename?: 'Response';
  active: Scalars['Boolean'];
  /** @deprecated RAQ backend migration never finalized */
  batches?: Maybe<Array<Batch>>;
  /** @deprecated RAQ backend migration never finalized */
  comments: Array<Comment>;
  constituentMessage?: Maybe<Scalars['String']>;
  contentHtml: Scalars['String'];
  contentText: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  /** Last viewed timestamp by current user */
  lastViewedAt?: Maybe<Scalars['ISO8601DateTime']>;
  primer: PrimerComparison;
  responseCard?: Maybe<ResponseCard>;
  /** @deprecated RAQ backend migration never finalized */
  tags: Array<Tag>;
  title: Scalars['String'];
  /** @deprecated RAQ backend migration never finalized */
  topic?: Maybe<Topic>;
  /** Number of unread comments by current user */
  unreadCommentsCount: Scalars['Int'];
  updatedAt: Scalars['ISO8601DateTime'];
  usage_1h?: Maybe<Scalars['Int']>;
  usage_7d?: Maybe<Scalars['Int']>;
  usage_24h?: Maybe<Scalars['Int']>;
  usage_30d?: Maybe<Scalars['Int']>;
  versions: VersionCollection;
  /** @deprecated RAQ backend migration never finalized */
  views: Array<ResponseView>;
  zendeskMacro?: Maybe<ZendeskMacro>;
  zendeskMacroId?: Maybe<Scalars['ID']>;
};


/** Warning: Deprecated - RAQ backend migration never finalized */
export type ResponseVersionsArgs = {
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
};

/** Attributes for creating or updating a response */
export type ResponseAttributes = {
  /** Is the response active */
  active?: Maybe<Scalars['Boolean']>;
  /** Batch IDs to be associated */
  batchIds?: Maybe<Array<Scalars['ID']>>;
  /** Text content for the constituent message */
  constituentMessage?: Maybe<Scalars['String']>;
  /** HTML content for the response */
  contentHtml?: Maybe<Scalars['String']>;
  /** Text content for the response */
  contentText?: Maybe<Scalars['String']>;
  /** Tag IDs to be associated */
  tagIds?: Maybe<Array<Scalars['ID']>>;
  /** Title for the response */
  title?: Maybe<Scalars['String']>;
  /** Topic ID to be associated */
  topicId?: Maybe<Scalars['ID']>;
};

export type ResponseCard = {
  __typename?: 'ResponseCard';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  lastMovedAt?: Maybe<Scalars['ISO8601DateTime']>;
  position: Scalars['Int'];
  /** @deprecated RAQ backend migration never finalized */
  response?: Maybe<Response>;
  responseColumn: ResponseColumn;
  sunshineCard?: Maybe<SunshineObject>;
  updatedAt: Scalars['ISO8601DateTime'];
  versions: VersionCollection;
};


export type ResponseCardVersionsArgs = {
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
};

/** Autogenerated input type of ResponseCardDelete */
export type ResponseCardDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  hardDelete?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of ResponseCardDelete. */
export type ResponseCardDeletePayload = {
  __typename?: 'ResponseCardDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Error>>;
  responseCard?: Maybe<ResponseCard>;
};

/** Autogenerated input type of ResponseCardMove */
export type ResponseCardMoveInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  columnId: Scalars['ID'];
  id: Scalars['ID'];
  position?: Maybe<Scalars['Int']>;
};

/** Autogenerated return type of ResponseCardMove. */
export type ResponseCardMovePayload = {
  __typename?: 'ResponseCardMovePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Error>>;
  responseCard?: Maybe<ResponseCard>;
  responseColumns: Array<ResponseColumn>;
};

export type ResponseCollection = {
  __typename?: 'ResponseCollection';
  collection: Array<Response>;
  facets: ResponseFacet;
  metadata: CollectionMetadata;
};

export type ResponseColumn = {
  __typename?: 'ResponseColumn';
  cards: Array<ResponseCard>;
  createdAt: Scalars['ISO8601DateTime'];
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  penultimate: Scalars['Boolean'];
  position?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Attributes for creating or updating columns */
export type ResponseColumnAttributes = {
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of ResponseColumnsUpdate */
export type ResponseColumnsUpdateInput = {
  attributes: Array<ResponseColumnAttributes>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of ResponseColumnsUpdate. */
export type ResponseColumnsUpdatePayload = {
  __typename?: 'ResponseColumnsUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Error>>;
  responseColumns?: Maybe<Array<ResponseColumn>>;
};

/** Autogenerated input type of ResponseCommentCreate */
export type ResponseCommentCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  comment: Scalars['String'];
  responseId: Scalars['ID'];
};

/** Autogenerated return type of ResponseCommentCreate. */
export type ResponseCommentCreatePayload = {
  __typename?: 'ResponseCommentCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  comment?: Maybe<Comment>;
  errors?: Maybe<Array<Error>>;
  response?: Maybe<Response>;
};

/** Autogenerated input type of ResponseCommentUpdate */
export type ResponseCommentUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  comment: Scalars['String'];
  commentId: Scalars['ID'];
  responseId: Scalars['ID'];
};

/** Autogenerated return type of ResponseCommentUpdate. */
export type ResponseCommentUpdatePayload = {
  __typename?: 'ResponseCommentUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  comment?: Maybe<Comment>;
  errors?: Maybe<Array<Error>>;
  response?: Maybe<Response>;
};

/** Autogenerated input type of ResponseCreate */
export type ResponseCreateInput = {
  /** Add response to the approval queue */
  addToBoard?: Maybe<Scalars['Boolean']>;
  attributes: ResponseAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of ResponseCreate. */
export type ResponseCreatePayload = {
  __typename?: 'ResponseCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Error>>;
  response?: Maybe<Response>;
};

/** Autogenerated input type of ResponseDelete */
export type ResponseDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of ResponseDelete. */
export type ResponseDeletePayload = {
  __typename?: 'ResponseDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Error>>;
  response?: Maybe<Response>;
};

export type ResponseFacet = {
  __typename?: 'ResponseFacet';
  tags: Array<Facet>;
  topics: Array<Facet>;
};

export type ResponseFilter = {
  activeEq?: Maybe<Scalars['Boolean']>;
  contentHtmlCont?: Maybe<Scalars['String']>;
  contentTextCont?: Maybe<Scalars['String']>;
  hasUsage?: Maybe<UsageEnum>;
  idEq?: Maybe<Scalars['ID']>;
  missingUsage?: Maybe<UsageEnum>;
  tagsIdEq?: Maybe<Scalars['ID']>;
  tagsNameCont?: Maybe<Scalars['String']>;
  tagsSlugCont?: Maybe<Scalars['String']>;
  titleCont?: Maybe<Scalars['String']>;
  titleEq?: Maybe<Scalars['String']>;
  titleOrContentTextCont?: Maybe<Scalars['String']>;
  topicIdBlank?: Maybe<Scalars['Boolean']>;
  topicIdEq?: Maybe<Scalars['ID']>;
  topicNameCont?: Maybe<Scalars['String']>;
  topicSlugCont?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of ResponseProgressApproval */
export type ResponseProgressApprovalInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of ResponseProgressApproval. */
export type ResponseProgressApprovalPayload = {
  __typename?: 'ResponseProgressApprovalPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Error>>;
  response?: Maybe<Response>;
};

export type ResponseSort = {
  field: ResponsesSortFieldEnum;
  order: SortOrderEnum;
};

/** Autogenerated input type of ResponseUpdate */
export type ResponseUpdateInput = {
  attributes: ResponseAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Progress the response to the approved column */
  finalizeApproval?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  /** Progress the response to the next column */
  progressApproval?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated return type of ResponseUpdate. */
export type ResponseUpdatePayload = {
  __typename?: 'ResponseUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Error>>;
  response?: Maybe<Response>;
};

/** Warning: Deprecated - RAQ backend migration never finalized */
export type ResponseView = {
  __typename?: 'ResponseView';
  actor?: Maybe<User>;
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  updatedAt: Scalars['ISO8601DateTime'];
  zendeskUserId: Scalars['ID'];
};

/** Autogenerated input type of ResponseViewUpdate */
export type ResponseViewUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  responseId: Scalars['ID'];
};

/** Autogenerated return type of ResponseViewUpdate. */
export type ResponseViewUpdatePayload = {
  __typename?: 'ResponseViewUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Error>>;
  view?: Maybe<ResponseView>;
};

export enum ResponsesSortFieldEnum {
  CreatedAt = 'createdAt',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

export enum ResultEnum {
  Error = 'error',
  Fail = 'fail',
  Pass = 'pass',
  Warning = 'warning'
}

export enum RetentionPeriodOption {
  D_2 = 'd_2',
  D_7 = 'd_7',
  D_30 = 'd_30',
  Forever = 'forever',
  H_24 = 'h_24',
  H_48 = 'h_48',
  M_6 = 'm_6',
  Qa = 'qa',
  RetentionPeriodD_2 = 'retention_period_d_2',
  RetentionPeriodD_7 = 'retention_period_d_7',
  RetentionPeriodD_30 = 'retention_period_d_30',
  RetentionPeriodForever = 'retention_period_forever',
  RetentionPeriodH_24 = 'retention_period_h_24',
  RetentionPeriodH_48 = 'retention_period_h_48',
  RetentionPeriodM_6 = 'retention_period_m_6',
  RetentionPeriodQa = 'retention_period_qa',
  RetentionPeriodW_1 = 'retention_period_w_1',
  RetentionPeriodY_1 = 'retention_period_y_1',
  RetentionPeriodY_2 = 'retention_period_y_2',
  RetentionPeriodY_5 = 'retention_period_y_5',
  W_1 = 'w_1',
  Y_1 = 'y_1',
  Y_2 = 'y_2',
  Y_5 = 'y_5'
}

/** S3 object from aws simple store service */
export type S3Object = {
  __typename?: 'S3Object';
  /** Entity tag (most likely a MD5 digest) for the object */
  etag: Scalars['String'];
  /** Full file name with file extension */
  fileName: Scalars['String'];
  /** Name of the object */
  name: Scalars['String'];
};

export type SeDashBoardsCollection = Collection & {
  __typename?: 'SEDashBoardsCollection';
  metadata: CollectionMetadata;
  seDashboards: Array<Maybe<SeDashboard>>;
};

export type SeDashboard = {
  __typename?: 'SEDashboard';
  allowAdvancedOptions: Scalars['Boolean'];
  cohort: Cohort;
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  seDashboardUsers: Array<SeDashboardUser>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type SeDashboardUser = {
  __typename?: 'SEDashboardUser';
  createdAt: Scalars['ISO8601DateTime'];
  email: Scalars['String'];
  id: Scalars['ID'];
  okatUserId?: Maybe<Scalars['String']>;
  seDashboards: Array<SeDashboard>;
  syncedToOkta?: Maybe<Scalars['Boolean']>;
  updatedAt: Scalars['ISO8601DateTime'];
  zendeskUserId?: Maybe<Scalars['String']>;
};

export enum SePrefectJobStatus {
  Cancelled = 'cancelled',
  Cancelling = 'cancelling',
  Completed = 'completed',
  Crashed = 'crashed',
  Failed = 'failed',
  NoTickets = 'no_tickets',
  Paused = 'paused',
  Pending = 'pending',
  Running = 'running',
  Scheduled = 'scheduled'
}

export enum SeQueryCronStatus {
  Finished = 'finished',
  InProgress = 'in_progress',
  Queued = 'queued'
}

export type SeRecord = {
  __typename?: 'SERecord';
  createdAt: Scalars['ISO8601DateTime'];
  creator?: Maybe<SeDashboardUser>;
  endDate: Scalars['ISO8601DateTime'];
  holdResults: Scalars['Boolean'];
  id: Scalars['ID'];
  jobStatus: SeRecordJobStatus;
  name: Scalars['String'];
  options?: Maybe<SearchOptions>;
  previewCount?: Maybe<Scalars['Int']>;
  rawSearchQueries: Array<Maybe<Scalars['JSON']>>;
  s3Location?: Maybe<Scalars['String']>;
  seDashboard: SeDashboard;
  seSearchQueries: Array<Maybe<SeSearchQuery>>;
  startDate: Scalars['ISO8601DateTime'];
  subdomains: Array<Maybe<Subdomain>>;
  updatedAt: Scalars['ISO8601DateTime'];
  zdTicketRetentions?: Maybe<Array<Maybe<ZdTicketRetention>>>;
};

export type SeRecordCreateInput = {
  dashboardId: Scalars['ID'];
  endDate: Scalars['ISO8601DateTime'];
  excludeQuery?: Maybe<SearchQueryInput>;
  holdResults: Scalars['Boolean'];
  name: Scalars['String'];
  options?: Maybe<SearchOptionsInput>;
  searchQueries: Array<SearchQueryInput>;
  startDate: Scalars['ISO8601DateTime'];
  subdomains: Array<Scalars['String']>;
  useNewSearchExport?: Maybe<Scalars['Boolean']>;
};

export enum SeRecordJobStatus {
  Created = 'created',
  Done = 'done',
  Failed = 'failed',
  MarkedAsFailed = 'marked_as_failed',
  NoTickets = 'no_tickets',
  Prefect = 'prefect',
  Processing = 'processing',
  Queued = 'queued'
}

export type SeRecordsCollection = Collection & {
  __typename?: 'SERecordsCollection';
  metadata: CollectionMetadata;
  seRecords: Array<Maybe<SeRecord>>;
};

export type SeSearchQuery = {
  __typename?: 'SESearchQuery';
  createdAt: Scalars['ISO8601DateTime'];
  cronStatus: SeQueryCronStatus;
  id: Scalars['ID'];
  isPreview: Scalars['Boolean'];
  prefectJobId?: Maybe<Scalars['String']>;
  prefectJobStatus: SePrefectJobStatus;
  seRecord: SeRecord;
  subdomain: Subdomain;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Autogenerated input type of SearchApplyMacro */
export type SearchApplyMacroInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  macroId: Scalars['ID'];
  query: Scalars['String'];
};

/** Autogenerated return type of SearchApplyMacro. */
export type SearchApplyMacroPayload = {
  __typename?: 'SearchApplyMacroPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  jobs?: Maybe<Array<TicketJob>>;
  numAppliedTickets: Scalars['String'];
  numPrintQueue: Scalars['String'];
  ticketIds: Array<Scalars['ID']>;
};

export type SearchOptions = {
  __typename?: 'SearchOptions';
  includeMetadata?: Maybe<Scalars['Boolean']>;
  includeSideConversations?: Maybe<Scalars['Boolean']>;
  includeTicketDetails?: Maybe<Scalars['Boolean']>;
};

export type SearchOptionsInput = {
  includeMetadata?: Maybe<Scalars['Boolean']>;
  includeSideConversations?: Maybe<Scalars['Boolean']>;
  includeTicketDetails?: Maybe<Scalars['Boolean']>;
};

export type SearchQueryInput = {
  parameters: Array<SearchQueryParameter>;
};

export enum SearchQueryOption {
  Assignee = 'assignee',
  Keyword = 'keyword',
  Participant = 'participant',
  Requester = 'requester'
}

export type SearchQueryParameter = {
  type: SearchQueryOption;
  value: Scalars['String'];
};

export type ServicesProvidedWidget = {
  __typename?: 'ServicesProvidedWidget';
  ticketCountByAgency?: Maybe<Array<AgencyTicketCount>>;
  ticketCountByAgencySubdomain?: Maybe<Array<SubdomainCaseworkTicketCount>>;
  totalCaseworkTicketsCount?: Maybe<Scalars['Int']>;
};

export type SideConversation = {
  __typename?: 'SideConversation';
  createdAt: Scalars['ISO8601DateTime'];
  createdBy: Scalars['String'];
  hasNewMessage?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  lastMessageAt?: Maybe<Scalars['ISO8601DateTime']>;
  messages: Array<SideConversationMessage>;
  mostRecentMessage?: Maybe<SideConversationMessage>;
  parentTicketId: Scalars['String'];
  subdomain?: Maybe<Subdomain>;
  subject?: Maybe<Scalars['String']>;
  ticketId: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type SideConversationCollection = Collection & {
  __typename?: 'SideConversationCollection';
  collection: Array<SideConversation>;
  metadata: CollectionMetadata;
};

export type SideConversationMessage = {
  __typename?: 'SideConversationMessage';
  attachments?: Maybe<Array<Attachment>>;
  commentId: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  createdBy: SideConversationParticipant;
  error?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isRead?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  messageStatus: MessageStatus;
  messageType: MessageType;
  recipients: Array<SideConversationParticipant>;
  sentAt: Scalars['ISO8601DateTime'];
  updatedBy?: Maybe<SideConversationParticipant>;
};

export type SideConversationParticipant = {
  __typename?: 'SideConversationParticipant';
  createdAt: Scalars['ISO8601DateTime'];
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  zendeskId?: Maybe<Scalars['String']>;
};

export type SideConversationParticipantInput = {
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  zendeskId?: Maybe<Scalars['String']>;
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export enum SortOrderEnum {
  Asc = 'asc',
  Desc = 'desc'
}

export type SparkpostIp = {
  __typename?: 'SparkpostIp';
  auto_warmup_enabled: Scalars['Boolean'];
  auto_warmup_stage?: Maybe<Scalars['Int']>;
  external_ip: Scalars['String'];
  hostname: Scalars['String'];
};

export type SparkpostIpPool = {
  __typename?: 'SparkpostIpPool';
  auto_warmup_overflow_pool?: Maybe<Scalars['String']>;
  fbl_signing_domain?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  ips?: Maybe<Array<Maybe<SparkpostIp>>>;
  metrics: IpPoolMetrics;
  name: Scalars['String'];
  signing_domain?: Maybe<Scalars['String']>;
};


export type SparkpostIpPoolMetricsArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};

export type SparkpostIpPoolCreateInput = {
  assign_ip_from_pool?: Maybe<Scalars['String']>;
  auto_warmup_overflow_pool?: Maybe<Scalars['String']>;
  fbl_signing_domain?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type SparkpostIpPoolCreateResponse = {
  __typename?: 'SparkpostIpPoolCreateResponse';
  id: Scalars['ID'];
};

export type SparkpostIpPoolDeleteResponse = {
  __typename?: 'SparkpostIpPoolDeleteResponse';
  success: Scalars['Boolean'];
};

export type SparkpostIpPoolUpdateResponse = {
  __typename?: 'SparkpostIpPoolUpdateResponse';
  success: Scalars['Boolean'];
};

export type SparkpostIpUpdateInput = {
  auto_warmup_enabled?: Maybe<Scalars['Boolean']>;
  /**
   * This property can only be used to force the IP into a lower warmup stage, not a higher one.
   * Hence, the provided integer needs to be lower than the current stage.
   */
  auto_warmup_stage?: Maybe<Scalars['Int']>;
  external_ip: Scalars['String'];
  ip_pool?: Maybe<Scalars['ID']>;
};

export type Subdomain = {
  __typename?: 'Subdomain';
  bulkEmail?: Maybe<Scalars['String']>;
  bulkEmailReply?: Maybe<Scalars['String']>;
  bulkMailUnsubscribeLinkText?: Maybe<Scalars['String']>;
  bulkReturnPath?: Maybe<Scalars['String']>;
  cohort?: Maybe<Cohort>;
  name: Scalars['String'];
  proactiveMailPool?: Maybe<Scalars['String']>;
};

export type SubdomainCaseworkTicketCount = {
  __typename?: 'SubdomainCaseworkTicketCount';
  agencyCounts?: Maybe<Array<AgencyTicketCount>>;
  subdomain?: Maybe<Scalars['String']>;
};

export type SubdomainEmailUpdateInput = {
  bulkEmail?: Maybe<Scalars['String']>;
  bulkEmailReply?: Maybe<Scalars['String']>;
  bulkReturnPath?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type SubdomainNormalizeInput = {
  name: Scalars['String'];
  startDate?: Maybe<Scalars['ISO8601DateTime']>;
};

export type SubdomainTicketResponseTime = {
  __typename?: 'SubdomainTicketResponseTime';
  caseworkAveResponseSecs?: Maybe<Scalars['Int']>;
  correspondenceAveResponseSecs?: Maybe<Scalars['Int']>;
  subdomainName?: Maybe<Scalars['String']>;
};

export type SubdomainUpdateBulkMailUnsubscribeLinkInput = {
  name: Scalars['ID'];
  unsubscribeLinkText?: Maybe<Scalars['String']>;
};

export type SubdomainUpdateProactivePoolInput = {
  name: Scalars['ID'];
  proactiveMailPool?: Maybe<Scalars['String']>;
};

export type SunshineObject = {
  __typename?: 'SunshineObject';
  attributes?: Maybe<Scalars['JSON']>;
  createdAt: Scalars['ISO8601DateTime'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  type?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type SupportOrganization = {
  __typename?: 'SupportOrganization';
  caseworkTeamContactFrequency?: Maybe<Scalars['String']>;
  commsDirectorContactFrequency?: Maybe<Scalars['String']>;
  dcOfficeSentiment?: Maybe<Scalars['String']>;
  districtOfficeSentimentScore?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  keyRelationshipsPersonnelNotes?: Maybe<Scalars['String']>;
  lcLaContactFrequency?: Maybe<Scalars['String']>;
  payload?: Maybe<Scalars['JSON']>;
  productFriction?: Maybe<Scalars['String']>;
  productionUrl?: Maybe<Scalars['String']>;
  uniqueProductConfigurationsNotes?: Maybe<Scalars['String']>;
  zendeskId?: Maybe<Scalars['String']>;
};

export type Survey = {
  __typename?: 'Survey';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  /** A published survey may no longer be updated */
  isPublished: Scalars['Boolean'];
  publishedAt?: Maybe<Scalars['ISO8601DateTime']>;
  questions: Array<SurveyQuestion>;
  /** Lead in phrase or question for the survey in email */
  teaser?: Maybe<Scalars['String']>;
  /** Human friendly identifier for internal use */
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type SurveyAnswer = {
  __typename?: 'SurveyAnswer';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  surveyQuestion: SurveyQuestion;
  surveyResponse: SurveyResponse;
  updatedAt: Scalars['ISO8601DateTime'];
  value?: Maybe<Scalars['String']>;
};

/** Attributes for creating a survey response answer */
export type SurveyAnswerAttributes = {
  slug: Scalars['ID'];
  value: Scalars['String'];
};

/** Attributes for creating or updating a survey */
export type SurveyAttributes = {
  /** Sets survey as "published". Warning: it is (intentionally) not possible to undo this action */
  published?: Maybe<Scalars['Boolean']>;
  /** Survey questions */
  questions?: Maybe<Array<SurveyQuestionAttributes>>;
  /** Text header of the survey in the email */
  teaser?: Maybe<Scalars['String']>;
  /** Title of the survey */
  title?: Maybe<Scalars['String']>;
};

export type SurveyCollection = {
  __typename?: 'SurveyCollection';
  collection: Array<Survey>;
  metadata: CollectionMetadata;
};

/** Autogenerated input type of SurveyCreate */
export type SurveyCreateInput = {
  attributes: SurveyAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of SurveyCreate. */
export type SurveyCreatePayload = {
  __typename?: 'SurveyCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Error>>;
  survey?: Maybe<Survey>;
};

/** Survey Question */
export type SurveyQuestion = {
  __typename?: 'SurveyQuestion';
  id: Scalars['ID'];
  /** Possible answers */
  options?: Maybe<Array<SurveyQuestionOption>>;
  /** Question text */
  query: Scalars['String'];
  slug: Scalars['ID'];
  /** Summarized responses */
  summary?: Maybe<SurveyQuestionSummary>;
};

/** Attributes for creating or updating a survey question */
export type SurveyQuestionAttributes = {
  id?: Maybe<Scalars['ID']>;
  /** Answer Options */
  options?: Maybe<Array<SurveyQuestionOptionAttributes>>;
  /** Question text */
  query?: Maybe<Scalars['String']>;
};

/** A possible answer to a survey question and its associated tag (if it has one) */
export type SurveyQuestionOption = {
  __typename?: 'SurveyQuestionOption';
  tag?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Attributes for creating survey question option */
export type SurveyQuestionOptionAttributes = {
  /** User tag associated with the option */
  tag?: Maybe<Scalars['String']>;
  /** Option text */
  value: Scalars['String'];
};

/** An aggregated tally of responses */
export type SurveyQuestionSummary = {
  __typename?: 'SurveyQuestionSummary';
  counts: Array<SurveyQuestionSummaryOption>;
  /** Total number of question responses */
  total: Scalars['Int'];
};

export type SurveyQuestionSummaryOption = {
  __typename?: 'SurveyQuestionSummaryOption';
  count: Scalars['Int'];
  value: Scalars['String'];
};

export type SurveyResponse = {
  __typename?: 'SurveyResponse';
  createdAt: Scalars['ISO8601DateTime'];
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isSynced: Scalars['Boolean'];
  survey: Survey;
  surveyAnswers: Array<SurveyAnswer>;
  updatedAt: Scalars['ISO8601DateTime'];
  zendeskId?: Maybe<Scalars['Int']>;
  zendeskSyncedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** Attributes for creating a response to a survey */
export type SurveyResponseAttributes = {
  address1: Scalars['String'];
  address2?: Maybe<Scalars['String']>;
  answers: Array<SurveyAnswerAttributes>;
  city: Scalars['String'];
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  state: Scalars['String'];
  zipcode: Scalars['String'];
};

/** Autogenerated input type of SurveyResponseCreate */
export type SurveyResponseCreateInput = {
  attributes: SurveyResponseAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of SurveyResponseCreate. */
export type SurveyResponseCreatePayload = {
  __typename?: 'SurveyResponseCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  surveyResponse: SurveyResponse;
};

/** Autogenerated input type of SurveyUpdate */
export type SurveyUpdateInput = {
  attributes: SurveyAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of SurveyUpdate. */
export type SurveyUpdatePayload = {
  __typename?: 'SurveyUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Error>>;
  survey?: Maybe<Survey>;
};

/** Warning: Deprecated - RAQ backend migration never finalized */
export type Tag = {
  __typename?: 'Tag';
  createdAt: Scalars['ISO8601DateTime'];
  default: Scalars['Boolean'];
  id: Scalars['ID'];
  legacySlug?: Maybe<Scalars['String']>;
  /** Metrics for the zendesk tag used for this tag */
  metrics?: Maybe<TagMetrics>;
  name: Scalars['String'];
  primer: PrimerComparison;
  slug: Scalars['String'];
  ticketCount: Scalars['Int'];
  topic?: Maybe<Topic>;
  topicId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['ISO8601DateTime'];
  zendeskFieldOptionId?: Maybe<Scalars['ID']>;
};

/** Attributes for creating or updating a tag */
export type TagAttributes = {
  /** Name of the tag */
  name: Scalars['String'];
  /** Topic for the tag tag */
  topicId: Scalars['ID'];
};

export type TagCollection = {
  __typename?: 'TagCollection';
  collection: Array<Tag>;
  facets: TagFacet;
  metadata: CollectionMetadata;
};

/** Autogenerated input type of TagCreate */
export type TagCreateInput = {
  attributes: TagAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of TagCreate. */
export type TagCreatePayload = {
  __typename?: 'TagCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Error>>;
  tag?: Maybe<Tag>;
};

/** Autogenerated input type of TagDelete */
export type TagDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of TagDelete. */
export type TagDeletePayload = {
  __typename?: 'TagDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Error>>;
  tag?: Maybe<Tag>;
};

export type TagFacet = {
  __typename?: 'TagFacet';
  topics: Array<Facet>;
};

export type TagFilter = {
  idEq?: Maybe<Scalars['ID']>;
  nameCont?: Maybe<Scalars['String']>;
  nameEq?: Maybe<Scalars['String']>;
  slugCont?: Maybe<Scalars['String']>;
  slugEq?: Maybe<Scalars['String']>;
  topicIdBlank?: Maybe<Scalars['Boolean']>;
  topicIdEq?: Maybe<Scalars['ID']>;
  topicNameCont?: Maybe<Scalars['String']>;
  topicSlugCont?: Maybe<Scalars['String']>;
};

export type TagMetrics = {
  __typename?: 'TagMetrics';
  medianDate?: Maybe<Scalars['ISO8601DateTime']>;
  numTicketsGteSolved?: Maybe<Scalars['Int']>;
  numTicketsLtSolved?: Maybe<Scalars['Int']>;
  numTicketsOpen?: Maybe<Scalars['Int']>;
  numTicketsTotal?: Maybe<Scalars['Int']>;
  oldestDate?: Maybe<Scalars['ISO8601DateTime']>;
};

/** Autogenerated input type of TagUpdate */
export type TagUpdateInput = {
  attributes: TagAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of TagUpdate. */
export type TagUpdatePayload = {
  __typename?: 'TagUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Error>>;
  tag?: Maybe<Tag>;
};

/** Attributes for a template */
export type Template = {
  /** File name of template */
  fileName: Scalars['String'];
  /** Type of template */
  type: Scalars['String'];
};

export type Ticket = {
  __typename?: 'Ticket';
  agency?: Maybe<Scalars['String']>;
  assignee?: Maybe<User>;
  assigneeId?: Maybe<Scalars['String']>;
  batch?: Maybe<Scalars['String']>;
  comments?: Maybe<Array<ZendeskTicketComment>>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  customFields?: Maybe<Array<TicketCustomField>>;
  customTags?: Maybe<Scalars['JSON']>;
  cwcCampaignId?: Maybe<Scalars['String']>;
  form?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  outcome?: Maybe<Scalars['String']>;
  readableTags?: Maybe<Array<Tag>>;
  requester?: Maybe<User>;
  requesterId?: Maybe<Scalars['String']>;
  respondedAt?: Maybe<Scalars['ISO8601DateTime']>;
  status?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  ticketFormId?: Maybe<Scalars['String']>;
  ticketId?: Maybe<Scalars['String']>;
  topic?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type TicketAddBatchSuccess = {
  __typename?: 'TicketAddBatchSuccess';
  success: Scalars['Boolean'];
};

/** Autogenerated input type of TicketApplyMacro */
export type TicketApplyMacroInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Zendesk macro id */
  macroId: Scalars['ID'];
  /** Zendesk ticket id */
  ticketId: Scalars['ID'];
};

/** Autogenerated return type of TicketApplyMacro. */
export type TicketApplyMacroPayload = {
  __typename?: 'TicketApplyMacroPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  jobId: Scalars['String'];
};

export type TicketApplyResponseInput = {
  macroId: Scalars['ID'];
  ticketId: Scalars['ID'];
};

export type TicketApplyResponseSuccess = {
  __typename?: 'TicketApplyResponseSuccess';
  success: Scalars['Boolean'];
};

export type TicketAttachEmlInput = {
  ticketId: Scalars['ID'];
};

export type TicketAttachEmlSuccess = {
  __typename?: 'TicketAttachEmlSuccess';
  success: Scalars['Boolean'];
};

export type TicketCountMatchingResponse = {
  __typename?: 'TicketCountMatchingResponse';
  count: Scalars['Int'];
};

export type TicketCountMatchingTriggerInput = {
  triggerSearchParams: TriggerSearchParams;
};

export type TicketCustomField = {
  __typename?: 'TicketCustomField';
  id: Scalars['ID'];
  ticketFieldId: Scalars['String'];
  value?: Maybe<Scalars['JSON']>;
};

export type TicketJob = {
  __typename?: 'TicketJob';
  jobId: Scalars['String'];
  ticketId: Scalars['ID'];
};

/** Autogenerated input type of TicketNotifyRequester */
export type TicketNotifyRequesterInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  commentId: Scalars['ID'];
  /** looks for data here first before querying zendesk */
  meta?: Maybe<TicketNotifyRequesterMetaAttributes>;
  ticketId: Scalars['ID'];
};

/** Metadata attributes to avoid expensive lookups while processing a notify mutation */
export type TicketNotifyRequesterMetaAttributes = {
  assignee?: Maybe<TicketNotifyRequesterMetaUserAttributes>;
  requester?: Maybe<TicketNotifyRequesterMetaUserAttributes>;
  ticket?: Maybe<TicketNotifyRequesterMetaTicketAttributes>;
};

/** Ticket attributes to avoid expensive lookups */
export type TicketNotifyRequesterMetaTicketAttributes = {
  comment?: Maybe<TicketNotifyRequesterMetaTicketCommentAttributes>;
  subject?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
};

/** Ticket comment attributes to avoid expensive lookups */
export type TicketNotifyRequesterMetaTicketCommentAttributes = {
  /** html comment body override */
  htmlBody: Array<Scalars['String']>;
  /** plain comment body override */
  plainBody?: Maybe<Scalars['String']>;
};

/** Ticket attributes to avoid expensive lookups */
export type TicketNotifyRequesterMetaUserAttributes = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  /** Computed from first_name + last_name if not provided */
  name?: Maybe<Scalars['String']>;
  signature?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of TicketNotifyRequester. */
export type TicketNotifyRequesterPayload = {
  __typename?: 'TicketNotifyRequesterPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  jobId: Scalars['String'];
};

export enum TicketResolution {
  Closed = 'closed',
  Keptstatus = 'keptstatus',
  Solved = 'solved'
}

export type TicketResponseTime = {
  __typename?: 'TicketResponseTime';
  subdomainMetrics?: Maybe<Array<SubdomainTicketResponseTime>>;
};

export type TicketSearchByTriggerAddBatchInput = {
  batchValue: Scalars['String'];
  triggerSearchParams: TriggerSearchParams;
};

export type TicketSearchByTriggerApplyResponseInput = {
  macroId: Scalars['ID'];
  triggerSearchParams: TriggerSearchParams;
};

export type TicketUpdateInDatabaseInput = {
  assigneeId?: Maybe<Scalars['String']>;
  batchValue?: Maybe<Scalars['String']>;
  formType?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  ticketId: Scalars['String'];
};

export type TicketUpdateInDatabaseSuccess = {
  __typename?: 'TicketUpdateInDatabaseSuccess';
  success: Scalars['Boolean'];
};

/** Warning: Deprecated - RAQ backend migration never finalized */
export type Topic = {
  __typename?: 'Topic';
  batchesCount: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  default: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  legacySlug: Scalars['String'];
  name: Scalars['String'];
  primer: PrimerComparison;
  responsesCount: Scalars['Int'];
  slug: Scalars['String'];
  tagsCount: Scalars['Int'];
  updatedAt: Scalars['ISO8601DateTime'];
  zendeskFieldOptionId?: Maybe<Scalars['ID']>;
};

/** Attributes for creating or updating a topic */
export type TopicAttributes = {
  /** Name of the topic */
  name: Scalars['String'];
};

export type TopicCollection = {
  __typename?: 'TopicCollection';
  collection: Array<Topic>;
  metadata: CollectionMetadata;
};

/** Autogenerated input type of TopicCreate */
export type TopicCreateInput = {
  attributes: TopicAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of TopicCreate. */
export type TopicCreatePayload = {
  __typename?: 'TopicCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Error>>;
  topic?: Maybe<Topic>;
};

export type TopicFilter = {
  idEq?: Maybe<Scalars['ID']>;
  nameCont?: Maybe<Scalars['String']>;
  nameEq?: Maybe<Scalars['String']>;
  slugCont?: Maybe<Scalars['String']>;
  slugEq?: Maybe<Scalars['String']>;
};

export type TransactionalEmailSendInput = {
  body: Scalars['String'];
  /** Must be an email address in our domain i.e. indigov.com/.us */
  from?: Maybe<Scalars['String']>;
  /** If provided, will populate the reply-to header */
  replyTo?: Maybe<Scalars['String']>;
  subject: Scalars['String'];
  /** @deprecated(reason: Use `tos`.) */
  to?: Maybe<Scalars['String']>;
  tos?: Maybe<Array<Scalars['String']>>;
};

export type TransactionalEmailSendResponse = {
  __typename?: 'TransactionalEmailSendResponse';
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Get the count of tickets broken down by any ticket_field (ex: topic) */
export type TrendingIssuesCount = {
  __typename?: 'TrendingIssuesCount';
  issueName?: Maybe<Scalars['String']>;
  ticketCount?: Maybe<Scalars['Int']>;
};

/** Get the count of tickets broken down by any ticket_field (ex: topic) and subdomain */
export type TrendingIssuesCountBySubdomain = {
  __typename?: 'TrendingIssuesCountBySubdomain';
  issueCounts?: Maybe<Array<TrendingIssuesCount>>;
  subdomain?: Maybe<Scalars['String']>;
};

export type TrendingIssuesWidgetData = {
  __typename?: 'TrendingIssuesWidgetData';
  ticketCountByIssue?: Maybe<Array<TrendingIssuesCount>>;
  ticketCountByIssueAndSubdomain?: Maybe<Array<TrendingIssuesCountBySubdomain>>;
  totalTicketCount?: Maybe<Scalars['Int']>;
};

/** Autogenerated input type of TriggerCreateAutoBatch */
export type TriggerCreateAutoBatchInput = {
  batchId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  createOcrTrigger?: Maybe<Scalars['Boolean']>;
  /** Should we deactivate duplicates and replace them with this new trigger? */
  deactivateDuplicates?: Maybe<Scalars['Boolean']>;
  matchers: ZendeskTriggerMatchersAttributes;
};

/** Autogenerated return type of TriggerCreateAutoBatch. */
export type TriggerCreateAutoBatchPayload = {
  __typename?: 'TriggerCreateAutoBatchPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Error>>;
  trigger?: Maybe<ZendeskTrigger>;
};

/** Autogenerated input type of TriggerCreateAutoResponse */
export type TriggerCreateAutoResponseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  createOcrTrigger?: Maybe<Scalars['Boolean']>;
  /** Should we deactivate duplicates and replace them with this new trigger? */
  deactivateDuplicates?: Maybe<Scalars['Boolean']>;
  macroId: Scalars['ID'];
  matchers: ZendeskTriggerMatchersAttributes;
};

/** Autogenerated return type of TriggerCreateAutoResponse. */
export type TriggerCreateAutoResponsePayload = {
  __typename?: 'TriggerCreateAutoResponsePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Error>>;
  trigger?: Maybe<ZendeskTrigger>;
};

export enum TriggerMatchersTypeEnum {
  CommentIncludesWord = 'comment_includes_word',
  CwcCampaignId = 'cwc_campaign_id',
  SubjectIncludesWord = 'subject_includes_word'
}

export type TriggerSearchParams = {
  triggerId: Scalars['ID'];
  type: TriggerSearchType;
};

export enum TriggerSearchType {
  AutoBatch = 'autoBatch',
  AutoResponse = 'autoResponse'
}

export type Universe = {
  __typename?: 'Universe';
  appName: Scalars['String'];
  cardinality: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  csv?: Maybe<Blob>;
  dataSource: Scalars['String'];
  dateCreated: Scalars['ISO8601DateTime'];
  dateModified: Scalars['ISO8601DateTime'];
  estMailerUserCount?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  refresh: Scalars['Boolean'];
  updatedAt: Scalars['ISO8601DateTime'];
  username: Scalars['String'];
};

export type UniverseCollection = {
  __typename?: 'UniverseCollection';
  collection: Array<Universe>;
  metadata: CollectionMetadata;
};

/** Autogenerated input type of UniversesRefreshJob */
export type UniversesRefreshJobInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Download Universe CSVs from L2 */
  enableDownload?: Maybe<Scalars['Boolean']>;
  /** Sync Universes with L2 */
  enableSync?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated return type of UniversesRefreshJob. */
export type UniversesRefreshJobPayload = {
  __typename?: 'UniversesRefreshJobPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  jobId: Scalars['String'];
};

export type UpdateCustomerFactsInput = {
  /** Stringified JSON of data to store */
  data: Scalars['String'];
};

export type UpdateCustomerFactsResponse = {
  __typename?: 'UpdateCustomerFactsResponse';
  /** Stringified JSON representation */
  data?: Maybe<Scalars['String']>;
  error?: Maybe<GraphQlResponseError>;
};

export type UpdateSeDashboardInput = {
  dashboardUserEmails: Array<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UploadedUser = {
  __typename?: 'UploadedUser';
  createdAt: Scalars['ISO8601DateTime'];
  data?: Maybe<UploadedUserData>;
  error?: Maybe<Scalars['String']>;
  externalId: Scalars['ID'];
  id: Scalars['ID'];
  status: UploadedUserStatus;
  userUploadId: Scalars['Int'];
  zendeskId?: Maybe<Scalars['ID']>;
};

export type UploadedUserData = {
  __typename?: 'UploadedUserData';
  created_at?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  external_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  updated_at?: Maybe<Scalars['String']>;
};

export enum UploadedUserStatus {
  Created = 'created',
  Failed = 'failed',
  Queued = 'queued',
  Updated = 'updated'
}

export enum UsageEnum {
  Usage_1h = 'usage_1h',
  Usage_7d = 'usage_7d',
  Usage_24h = 'usage_24h',
  Usage_30d = 'usage_30d'
}

export type User = {
  __typename?: 'User';
  city?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  districtStatus?: Maybe<DistrictStatusEnum>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  groups?: Maybe<Array<UserGroup>>;
  homeAddressLineOne?: Maybe<Scalars['String']>;
  homeAddressLineTwo?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  payload?: Maybe<Scalars['JSON']>;
  phone?: Maybe<Scalars['String']>;
  photo?: Maybe<UserPhoto>;
  prefix?: Maybe<Scalars['String']>;
  rawTags?: Maybe<Array<Scalars['String']>>;
  state?: Maybe<Scalars['String']>;
  suffix?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<ConstituentTag>>;
  thumbnails?: Maybe<Array<UserPhoto>>;
  ticketsRequested?: Maybe<Array<Ticket>>;
  zendeskId?: Maybe<Scalars['ID']>;
  zipCode?: Maybe<Scalars['String']>;
};

/** Attributes for creating or updating a user */
export type UserAttributes = {
  /** Custom role id */
  customRoleId?: Maybe<Scalars['ID']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  /** Assigned group ids */
  groupIds?: Maybe<Array<Scalars['ID']>>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  /** Zendesk Role */
  role?: Maybe<Scalars['String']>;
  /** Is user suspended? */
  suspended?: Maybe<Scalars['Boolean']>;
  tags?: Maybe<Array<Scalars['String']>>;
  userFields?: Maybe<UserFields>;
};

export type UserCollection = {
  __typename?: 'UserCollection';
  collection: Array<User>;
  metadata: CollectionMetadata;
};

export type UserCounts = {
  __typename?: 'UserCounts';
  created: Scalars['Int'];
  failed: Scalars['Int'];
  queued: Scalars['Int'];
  updated: Scalars['Int'];
};

/** Autogenerated input type of UserDowngrade */
export type UserDowngradeInput = {
  attributes: UserAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  subdomain: Scalars['ID'];
};

/** Autogenerated return type of UserDowngrade. */
export type UserDowngradePayload = {
  __typename?: 'UserDowngradePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Error>>;
  user?: Maybe<User>;
};

export type UserFields = {
  city?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  homeAddressCity?: Maybe<Scalars['String']>;
  homeAddressCounty?: Maybe<Scalars['String']>;
  homeAddressLine1?: Maybe<Scalars['String']>;
  homeAddressLine2?: Maybe<Scalars['String']>;
  homeAddressState?: Maybe<Scalars['String']>;
  homeAddressZipCode?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  prefix?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  suffix?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type UserFilter = {
  idEq?: Maybe<Scalars['ID']>;
  nameCont?: Maybe<Scalars['String']>;
};

export type UserGroup = {
  __typename?: 'UserGroup';
  createdAt: Scalars['ISO8601DateTime'];
  customerId: Scalars['Int'];
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  payload?: Maybe<Scalars['JSON']>;
  syncedAt: Scalars['ISO8601DateTime'];
  type: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

export type UserPhoto = {
  __typename?: 'UserPhoto';
  contentType?: Maybe<Scalars['String']>;
  contentUrl?: Maybe<Scalars['String']>;
  deleted?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  inline?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['String']>;
};

export type UserUpdateBatch = {
  __typename?: 'UserUpdateBatch';
  createdAt: Scalars['ISO8601DateTime'];
  createdBy: Admin;
  csv?: Maybe<Blob>;
  customer: Customer;
  id: Scalars['ID'];
  processCsvBatchId?: Maybe<Scalars['ID']>;
  processCsvStartedAt?: Maybe<Scalars['ISO8601DateTime']>;
  tags: Array<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type UserUpdateBatchAttributes = {
  /** Signed blob ID generated via `` UserUpdateBatchCSVUpload mutation */
  csvBlobId: Scalars['ID'];
  subdomain: Scalars['String'];
  tags: Array<Scalars['String']>;
};

export type UserUpdateBatchCollection = {
  __typename?: 'UserUpdateBatchCollection';
  collection: Array<UserUpdateBatch>;
  metadata: CollectionMetadata;
};

/** Autogenerated input type of UserUpdateBatchCreate */
export type UserUpdateBatchCreateInput = {
  attributes: UserUpdateBatchAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UserUpdateBatchCreate. */
export type UserUpdateBatchCreatePayload = {
  __typename?: 'UserUpdateBatchCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Error>>;
  userUpdateBatch?: Maybe<UserUpdateBatch>;
};

/** Autogenerated input type of UserUpdateBatchCsvUpload */
export type UserUpdateBatchCsvUploadInput = {
  attributes: DirectUploadAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UserUpdateBatchCsvUpload. */
export type UserUpdateBatchCsvUploadPayload = {
  __typename?: 'UserUpdateBatchCsvUploadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  directUpload?: Maybe<DirectUpload>;
};

/** Autogenerated input type of UserUpdateBatchExecute */
export type UserUpdateBatchExecuteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of UserUpdateBatchExecute. */
export type UserUpdateBatchExecutePayload = {
  __typename?: 'UserUpdateBatchExecutePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Error>>;
  userUpdateBatch?: Maybe<UserUpdateBatch>;
};

/** Autogenerated input type of UserUpdateBatchUpdate */
export type UserUpdateBatchUpdateInput = {
  attributes: UserUpdateBatchAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of UserUpdateBatchUpdate. */
export type UserUpdateBatchUpdatePayload = {
  __typename?: 'UserUpdateBatchUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Error>>;
  userUpdateBatch?: Maybe<UserUpdateBatch>;
};

/** Autogenerated input type of UserUpdate */
export type UserUpdateInput = {
  attributes: UserAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  subdomain: Scalars['ID'];
};

/** Autogenerated return type of UserUpdate. */
export type UserUpdatePayload = {
  __typename?: 'UserUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Error>>;
  user?: Maybe<User>;
};

export type UserUpload = {
  __typename?: 'UserUpload';
  batchId: Scalars['ID'];
  createdAt: Scalars['ISO8601DateTime'];
  emailsAvailable?: Maybe<Scalars['Int']>;
  error?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  jobsCompletedCount: Scalars['Int'];
  jobsFailedCount: Scalars['Int'];
  jobsTotalCount?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  s3Key: Scalars['String'];
  status: UserUploadStatus;
  subdomain: Subdomain;
  sunshineId?: Maybe<Scalars['String']>;
  uniqueHouseholds?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['ISO8601DateTime'];
  uploadTag: Scalars['String'];
  uploadedUsers: Array<Maybe<UploadedUser>>;
  uploaderZendeskId: Scalars['ID'];
  userCounts?: Maybe<UserCounts>;
};

export type UserUploadCollection = Collection & {
  __typename?: 'UserUploadCollection';
  collection: Array<UserUpload>;
  metadata: CollectionMetadata;
};

export enum UserUploadStatus {
  Cancelled = 'cancelled',
  Done = 'done',
  Failed = 'failed',
  Queued = 'queued',
  Scheduling = 'scheduling',
  Uploading = 'uploading'
}

/** Autogenerated input type of UshorZipsStateSyncJob */
export type UshorZipsStateSyncJobInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['Int']>;
  state: Scalars['String'];
};

/** Autogenerated return type of UshorZipsStateSyncJob. */
export type UshorZipsStateSyncJobPayload = {
  __typename?: 'UshorZipsStateSyncJobPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Error>>;
  jobId?: Maybe<Scalars['ID']>;
};

/** Autogenerated input type of UshorZipsSyncJob */
export type UshorZipsSyncJobInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UshorZipsSyncJob. */
export type UshorZipsSyncJobPayload = {
  __typename?: 'UshorZipsSyncJobPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Error>>;
  jobId?: Maybe<Scalars['ID']>;
};

export type ValidateXmlInput = {
  createTicket?: Maybe<Scalars['Boolean']>;
  type: XmlType;
  xml: Scalars['String'];
};

export type ValidateXmlResponse = {
  __typename?: 'ValidateXmlResponse';
  errors: Array<Maybe<Scalars['String']>>;
  parsedXml?: Maybe<Scalars['String']>;
  warnings: Array<Maybe<Scalars['String']>>;
};

export type Version = {
  __typename?: 'Version';
  actions: Array<Scalars['String']>;
  actor?: Maybe<User>;
  changes?: Maybe<Array<VersionObjectChange>>;
  comment?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  event: Scalars['String'];
  id: Scalars['ID'];
  itemId: Scalars['ID'];
  itemType: Scalars['String'];
  whodunnit?: Maybe<Scalars['String']>;
};

export type VersionCollection = {
  __typename?: 'VersionCollection';
  collection: Array<Version>;
  metadata: CollectionMetadata;
};

export type VersionObjectChange = {
  __typename?: 'VersionObjectChange';
  key: Scalars['String'];
  previousValue?: Maybe<Scalars['JSON']>;
  updatedValue?: Maybe<Scalars['JSON']>;
};

export type Webform = {
  __typename?: 'Webform';
  cohort: Cohort;
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  schema: Scalars['JSON'];
  settings: Scalars['JSON'];
  subdomains: Array<Subdomain>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type WebformCollection = Collection & {
  __typename?: 'WebformCollection';
  collection: Array<Webform>;
  metadata: CollectionMetadata;
};

export type WebformCreateInput = {
  cohort: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  schema: Scalars['String'];
  settings?: Maybe<Scalars['String']>;
  subdomains?: Maybe<Array<Scalars['String']>>;
};

export type WebformUpdateInput = {
  cohort?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  schema?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['String']>;
  subdomains?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type WebformsQueryInput = {
  subdomains?: Maybe<Array<Scalars['String']>>;
};

export enum XmlType {
  WebMessages = 'WebMessages',
  Zds = 'ZDS'
}

export type ZdTicketRetention = {
  __typename?: 'ZDTicketRetention';
  createdAt: Scalars['ISO8601DateTime'];
  heldBy?: Maybe<Array<SeRecord>>;
  id: Scalars['ID'];
  retentionPeriod?: Maybe<RetentionPeriodOption>;
  subdomain: Subdomain;
  ticketShouldDeleteAt?: Maybe<Scalars['ISO8601DateTime']>;
  ticketSolvedAt?: Maybe<Scalars['ISO8601DateTime']>;
  ticketStatus?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
  zendeskTicketId: Scalars['String'];
};

export type ZdTicketRetentionHoldInput = {
  seRecordId: Scalars['String'];
  subdomain: Scalars['String'];
  zendeskTicketId: Scalars['String'];
};

export type ZdTicketRetentionHoldManyInput = {
  seRecordId: Scalars['String'];
  subdomain: Scalars['String'];
  zendeskTicketIds: Array<Scalars['String']>;
};

export type ZdTicketRetentionReleaseInput = {
  seRecordId: Scalars['String'];
  subdomain: Scalars['String'];
  zendeskTicketId: Scalars['String'];
};

export type ZdTicketRetentionReleaseManyInput = {
  seRecordId: Scalars['String'];
};

export type ZdTicketRetentionWebhookHandlerInput = {
  retentionPeriodOption: RetentionPeriodOption;
  status: Scalars['String'];
  subdomain: Scalars['String'];
  ticketId: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

export type ZendeskAttachment = {
  __typename?: 'ZendeskAttachment';
  contentType?: Maybe<Scalars['String']>;
  contentUrl?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  url?: Maybe<Scalars['String']>;
};

export type ZendeskBatch = {
  __typename?: 'ZendeskBatch';
  card?: Maybe<ZendeskResponseCard>;
  columnName?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  latestBulkApiSend?: Maybe<BatchBulkApiSend>;
  latestExecution?: Maybe<BatchExecution>;
  metrics?: Maybe<BatchMetric>;
  name?: Maybe<Scalars['String']>;
  rawName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  statusOrder?: Maybe<Scalars['Int']>;
  topic?: Maybe<ZendeskTopic>;
  value?: Maybe<Scalars['String']>;
};

/** Attributes for creating a batch */
export type ZendeskBatchAttributes = {
  /** Create an associated response card? */
  createCard?: Maybe<Scalars['Boolean']>;
  /** Name for the batch */
  name?: Maybe<Scalars['String']>;
  /** Topic ID to be associated */
  topicId?: Maybe<Scalars['ID']>;
};

export type ZendeskBatchCollection = {
  __typename?: 'ZendeskBatchCollection';
  collection: Array<ZendeskBatch>;
  metadata: CollectionMetadata;
};

export type ZendeskBatchFieldOption = {
  __typename?: 'ZendeskBatchFieldOption';
  default: Scalars['Boolean'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  rawName: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type ZendeskBatchFilter = {
  nameCont?: Maybe<Scalars['String']>;
  statusEq?: Maybe<Scalars['String']>;
  topicEq?: Maybe<Scalars['String']>;
};

export type ZendeskBatchSort = {
  field: ZendeskBatchSortFieldEnum;
  order: SortOrderEnum;
};

export enum ZendeskBatchSortFieldEnum {
  BatchName = 'batchName',
  MedianAge = 'medianAge',
  OldestDate = 'oldestDate',
  OpenTickets = 'openTickets',
  ResponseStatus = 'responseStatus'
}

export type ZendeskMacro = {
  __typename?: 'ZendeskMacro';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  syncedAt: Scalars['ISO8601DateTime'];
  updatedAt: Scalars['ISO8601DateTime'];
  usage_1h: Scalars['Int'];
  usage_7d: Scalars['Int'];
  usage_24h: Scalars['Int'];
  usage_30d: Scalars['Int'];
};

export type ZendeskObject = {
  __typename?: 'ZendeskObject';
  createdAt: Scalars['ISO8601DateTime'];
  customer?: Maybe<Customer>;
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  payload: Scalars['JSON'];
  syncedAt?: Maybe<Scalars['ISO8601DateTime']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

export type ZendeskObjectCollection = {
  __typename?: 'ZendeskObjectCollection';
  collection: Array<ZendeskObject>;
  facets: ZendeskObjectFacet;
  metadata: CollectionMetadata;
};

export type ZendeskObjectFacet = {
  __typename?: 'ZendeskObjectFacet';
  types: Array<Facet>;
};

/** Autogenerated input type of ZendeskObjectSync */
export type ZendeskObjectSyncInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  subdomain: Scalars['ID'];
  type: Scalars['String'];
};

/** Autogenerated return type of ZendeskObjectSync. */
export type ZendeskObjectSyncPayload = {
  __typename?: 'ZendeskObjectSyncPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  zendeskObject: ZendeskObject;
};

/** Autogenerated input type of ZendeskObjectToggleDestroy */
export type ZendeskObjectToggleDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  subdomain: Scalars['ID'];
  type: Scalars['String'];
};

/** Autogenerated return type of ZendeskObjectToggleDestroy. */
export type ZendeskObjectToggleDestroyPayload = {
  __typename?: 'ZendeskObjectToggleDestroyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  zendeskObject: ZendeskObject;
};

export type ZendeskResponseCard = {
  __typename?: 'ZendeskResponseCard';
  attributes: ZendeskResponseCardAttributes;
  createdAt: Scalars['ISO8601Date'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  responseName: Scalars['String'];
  title: Scalars['String'];
  topicName: Scalars['String'];
  type: Scalars['String'];
  updatedAt: Scalars['ISO8601Date'];
};

export type ZendeskResponseCardAttributes = {
  __typename?: 'ZendeskResponseCardAttributes';
  batchValue?: Maybe<Scalars['String']>;
  commentViewLogs?: Maybe<Scalars['String']>;
  creatorId: Scalars['String'];
  dateAddedToColumn?: Maybe<Scalars['String']>;
  dateLastComment?: Maybe<Scalars['String']>;
  editorId?: Maybe<Scalars['String']>;
  responseId: Scalars['String'];
};

export type ZendeskResponseCardCollection = {
  __typename?: 'ZendeskResponseCardCollection';
  collection: Array<ZendeskResponseCard>;
  metadata: CollectionMetadata;
};

export type ZendeskResponseCardFilter = {
  activeEq?: Maybe<Scalars['Boolean']>;
  approvedEq?: Maybe<Scalars['Boolean']>;
};

export type ZendeskTicketComment = {
  __typename?: 'ZendeskTicketComment';
  attachments?: Maybe<Array<ZendeskAttachment>>;
  author?: Maybe<User>;
  authorId?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  htmlBody?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  public?: Maybe<Scalars['Boolean']>;
};

export type ZendeskTicketField = {
  __typename?: 'ZendeskTicketField';
  active: Scalars['Boolean'];
  agentDescription?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  customFieldOptions?: Maybe<Array<ZendeskTicketFieldOption>>;
  id: Scalars['ID'];
  name: Scalars['String'];
  position: Scalars['Int'];
  required: Scalars['Boolean'];
  syncedAt: Scalars['ISO8601DateTime'];
  type: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

export type ZendeskTicketFieldCollection = {
  __typename?: 'ZendeskTicketFieldCollection';
  collection: Array<ZendeskTicketField>;
  metadata: CollectionMetadata;
};

export type ZendeskTicketFieldOption = {
  __typename?: 'ZendeskTicketFieldOption';
  default?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type ZendeskTicketForm = {
  __typename?: 'ZendeskTicketForm';
  active: Scalars['Boolean'];
  createdAt: Scalars['ISO8601DateTime'];
  default: Scalars['Boolean'];
  endUserVisible: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
  position: Scalars['Int'];
  rawName?: Maybe<Scalars['String']>;
  syncedAt: Scalars['ISO8601DateTime'];
  ticketFieldIds: Array<ZendeskTicketField>;
  ticketFields: Array<ZendeskTicketField>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type ZendeskTicketFormCollection = {
  __typename?: 'ZendeskTicketFormCollection';
  collection: Array<ZendeskTicketForm>;
  metadata: CollectionMetadata;
};

export type ZendeskTopic = {
  __typename?: 'ZendeskTopic';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  rawName?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type ZendeskTopicCollection = {
  __typename?: 'ZendeskTopicCollection';
  collection: Array<ZendeskTopic>;
  metadata: CollectionMetadata;
};

export type ZendeskTrigger = {
  __typename?: 'ZendeskTrigger';
  active?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  position: Scalars['Int'];
  syncedAt?: Maybe<Scalars['ISO8601DateTime']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** Attributes for ticket console ticket matching logic */
export type ZendeskTriggerMatchersAttributes = {
  /** should frequent fliers be excluded? */
  excludeFrequentFliers?: Maybe<Scalars['Boolean']>;
  /** content to be matched */
  matchContent?: Maybe<Scalars['String']>;
  /** field to match against */
  matchType: TriggerMatchersTypeEnum;
};

export type ZendeskUser = {
  __typename?: 'ZendeskUser';
  email?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  url: Scalars['String'];
};

export type ZendeskUserCollection = {
  __typename?: 'ZendeskUserCollection';
  collection: Array<ZendeskUser>;
  metadata: CollectionMetadata;
};

/** Autogenerated input type of ZendeskUserUpdate */
export type ZendeskUserUpdateInput = {
  attributes: UserAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  subdomain: Scalars['ID'];
};

/** Autogenerated return type of ZendeskUserUpdate. */
export type ZendeskUserUpdatePayload = {
  __typename?: 'ZendeskUserUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Error>>;
  user?: Maybe<User>;
};

export type SurveyShowQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SurveyShowQuery = { __typename?: 'Query', survey: { __typename?: 'Survey', title?: string | null | undefined, questions: Array<{ __typename?: 'SurveyQuestion', query: string, options?: Array<{ __typename?: 'SurveyQuestionOption', tag?: string | null | undefined, value: string }> | null | undefined, summary?: { __typename?: 'SurveyQuestionSummary', total: number, counts: Array<{ __typename?: 'SurveyQuestionSummaryOption', value: string, count: number }> } | null | undefined }> } };

export type GetBatchesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBatchesQuery = { __typename?: 'Query', zendeskBatches: { __typename?: 'ZendeskBatchCollection', collection: Array<{ __typename?: 'ZendeskBatch', id?: string | null | undefined, name?: string | null | undefined, displayName?: string | null | undefined, value?: string | null | undefined, columnName?: string | null | undefined, status?: string | null | undefined, statusOrder?: number | null | undefined, card?: { __typename?: 'ZendeskResponseCard', id: string, externalId?: string | null | undefined, attributes: { __typename?: 'ZendeskResponseCardAttributes', batchValue?: string | null | undefined, creatorId: string, responseId: string } } | null | undefined, topic?: { __typename?: 'ZendeskTopic', id?: string | null | undefined, name?: string | null | undefined } | null | undefined, metrics?: { __typename?: 'BatchMetric', openTickets?: number | null | undefined, medianAge?: number | null | undefined, oldestDate?: number | null | undefined } | null | undefined, latestExecution?: { __typename?: 'BatchExecution', id: string, userId: string, status: string, macroId: string, runAt: any, createdAt: any, ticketIds?: Array<string> | null | undefined, pqTicketIds?: Array<string> | null | undefined } | null | undefined, latestBulkApiSend?: { __typename?: 'BatchBulkApiSend', id: string, status: string, createdAt: any, scheduledAt: any } | null | undefined }> } };

export type GetZendeskBatchQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetZendeskBatchQuery = { __typename?: 'Query', zendeskBatch: { __typename?: 'ZendeskBatch', id?: string | null | undefined, name?: string | null | undefined, displayName?: string | null | undefined, value?: string | null | undefined, columnName?: string | null | undefined, status?: string | null | undefined, statusOrder?: number | null | undefined, card?: { __typename?: 'ZendeskResponseCard', id: string, externalId?: string | null | undefined, attributes: { __typename?: 'ZendeskResponseCardAttributes', batchValue?: string | null | undefined, creatorId: string, responseId: string } } | null | undefined, topic?: { __typename?: 'ZendeskTopic', id?: string | null | undefined, name?: string | null | undefined } | null | undefined, metrics?: { __typename?: 'BatchMetric', openTickets?: number | null | undefined, medianAge?: number | null | undefined, oldestDate?: number | null | undefined } | null | undefined, latestExecution?: { __typename?: 'BatchExecution', id: string, userId: string, status: string, macroId: string, runAt: any, createdAt: any, ticketIds?: Array<string> | null | undefined, pqTicketIds?: Array<string> | null | undefined } | null | undefined, latestBulkApiSend?: { __typename?: 'BatchBulkApiSend', id: string, status: string, createdAt: any, scheduledAt: any } | null | undefined } };

export type GetTopicsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTopicsQuery = { __typename?: 'Query', zendeskTopics: { __typename?: 'ZendeskTopicCollection', collection: Array<{ __typename?: 'ZendeskTopic', id?: string | null | undefined, name?: string | null | undefined, rawName?: string | null | undefined }> } };

export type SearchApplyMacroMutationVariables = Exact<{
  input: SearchApplyMacroInput;
}>;


export type SearchApplyMacroMutation = { __typename?: 'Mutation', searchApplyMacro?: { __typename?: 'SearchApplyMacroPayload', numPrintQueue: string, numAppliedTickets: string, ticketIds: Array<string> } | null | undefined };

export type BatchExecuteMutationVariables = Exact<{
  input: BatchExecuteInput;
}>;


export type BatchExecuteMutation = { __typename?: 'Mutation', batchExecute?: { __typename?: 'BatchExecutePayload', batchExecution?: { __typename?: 'BatchExecution', id: string, userId: string, status: string, macroId: string, runAt: any, createdAt: any, pqTicketIds?: Array<string> | null | undefined } | null | undefined, batch?: { __typename?: 'ZendeskBatch', id?: string | null | undefined, name?: string | null | undefined, displayName?: string | null | undefined, value?: string | null | undefined, columnName?: string | null | undefined, status?: string | null | undefined, statusOrder?: number | null | undefined, card?: { __typename?: 'ZendeskResponseCard', id: string, externalId?: string | null | undefined, attributes: { __typename?: 'ZendeskResponseCardAttributes', batchValue?: string | null | undefined, creatorId: string, responseId: string } } | null | undefined, topic?: { __typename?: 'ZendeskTopic', id?: string | null | undefined, name?: string | null | undefined } | null | undefined, metrics?: { __typename?: 'BatchMetric', openTickets?: number | null | undefined, medianAge?: number | null | undefined, oldestDate?: number | null | undefined } | null | undefined, latestExecution?: { __typename?: 'BatchExecution', id: string, userId: string, status: string, macroId: string, runAt: any, createdAt: any, ticketIds?: Array<string> | null | undefined, pqTicketIds?: Array<string> | null | undefined } | null | undefined, latestBulkApiSend?: { __typename?: 'BatchBulkApiSend', id: string, status: string, createdAt: any, scheduledAt: any } | null | undefined } | null | undefined } | null | undefined };

export type BatchesScheduleSendMutationVariables = Exact<{
  input: BatchesScheduleSendInput;
}>;


export type BatchesScheduleSendMutation = { __typename?: 'Mutation', batchesScheduleSend: { __typename?: 'BatchesScheduleSendResponse', success: boolean, failedBatches?: Array<string> | null | undefined } };

export type BatchCreateMutationVariables = Exact<{
  input: BatchCreateInput;
}>;


export type BatchCreateMutation = { __typename?: 'Mutation', batchCreate?: { __typename?: 'BatchCreatePayload', errors?: Array<{ __typename?: 'Error', message: string }> | null | undefined, batch?: { __typename?: 'ZendeskBatch', id?: string | null | undefined } | null | undefined } | null | undefined };

export type AssignBatchMutationVariables = Exact<{
  input: BatchResponseAttachInput;
}>;


export type AssignBatchMutation = { __typename?: 'Mutation', batchResponseAttach?: { __typename?: 'BatchResponseAttachPayload', batch?: { __typename?: 'ZendeskBatch', id?: string | null | undefined, name?: string | null | undefined, displayName?: string | null | undefined, value?: string | null | undefined, columnName?: string | null | undefined, status?: string | null | undefined, statusOrder?: number | null | undefined, card?: { __typename?: 'ZendeskResponseCard', id: string, externalId?: string | null | undefined, attributes: { __typename?: 'ZendeskResponseCardAttributes', batchValue?: string | null | undefined, creatorId: string, responseId: string } } | null | undefined, topic?: { __typename?: 'ZendeskTopic', id?: string | null | undefined, name?: string | null | undefined } | null | undefined, metrics?: { __typename?: 'BatchMetric', openTickets?: number | null | undefined, medianAge?: number | null | undefined, oldestDate?: number | null | undefined } | null | undefined, latestExecution?: { __typename?: 'BatchExecution', id: string, userId: string, status: string, macroId: string, runAt: any, createdAt: any, ticketIds?: Array<string> | null | undefined, pqTicketIds?: Array<string> | null | undefined } | null | undefined, latestBulkApiSend?: { __typename?: 'BatchBulkApiSend', id: string, status: string, createdAt: any, scheduledAt: any } | null | undefined } | null | undefined } | null | undefined };

export type ZendeskResponseCardsQueryVariables = Exact<{ [key: string]: never; }>;


export type ZendeskResponseCardsQuery = { __typename?: 'Query', zendeskResponseCards: { __typename?: 'ZendeskResponseCardCollection', collection: Array<{ __typename?: 'ZendeskResponseCard', id: string, title: string, attributes: { __typename?: 'ZendeskResponseCardAttributes', batchValue?: string | null | undefined, responseId: string } }> } };

export type BatchCancelSendMutationVariables = Exact<{
  batchId: Scalars['ID'];
}>;


export type BatchCancelSendMutation = { __typename?: 'Mutation', batchCancelSend: { __typename?: 'BatchCancelSendResponse', success: boolean } };

export type BatchDeleteMutationVariables = Exact<{
  input: BatchDeleteInput;
}>;


export type BatchDeleteMutation = { __typename?: 'Mutation', batchDelete?: { __typename?: 'BatchDeletePayload', errors?: Array<{ __typename?: 'Error', message: string }> | null | undefined } | null | undefined };

export type BatchUpdateMutationVariables = Exact<{
  input: BatchUpdateInput;
}>;


export type BatchUpdateMutation = { __typename?: 'Mutation', batchUpdate?: { __typename?: 'BatchUpdatePayload', batch?: { __typename?: 'ZendeskBatch', id?: string | null | undefined, name?: string | null | undefined, displayName?: string | null | undefined, value?: string | null | undefined, columnName?: string | null | undefined, status?: string | null | undefined, statusOrder?: number | null | undefined, card?: { __typename?: 'ZendeskResponseCard', id: string, externalId?: string | null | undefined, attributes: { __typename?: 'ZendeskResponseCardAttributes', batchValue?: string | null | undefined, creatorId: string, responseId: string } } | null | undefined, topic?: { __typename?: 'ZendeskTopic', id?: string | null | undefined, name?: string | null | undefined } | null | undefined, metrics?: { __typename?: 'BatchMetric', openTickets?: number | null | undefined, medianAge?: number | null | undefined, oldestDate?: number | null | undefined } | null | undefined, latestExecution?: { __typename?: 'BatchExecution', id: string, userId: string, status: string, macroId: string, runAt: any, createdAt: any, ticketIds?: Array<string> | null | undefined, pqTicketIds?: Array<string> | null | undefined } | null | undefined, latestBulkApiSend?: { __typename?: 'BatchBulkApiSend', id: string, status: string, createdAt: any, scheduledAt: any } | null | undefined } | null | undefined } | null | undefined };

export type CampaignQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CampaignQuery = { __typename?: 'Query', campaign: { __typename?: 'Campaign', id: string, subject?: string | null | undefined, deliveryMethod: DeliveryMethod, audienceListId?: string | null | undefined, addTicketTags?: Array<string> | null | undefined, message?: string | null | undefined, html?: string | null | undefined, surveyId?: string | null | undefined, audienceFound?: number | null | undefined, audienceSize?: number | null | undefined, audienceSearchStartedAt?: any | null | undefined, tags?: Array<string> | null | undefined, physicalMailTemplate?: string | null | undefined, userTags?: Array<string> | null | undefined, excludedUserTags?: Array<string> | null | undefined, isEmailValidationEnabled?: boolean | null | undefined, isExcludeNewsSubEnabled?: boolean | null | undefined, isOnlyNewsSubEnabled?: boolean | null | undefined, scheduledAt?: any | null | undefined, isOnlyInDistrictVerifiedEnabled?: boolean | null | undefined, lastCampaignDate?: string | null | undefined, topics?: Array<string> | null | undefined, zipCodes?: Array<string> | null | undefined, counties?: Array<string> | null | undefined, status: CampaignStatus, audienceList?: { __typename?: 'AudienceList', name: string, isArchived: boolean, groups: Array<{ __typename?: 'AudienceListGroup', createdAt: any }>, criteria: Array<{ __typename?: 'AudienceListCriteria', createdAt: any }> } | null | undefined } };

export type CampaignsQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  query?: Maybe<Scalars['String']>;
  statusIn?: Maybe<Array<CampaignStatus> | CampaignStatus>;
  statusNotIn?: Maybe<Array<CampaignStatus> | CampaignStatus>;
}>;


export type CampaignsQuery = { __typename?: 'Query', campaigns: { __typename?: 'CampaignCollection', collection: Array<{ __typename?: 'Campaign', id: string, subject?: string | null | undefined, name: string, deliveryMethod: DeliveryMethod, audienceFound?: number | null | undefined, physicalMailJID?: string | null | undefined, jobsCompletedCount?: number | null | undefined, scheduledAt?: any | null | undefined, lastActionTakenAt?: any | null | undefined, jobsFailedCount?: number | null | undefined, jobsTotalCount?: number | null | undefined, status: CampaignStatus, audienceSize?: number | null | undefined, audienceListId?: string | null | undefined, analytics?: { __typename?: 'CampaignAnalytics', open?: number | null | undefined, linkClick?: number | null | undefined } | null | undefined }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, totalPages: number, totalCount: number } } };

export type CampaignDeleteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CampaignDeleteMutation = { __typename?: 'Mutation', campaignDelete: { __typename?: 'DeleteResponse', id: string, isDeleted: boolean } };

export type DuplicateMailerMutationVariables = Exact<{
  campaignId: Scalars['ID'];
  subject: Scalars['String'];
}>;


export type DuplicateMailerMutation = { __typename?: 'Mutation', campaignDuplicate: { __typename?: 'Campaign', id: string, subject?: string | null | undefined } };

export type UserUploadsQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  query?: Maybe<Scalars['String']>;
}>;


export type UserUploadsQuery = { __typename?: 'Query', userUploads: { __typename?: 'UserUploadCollection', collection: Array<{ __typename?: 'UserUpload', id: number, uploadTag: string, status: UserUploadStatus, updatedAt: any, jobsCompletedCount: number, jobsFailedCount: number, jobsTotalCount?: number | null | undefined, emailsAvailable?: number | null | undefined, uniqueHouseholds?: number | null | undefined, error?: string | null | undefined, userCounts?: { __typename?: 'UserCounts', queued: number, failed: number, created: number, updated: number } | null | undefined }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, totalPages: number, totalCount: number } } };

export type RefreshCampaignJobStatusQueryVariables = Exact<{
  campaignId: Scalars['ID'];
}>;


export type RefreshCampaignJobStatusQuery = { __typename?: 'Query', campaign: { __typename?: 'Campaign', id: string, jobsFailedCount?: number | null | undefined, jobsTotalCount?: number | null | undefined, jobsCompletedCount?: number | null | undefined, status: CampaignStatus, scheduledAt?: any | null | undefined, lastActionTakenAt?: any | null | undefined } };

export type L2UniversesQueryVariables = Exact<{ [key: string]: never; }>;


export type L2UniversesQuery = { __typename?: 'Query', universes: { __typename?: 'UniverseCollection', collection: Array<{ __typename?: 'Universe', id: string, name: string, cardinality: number, dateCreated: any, dateModified: any, username: string, csv?: { __typename?: 'Blob', key: string } | null | undefined }> } };

export type UpdateAudienceListMutationVariables = Exact<{
  input: AudienceListUpdateInput;
}>;


export type UpdateAudienceListMutation = { __typename?: 'Mutation', audienceListUpdate: { __typename?: 'AudienceList', id: string, name: string, updatedAt?: any | null | undefined, groups: Array<{ __typename?: 'AudienceListGroup', criteria: Array<{ __typename?: 'AudienceListCriteria', content: any }> }>, criteria: Array<{ __typename?: 'AudienceListCriteria', content: any }> } };

export type AudienceListQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AudienceListQuery = { __typename?: 'Query', audienceList: { __typename?: 'AudienceList', id: string, name: string, status: AudienceListStatus, totalAudienceSize?: number | null | undefined, isDraft: boolean, searchedAt?: any | null | undefined, queryString?: string | null | undefined, groups: Array<{ __typename?: 'AudienceListGroup', criteria: Array<{ __typename?: 'AudienceListCriteria', content: any }> }>, criteria: Array<{ __typename?: 'AudienceListCriteria', content: any }> } };

export type UpdateAudienceListNameMutationVariables = Exact<{
  input: AudienceListUpdateInput;
}>;


export type UpdateAudienceListNameMutation = { __typename?: 'Mutation', audienceListUpdate: { __typename?: 'AudienceList', id: string, name: string, updatedAt?: any | null | undefined, isDraft: boolean } };

export type AudienceListCreateMutationVariables = Exact<{
  input: AudienceListCreateInput;
}>;


export type AudienceListCreateMutation = { __typename?: 'Mutation', audienceListCreate: { __typename?: 'AudienceList', id: string, isArchived: boolean, status: AudienceListStatus, name: string, createdAt: any, updatedAt?: any | null | undefined, criteria: Array<{ __typename?: 'AudienceListCriteria', content: any }>, groups: Array<{ __typename?: 'AudienceListGroup', criteria: Array<{ __typename?: 'AudienceListCriteria', content: any }> }> } };

export type GenerateAudienceListPreviewMutationVariables = Exact<{
  input: AudienceListPopulatePreviewInput;
}>;


export type GenerateAudienceListPreviewMutation = { __typename?: 'Mutation', audienceListPopulatePreview: { __typename?: 'AudienceList', status: AudienceListStatus, id: string, totalAudienceSize?: number | null | undefined, searchedAt?: any | null | undefined } };

export type AudienceListStatusQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AudienceListStatusQuery = { __typename?: 'Query', audienceList: { __typename?: 'AudienceList', id: string, status: AudienceListStatus, totalAudienceSize?: number | null | undefined } };

export type AudienceListPreviewQueryVariables = Exact<{
  id: Scalars['ID'];
  usersPage: Scalars['Int'];
}>;


export type AudienceListPreviewQuery = { __typename?: 'Query', audienceList: { __typename?: 'AudienceList', id: string, searchedAt?: any | null | undefined, users?: { __typename?: 'AudienceListUserCollection', collection: Array<{ __typename?: 'AudienceListUser', id: string, zendeskUser: { __typename?: 'BulkMailZendeskUser', id: string, email?: string | null | undefined, name?: string | null | undefined, userFields?: any | null | undefined } }>, metadata: { __typename?: 'CollectionMetadata', totalCount: number, totalPages: number, currentPage: number } } | null | undefined } };

export type AudienceListsQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  query?: Maybe<Scalars['String']>;
}>;


export type AudienceListsQuery = { __typename?: 'Query', audienceLists: { __typename?: 'AudienceListCollection', collection: Array<{ __typename?: 'AudienceList', id: string, name: string, isDraft: boolean, createdAt: any, totalAudienceSize?: number | null | undefined, status: AudienceListStatus, searchedAt?: any | null | undefined, criteria: Array<{ __typename?: 'AudienceListCriteria', content: any }>, groups: Array<{ __typename?: 'AudienceListGroup', criteria: Array<{ __typename?: 'AudienceListCriteria', content: any }> }> }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type ListNameFragment = { __typename?: 'AudienceList', id: string, name: string };

export type RenameListMutationVariables = Exact<{
  input: AudienceListUpdateInput;
}>;


export type RenameListMutation = { __typename?: 'Mutation', audienceListUpdate: { __typename?: 'AudienceList', id: string, name: string } };

export type RefreshListImportJobStatusQueryVariables = Exact<{
  userUploadId: Scalars['Int'];
}>;


export type RefreshListImportJobStatusQuery = { __typename?: 'Query', userUpload: { __typename?: 'UserUpload', id: number, status: UserUploadStatus, userCounts?: { __typename?: 'UserCounts', queued: number, failed: number, created: number, updated: number } | null | undefined } };

export type PhysicalMailerTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type PhysicalMailerTemplatesQuery = { __typename?: 'Query', physicalMailerTemplates: { __typename?: 'PhysicalMailerTemplateCollection', collection: Array<{ __typename?: 'PhysicalMailerTemplate', name?: string | null | undefined, templatesPerPage: number, template: { __typename?: 'Blob', filename: string, id: string, key: string, name: string } }> } };

export type ExternalDataConstituentTagDataQueryVariables = Exact<{ [key: string]: never; }>;


export type ExternalDataConstituentTagDataQuery = { __typename?: 'Query', constituentTags: Array<{ __typename?: 'ConstituentTag', id: string, slug: string, name: string, constituentTagCategory: { __typename?: 'ConstituentTagCategory', id: string, name: string } }>, constituentTagCategories: Array<{ __typename?: 'ConstituentTagCategory', id: string, name: string }> };

export type ExternalDataCreateConstituentTagMutationVariables = Exact<{
  input: ConstituentTagCreateInput;
}>;


export type ExternalDataCreateConstituentTagMutation = { __typename?: 'Mutation', constituentTagCreate?: { __typename?: 'ConstituentTagCreatePayload', constituentTag?: { __typename?: 'ConstituentTag', id: string, slug: string, name: string, constituentTagCategory: { __typename?: 'ConstituentTagCategory', id: string, name: string } } | null | undefined, errors?: Array<{ __typename?: 'Error', message: string }> | null | undefined } | null | undefined };

export type ArchiveListMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ArchiveListMutation = { __typename?: 'Mutation', audienceListArchive: { __typename?: 'AudienceList', id: string, isArchived: boolean } };

export type GetPhysicalMailDownloadUrlQueryVariables = Exact<{
  jid: Scalars['ID'];
}>;


export type GetPhysicalMailDownloadUrlQuery = { __typename?: 'Query', physicalMailer: { __typename?: 'PhysicalMailer', url?: string | null | undefined } };

export type CampaignReportModalQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CampaignReportModalQuery = { __typename?: 'Query', campaign: { __typename?: 'Campaign', id: string, createdAt: any, audienceFound?: number | null | undefined, deliveryMethod: DeliveryMethod, audienceSize?: number | null | undefined, totalAcceptedRecipients?: number | null | undefined, subject?: string | null | undefined, status: CampaignStatus, surveyId?: string | null | undefined, analyticsSyncedAt?: any | null | undefined, totalUnsubscribes?: number | null | undefined, subscribers?: Array<string> | null | undefined, analytics?: { __typename?: 'CampaignAnalytics', open?: number | null | undefined, linkClick?: number | null | undefined, bounce?: number | null | undefined, invalidatedByCansend?: number | null | undefined, deliveries?: number | null | undefined, subscribes?: number | null | undefined, injected?: number | null | undefined } | null | undefined } };

export type SearchResultCountsQueryVariables = Exact<{
  query?: Maybe<Scalars['String']>;
}>;


export type SearchResultCountsQuery = { __typename?: 'Query', draftCampaigns: { __typename?: 'CampaignCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, completedCampaigns: { __typename?: 'CampaignCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, userUploads: { __typename?: 'UserUploadCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, audienceLists: { __typename?: 'AudienceListCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } } };

export type UpdateCampaignInStep2MutationVariables = Exact<{
  input: CampaignInput;
}>;


export type UpdateCampaignInStep2Mutation = { __typename?: 'Mutation', campaignUpdate: { __typename?: 'Campaign', id: string, status: CampaignStatus, deliveryMethod: DeliveryMethod, audienceSize?: number | null | undefined, isOnlyNewsSubEnabled?: boolean | null | undefined, isEmailValidationEnabled?: boolean | null | undefined, isOnlyInDistrictVerifiedEnabled?: boolean | null | undefined, isExcludeNewsSubEnabled?: boolean | null | undefined, lastCampaignDate?: string | null | undefined, audienceSearchStartedAt?: any | null | undefined } };

export type CreateCampaignInStep2MutationVariables = Exact<{
  input: CampaignCreateInput;
}>;


export type CreateCampaignInStep2Mutation = { __typename?: 'Mutation', campaignCreate: { __typename?: 'Campaign', id: string, status: CampaignStatus, deliveryMethod: DeliveryMethod, audienceSize?: number | null | undefined, isOnlyNewsSubEnabled?: boolean | null | undefined, isEmailValidationEnabled?: boolean | null | undefined, isOnlyInDistrictVerifiedEnabled?: boolean | null | undefined, isExcludeNewsSubEnabled?: boolean | null | undefined, lastCampaignDate?: string | null | undefined, audienceSearchStartedAt?: any | null | undefined } };

export type PopulateAudienceForCampaignMutationVariables = Exact<{
  input: AudienceListPopulateBulkMailInput;
}>;


export type PopulateAudienceForCampaignMutation = { __typename?: 'Mutation', audienceListPopulateBulkMail: { __typename?: 'AudienceListPopulateBulkMailResponse', bulkMail: { __typename?: 'Campaign', id: string, status: CampaignStatus, audienceSize?: number | null | undefined, audienceFound?: number | null | undefined, audienceSearchStartedAt?: any | null | undefined }, audienceList: { __typename?: 'AudienceList', id: string, status: AudienceListStatus } } };

export type AudienceListsForSearchQueryVariables = Exact<{ [key: string]: never; }>;


export type AudienceListsForSearchQuery = { __typename?: 'Query', audienceLists: { __typename?: 'AudienceListCollection', collection: Array<{ __typename?: 'AudienceList', id: string, name: string, status: AudienceListStatus, totalAudienceSize?: number | null | undefined }> } };

export type StatusOfCampaignQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type StatusOfCampaignQuery = { __typename?: 'Query', campaign: { __typename?: 'Campaign', id: string, status: CampaignStatus, audienceFound?: number | null | undefined } };

export type ShowBatchJobQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ShowBatchJobQuery = { __typename?: 'Query', asyncBatchJob: { __typename?: 'AsyncBatchJob', id: string, isComplete: boolean, successPct: number } };

export type RefreshUniversesMutationVariables = Exact<{
  clientMutationId: Scalars['String'];
}>;


export type RefreshUniversesMutation = { __typename?: 'Mutation', universesRefreshJob?: { __typename?: 'UniversesRefreshJobPayload', jobId: string } | null | undefined };

export type SaveScheduleMutationVariables = Exact<{
  id: Scalars['ID'];
  status?: Maybe<CampaignStatus>;
  scheduledAt?: Maybe<Scalars['ISO8601DateTime']>;
}>;


export type SaveScheduleMutation = { __typename?: 'Mutation', campaignUpdate: { __typename?: 'Campaign', id: string, status: CampaignStatus, scheduledAt?: any | null | undefined } };

export type GetCampaignScheduleQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCampaignScheduleQuery = { __typename?: 'Query', campaign: { __typename?: 'Campaign', id: string, scheduledAt?: any | null | undefined, status: CampaignStatus, subject?: string | null | undefined, html?: string | null | undefined } };

export type SaveDraftStep3MutationVariables = Exact<{
  id: Scalars['ID'];
  status?: Maybe<CampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  html?: Maybe<Scalars['String']>;
  addTicketTags?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  delivery_method?: Maybe<DeliveryMethod>;
  physicalMailTemplate?: Maybe<Scalars['String']>;
  skipSurveyCheck?: Maybe<Scalars['Boolean']>;
}>;


export type SaveDraftStep3Mutation = { __typename?: 'Mutation', campaignUpdate: { __typename?: 'Campaign', id: string, status: CampaignStatus, subject?: string | null | undefined, message?: string | null | undefined, html?: string | null | undefined, deliveryMethod: DeliveryMethod, physicalMailTemplate?: string | null | undefined, lastActionTakenAt?: any | null | undefined } };

export type CreatePhysicalMailerMutationVariables = Exact<{
  input: PhysicalMailInput;
}>;


export type CreatePhysicalMailerMutation = { __typename?: 'Mutation', campaignPhysicalMailCreate: { __typename?: 'PhysicalMailer', jid: string, status: PhysicalMailerStatus } };

export type PreviewPhysicalMailerMutationVariables = Exact<{
  input: PhysicalMailInput;
}>;


export type PreviewPhysicalMailerMutation = { __typename?: 'Mutation', campaignPhysicalMailPreview: { __typename?: 'PhysicalMailerPreview', content: string } };

export type GetCampaignQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCampaignQuery = { __typename?: 'Query', campaign: { __typename?: 'Campaign', id: string, scheduledAt?: any | null | undefined, status: CampaignStatus } };

export type CampaignTestSendMutationVariables = Exact<{
  input: CampaignTestSendInput;
}>;


export type CampaignTestSendMutation = { __typename?: 'Mutation', campaignTestSend: { __typename?: 'Campaign', id: string, name: string, status: CampaignStatus } };

export type SnapshotConstituentTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type SnapshotConstituentTagsQuery = { __typename?: 'Query', constituentTags: Array<{ __typename?: 'ConstituentTag', id: string, slug: string, name: string, constituentTagCategory: { __typename?: 'ConstituentTagCategory', id: string, name: string } }> };

export type SnapshotConstituentCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type SnapshotConstituentCategoriesQuery = { __typename?: 'Query', constituentTagCategories: Array<{ __typename?: 'ConstituentTagCategory', id: string, name: string }> };

export type SnapshotCreateConstituentTagMutationVariables = Exact<{
  input: ConstituentTagCreateInput;
}>;


export type SnapshotCreateConstituentTagMutation = { __typename?: 'Mutation', constituentTagCreate?: { __typename?: 'ConstituentTagCreatePayload', constituentTag?: { __typename?: 'ConstituentTag', id: string, slug: string, name: string, constituentTagCategory: { __typename?: 'ConstituentTagCategory', id: string, name: string } } | null | undefined, errors?: Array<{ __typename?: 'Error', message: string }> | null | undefined } | null | undefined };

export type ConstituentTagsQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  filter?: Maybe<ConstituentTagFilter>;
}>;


export type ConstituentTagsQuery = { __typename?: 'Query', constituentTags: Array<{ __typename?: 'ConstituentTag', id: string, name: string, slug: string, createdAt: any, updatedAt: any, constituentTagCategory: { __typename?: 'ConstituentTagCategory', id: string, name: string, updatedAt: any, createdAt: any } }> };

export type ConstituentTagCategoriesQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  filter?: Maybe<ConstituentTagCategoryFilter>;
}>;


export type ConstituentTagCategoriesQuery = { __typename?: 'Query', constituentTagCategories: Array<{ __typename?: 'ConstituentTagCategory', id: string, name: string, updatedAt: any, createdAt: any }> };

export type CreateConstituentTagCategoryMutationVariables = Exact<{
  input: ConstituentTagCategoryCreateInput;
}>;


export type CreateConstituentTagCategoryMutation = { __typename?: 'Mutation', constituentTagCategoryCreate?: { __typename?: 'ConstituentTagCategoryCreatePayload', constituentTagCategory?: { __typename?: 'ConstituentTagCategory', id: string } | null | undefined, errors?: Array<{ __typename?: 'Error', message: string }> | null | undefined } | null | undefined };

export type CreateConstituentTagMutationVariables = Exact<{
  input: ConstituentTagCreateInput;
}>;


export type CreateConstituentTagMutation = { __typename?: 'Mutation', constituentTagCreate?: { __typename?: 'ConstituentTagCreatePayload', constituentTag?: { __typename?: 'ConstituentTag', id: string } | null | undefined, errors?: Array<{ __typename?: 'Error', message: string }> | null | undefined } | null | undefined };

export type DeleteConstituentTagMutationVariables = Exact<{
  input: ConstituentTagDeleteInput;
}>;


export type DeleteConstituentTagMutation = { __typename?: 'Mutation', constituentTagDelete?: { __typename?: 'ConstituentTagDeletePayload', constituentTag?: { __typename?: 'ConstituentTag', id: string } | null | undefined } | null | undefined };

export type PrintCommentUpdateMutationVariables = Exact<{
  input: PrintCommentUpdateInput;
}>;


export type PrintCommentUpdateMutation = { __typename?: 'Mutation', printCommentUpdate: { __typename?: 'PrintComment', id: string, commentHtml: string } };

export type PrintQueueJobsFetchQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset?: Maybe<Scalars['Int']>;
  sort?: Maybe<PrintQueueJobSort>;
  filter?: Maybe<PrintQueueJobFilter>;
}>;


export type PrintQueueJobsFetchQuery = { __typename?: 'Query', printQueueJobsFetch: { __typename?: 'PrintQueueJobsFetchResponse', totalJobs: number, printJobs: Array<{ __typename?: 'PrintQueueJob', createdAt: any, id: string, ticketResolution: TicketResolution, updatedAt: any, failedCommentCount?: number | null | undefined, documentUrls?: Array<string> | null | undefined, downloadable?: boolean | null | undefined, creator: { __typename?: 'PrintZendeskUser', id: string, name?: string | null | undefined, zendeskId: string }, printComments?: Array<{ __typename?: 'PrintComment', id: string, commentHtml: string, createdAt: any, printed: boolean, updatedAt: any, zendeskTicket: { __typename?: 'PrintZendeskTicket', id: string, zendeskId: string, status?: string | null | undefined, formType?: string | null | undefined, requester?: { __typename?: 'PrintZendeskUser', id: string, name?: string | null | undefined, zendeskId: string, hasValidAddress?: boolean | null | undefined, districtStatus?: DistrictStatus | null | undefined } | null | undefined, assignee?: { __typename?: 'PrintZendeskUser', id: string, name?: string | null | undefined, zendeskId: string } | null | undefined } }> | null | undefined }> } };

export type PrintCommentsFetchQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset?: Maybe<Scalars['Int']>;
  filter?: Maybe<PrintCommentFilter>;
  sort?: Maybe<PrintCommentSort>;
}>;


export type PrintCommentsFetchQuery = { __typename?: 'Query', printCommentsFetch: { __typename?: 'PrintCommentsFetchResponse', totalComments: number, printComments: Array<{ __typename?: 'PrintComment', commentHtml: string, id: string, printed: boolean, createdAt: any, updatedAt: any, zendeskTicket: { __typename?: 'PrintZendeskTicket', id: string, zendeskId: string, formType?: string | null | undefined, batchName?: string | null | undefined, status?: string | null | undefined, requester?: { __typename?: 'PrintZendeskUser', id: string, zendeskId: string, name?: string | null | undefined, hasValidAddress?: boolean | null | undefined, districtStatus?: DistrictStatus | null | undefined } | null | undefined } }> } };

export type PrintCommentsCloseMutationVariables = Exact<{
  input: PrintCommentsCloseInput;
}>;


export type PrintCommentsCloseMutation = { __typename?: 'Mutation', printCommentsClose: { __typename?: 'PrintCloseResponse', updateTicketsJobIds: Array<string | null | undefined> } };

export type PrintCommentsPrintMutationVariables = Exact<{
  input: PrintCommentsPrintInput;
}>;


export type PrintCommentsPrintMutation = { __typename?: 'Mutation', printCommentsPrint: { __typename?: 'PrintResponse', printQueueJob: { __typename?: 'PrintQueueJob', id: string } } };

export type PrintQueueJobFetchQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PrintQueueJobFetchQuery = { __typename?: 'Query', printQueueJobFetch?: { __typename?: 'PrintQueueJob', id: string, failedCommentCount?: number | null | undefined, succeededCommentCount?: number | null | undefined, documentUrls?: Array<string> | null | undefined, printComments?: Array<{ __typename?: 'PrintComment', id: string, printed: boolean }> | null | undefined } | null | undefined };

export type ListDigitalTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListDigitalTemplatesQuery = { __typename?: 'Query', digitalTemplates: { __typename?: 'DigitalTemplate', letters: Array<{ __typename?: 'S3Object', etag: string, name: string, fileName: string }>, envelopes: Array<{ __typename?: 'S3Object', etag: string, name: string, fileName: string }> } };

export type PrintTemplatePreviewMutationVariables = Exact<{
  input: PrintTemplatePreviewInput;
}>;


export type PrintTemplatePreviewMutation = { __typename?: 'Mutation', printTemplatePreview: { __typename?: 'PrintTemplatePreviewResponse', url: string } };

export type PrintUserUpdateMutationVariables = Exact<{
  input: PrintUserUpdateInput;
}>;


export type PrintUserUpdateMutation = { __typename?: 'Mutation', printUserUpdate: { __typename?: 'PrintUserUpdateSuccess', success: boolean } };

export type CreatePrintCommentMutationVariables = Exact<{
  input: PrintCommentCreateInput;
}>;


export type CreatePrintCommentMutation = { __typename?: 'Mutation', printCommentCreate: { __typename?: 'PrintComment', id: string, commentHtml: string, zendeskTicket: { __typename?: 'PrintZendeskTicket', id: string, zendeskId: string, requester?: { __typename?: 'PrintZendeskUser', name?: string | null | undefined, districtStatus?: DistrictStatus | null | undefined } | null | undefined } } };

export type PrintTicketCommentMutationVariables = Exact<{
  input: PrintTicketCommentInput;
}>;


export type PrintTicketCommentMutation = { __typename?: 'Mutation', printTicketComment: { __typename?: 'PrintCommentResponse', file: { __typename?: 'PrintFile', fileName: string, content: string } } };

export type CurrentEditorQueryVariables = Exact<{
  input: GetCurrentEditorInput;
}>;


export type CurrentEditorQuery = { __typename?: 'Query', currentEditor: { __typename?: 'CurrentEditorResponse', currentEditor?: { __typename?: 'CurrentEditor', id: string, currentEditorId: string, objectCurrentlyEditedId: string, appName: AppName, createdAt: any, updatedAt: any, deletedAt?: any | null | undefined, subdomain: { __typename?: 'Subdomain', name: string } } | null | undefined } };

export type CurrentEditorAddOrUpdateMutationVariables = Exact<{
  input: AddOrUpdateCurrentEditorInput;
}>;


export type CurrentEditorAddOrUpdateMutation = { __typename?: 'Mutation', currentEditorAddOrUpdate: { __typename?: 'CurrentEditor', id: string, currentEditorId: string, objectCurrentlyEditedId: string, appName: AppName, createdAt: any, updatedAt: any, deletedAt?: any | null | undefined, subdomain: { __typename?: 'Subdomain', name: string } } };

export type CurrentEditorDeleteMutationVariables = Exact<{
  currentEditorDeleteId: Scalars['ID'];
}>;


export type CurrentEditorDeleteMutation = { __typename?: 'Mutation', currentEditorDelete: { __typename?: 'CurrentEditor', id: string } };

export type GetBatchByBatchTagQueryVariables = Exact<{
  batchTag: Scalars['String'];
}>;


export type GetBatchByBatchTagQuery = { __typename?: 'Query', getBatchByBatchTag: { __typename?: 'ZendeskBatchFieldOption', default: boolean, id?: string | null | undefined, name: string, rawName: string, value?: string | null | undefined } };

export type ResponseCardMoveMutationVariables = Exact<{
  input: ResponseCardMoveInput;
}>;


export type ResponseCardMoveMutation = { __typename?: 'Mutation', responseCardMove?: { __typename?: 'ResponseCardMovePayload', errors?: Array<{ __typename?: 'Error', message: string }> | null | undefined } | null | undefined };

export type ResponseDeleteMutationVariables = Exact<{
  input: ResponseDeleteInput;
}>;


export type ResponseDeleteMutation = { __typename?: 'Mutation', responseDelete?: { __typename?: 'ResponseDeletePayload', errors?: Array<{ __typename?: 'Error', message: string }> | null | undefined, response?: { __typename?: 'Response', id: string } | null | undefined } | null | undefined };

export type TicketCountMatchingTriggerQueryVariables = Exact<{
  input: TicketCountMatchingTriggerInput;
}>;


export type TicketCountMatchingTriggerQuery = { __typename?: 'Query', ticketCountMatchingTrigger: { __typename?: 'TicketCountMatchingResponse', count: number } };

export type TicketSearchByTriggerApplyResponseMutationVariables = Exact<{
  input: TicketSearchByTriggerApplyResponseInput;
}>;


export type TicketSearchByTriggerApplyResponseMutation = { __typename?: 'Mutation', ticketSearchByTriggerApplyResponse: { __typename?: 'TicketApplyResponseSuccess', success: boolean } };

export type TicketSearchByTriggerAddBatchMutationVariables = Exact<{
  input: TicketSearchByTriggerAddBatchInput;
}>;


export type TicketSearchByTriggerAddBatchMutation = { __typename?: 'Mutation', ticketSearchByTriggerAddBatch: { __typename?: 'TicketAddBatchSuccess', success: boolean } };

export type TriggerCreateAutoResponseMutationVariables = Exact<{
  input: TriggerCreateAutoResponseInput;
}>;


export type TriggerCreateAutoResponseMutation = { __typename?: 'Mutation', triggerCreateAutoResponse?: { __typename?: 'TriggerCreateAutoResponsePayload', errors?: Array<{ __typename?: 'Error', message: string }> | null | undefined, trigger?: { __typename?: 'ZendeskTrigger', id: string, name: string, active?: boolean | null | undefined } | null | undefined } | null | undefined };

export type TriggerCreateAutoBatchMutationVariables = Exact<{
  input: TriggerCreateAutoBatchInput;
}>;


export type TriggerCreateAutoBatchMutation = { __typename?: 'Mutation', triggerCreateAutoBatch?: { __typename?: 'TriggerCreateAutoBatchPayload', errors?: Array<{ __typename?: 'Error', message: string }> | null | undefined, trigger?: { __typename?: 'ZendeskTrigger', id: string, name: string, active?: boolean | null | undefined } | null | undefined } | null | undefined };

export type TicketEditorSideConversationsQueryVariables = Exact<{
  ticketId: Scalars['String'];
}>;


export type TicketEditorSideConversationsQuery = { __typename?: 'Query', sideConversations: { __typename?: 'SideConversationCollection', collection: Array<{ __typename?: 'SideConversation', subject?: string | null | undefined, messages: Array<{ __typename?: 'SideConversationMessage', id: string, message?: string | null | undefined, sentAt: any, createdBy: { __typename?: 'SideConversationParticipant', email?: string | null | undefined }, attachments?: Array<{ __typename?: 'Attachment', filename: string, url: string }> | null | undefined }> }> } };

export type ConversationDetailsQueryVariables = Exact<{
  conversationId: Scalars['ID'];
}>;


export type ConversationDetailsQuery = { __typename?: 'Query', sideConversation: { __typename?: 'SideConversation', id: string, messages: Array<{ __typename?: 'SideConversationMessage', id: string, messageStatus: MessageStatus, messageType: MessageType, sentAt: any, message?: string | null | undefined, isRead?: boolean | null | undefined, createdBy: { __typename?: 'SideConversationParticipant', email?: string | null | undefined }, recipients: Array<{ __typename?: 'SideConversationParticipant', id: string, email?: string | null | undefined, name?: string | null | undefined }>, attachments?: Array<{ __typename?: 'Attachment', filename: string, url: string }> | null | undefined }> } };

export type ParticipantSuggestionsQueryVariables = Exact<{
  query: Scalars['String'];
}>;


export type ParticipantSuggestionsQuery = { __typename?: 'Query', zendeskUsers: { __typename?: 'UserCollection', collection: Array<{ __typename?: 'User', id: string, email?: string | null | undefined, name?: string | null | undefined }> } };

export type SideConversationsQueryVariables = Exact<{
  ticketId?: Maybe<Scalars['String']>;
}>;


export type SideConversationsQuery = { __typename?: 'Query', sideConversations: { __typename?: 'SideConversationCollection', collection: Array<{ __typename?: 'SideConversation', id: string, subject?: string | null | undefined, hasNewMessage?: boolean | null | undefined, mostRecentMessage?: { __typename?: 'SideConversationMessage', sentAt: any, message?: string | null | undefined, createdBy: { __typename?: 'SideConversationParticipant', email?: string | null | undefined }, recipients: Array<{ __typename?: 'SideConversationParticipant', id: string, zendeskId?: string | null | undefined, email?: string | null | undefined, name?: string | null | undefined }> } | null | undefined }> } };

export type CreateSideConversationMutationVariables = Exact<{
  input: CreateSideConversationInput;
}>;


export type CreateSideConversationMutation = { __typename?: 'Mutation', createSideConversation: { __typename?: 'SideConversation', id: string } };

export type GetResponseVersionsQueryVariables = Exact<{
  responseId: Scalars['ID'];
}>;


export type GetResponseVersionsQuery = { __typename?: 'Query', response?: { __typename?: 'Response', versions: { __typename?: 'VersionCollection', collection: Array<{ __typename?: 'Version', id: string, actions: Array<string>, createdAt: any, actor?: { __typename?: 'User', email?: string | null | undefined, name?: string | null | undefined, photo?: { __typename?: 'UserPhoto', contentUrl?: string | null | undefined } | null | undefined } | null | undefined }>, metadata: { __typename?: 'CollectionMetadata', totalPages: number, totalCount: number } } } | null | undefined };

export type MakeResponseCommentMutationVariables = Exact<{
  responseId: Scalars['ID'];
  comment: Scalars['String'];
}>;


export type MakeResponseCommentMutation = { __typename?: 'Mutation', responseCommentCreate?: { __typename?: 'ResponseCommentCreatePayload', errors?: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null | undefined }> | null | undefined, response?: { __typename?: 'Response', id: string, comments: Array<{ __typename?: 'Comment', id: string, comment: string, createdAt: any, actor?: { __typename?: 'User', id: string, name?: string | null | undefined, email?: string | null | undefined } | null | undefined }> } | null | undefined } | null | undefined };

export type GetResponseCommentsQueryVariables = Exact<{
  responseId: Scalars['ID'];
}>;


export type GetResponseCommentsQuery = { __typename?: 'Query', response?: { __typename?: 'Response', id: string, comments: Array<{ __typename?: 'Comment', id: string, comment: string, createdAt: any, actor?: { __typename?: 'User', id: string, name?: string | null | undefined, email?: string | null | undefined } | null | undefined }> } | null | undefined };

export type MakeResponseViewMutationVariables = Exact<{
  responseId: Scalars['ID'];
}>;


export type MakeResponseViewMutation = { __typename?: 'Mutation', responseViewUpdate?: { __typename?: 'ResponseViewUpdatePayload', errors?: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null | undefined }> | null | undefined } | null | undefined };

export type ListBatchesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListBatchesQuery = { __typename?: 'Query', batches: { __typename?: 'BatchCollection', collection: Array<{ __typename?: 'Batch', name: string }> } };

export type ListTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListTagsQuery = { __typename?: 'Query', tags: { __typename?: 'TagCollection', collection: Array<{ __typename?: 'Tag', id: string, name: string, topic?: { __typename?: 'Topic', name: string } | null | undefined }> } };

export type GetTopicsDropdownQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTopicsDropdownQuery = { __typename?: 'Query', topics: { __typename?: 'TopicCollection', collection: Array<{ __typename?: 'Topic', id: string, name: string }> } };

export type GetApprovedResponseQueryVariables = Exact<{
  responseId: Scalars['ID'];
}>;


export type GetApprovedResponseQuery = { __typename?: 'Query', response?: { __typename?: 'Response', id: string, batches?: Array<{ __typename?: 'Batch', id: string, name: string, metrics?: { __typename?: 'TagMetrics', numTicketsOpen?: number | null | undefined } | null | undefined, topic?: { __typename?: 'Topic', id: string, name: string } | null | undefined }> | null | undefined } | null | undefined };

export type UnassignBatchMutationVariables = Exact<{
  batchId: Scalars['ID'];
}>;


export type UnassignBatchMutation = { __typename?: 'Mutation', batchResponseUnassign?: { __typename?: 'BatchResponseUnassignPayload', batch?: { __typename?: 'ZendeskBatch', id?: string | null | undefined, name?: string | null | undefined, displayName?: string | null | undefined, value?: string | null | undefined, columnName?: string | null | undefined, status?: string | null | undefined, statusOrder?: number | null | undefined, card?: { __typename?: 'ZendeskResponseCard', attributes: { __typename?: 'ZendeskResponseCardAttributes', batchValue?: string | null | undefined, creatorId: string, responseId: string } } | null | undefined, topic?: { __typename?: 'ZendeskTopic', id?: string | null | undefined, name?: string | null | undefined } | null | undefined, metrics?: { __typename?: 'BatchMetric', openTickets?: number | null | undefined, medianAge?: number | null | undefined, oldestDate?: number | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type GetResponseTitleQueryVariables = Exact<{
  responseId: Scalars['ID'];
}>;


export type GetResponseTitleQuery = { __typename?: 'Query', response?: { __typename?: 'Response', id: string, title: string } | null | undefined };

export type DeleteResponseMutationVariables = Exact<{
  responseId: Scalars['ID'];
}>;


export type DeleteResponseMutation = { __typename?: 'Mutation', responseDelete?: { __typename?: 'ResponseDeletePayload', errors?: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null | undefined }> | null | undefined } | null | undefined };

export const ListNameFragmentDoc = gql`
    fragment ListName on AudienceList {
  id
  name
}
    `;
export const SurveyShowDocument = gql`
    query surveyShow($id: ID!) {
  survey(id: $id) {
    title
    questions {
      query
      options {
        tag
        value
      }
      summary {
        total
        counts {
          value
          count
        }
      }
    }
  }
}
    `;

/**
 * __useSurveyShowQuery__
 *
 * To run a query within a React component, call `useSurveyShowQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurveyShowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSurveyShowQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSurveyShowQuery(baseOptions: Apollo.QueryHookOptions<SurveyShowQuery, SurveyShowQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SurveyShowQuery, SurveyShowQueryVariables>(SurveyShowDocument, options);
      }
export function useSurveyShowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SurveyShowQuery, SurveyShowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SurveyShowQuery, SurveyShowQueryVariables>(SurveyShowDocument, options);
        }
export type SurveyShowQueryHookResult = ReturnType<typeof useSurveyShowQuery>;
export type SurveyShowLazyQueryHookResult = ReturnType<typeof useSurveyShowLazyQuery>;
export type SurveyShowQueryResult = Apollo.QueryResult<SurveyShowQuery, SurveyShowQueryVariables>;
export const GetBatchesDocument = gql`
    query GetBatches {
  zendeskBatches(limit: 3000) {
    collection {
      id
      name
      displayName
      value
      card {
        id
        externalId
        attributes {
          batchValue
          creatorId
          responseId
        }
      }
      columnName
      status
      statusOrder
      topic {
        id
        name
      }
      metrics {
        openTickets
        medianAge
        oldestDate
      }
      latestExecution {
        id
        userId
        status
        macroId
        runAt
        createdAt
        ticketIds
        pqTicketIds
      }
      latestBulkApiSend {
        id
        status
        createdAt
        scheduledAt
      }
    }
  }
}
    `;

/**
 * __useGetBatchesQuery__
 *
 * To run a query within a React component, call `useGetBatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBatchesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBatchesQuery(baseOptions?: Apollo.QueryHookOptions<GetBatchesQuery, GetBatchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBatchesQuery, GetBatchesQueryVariables>(GetBatchesDocument, options);
      }
export function useGetBatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBatchesQuery, GetBatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBatchesQuery, GetBatchesQueryVariables>(GetBatchesDocument, options);
        }
export type GetBatchesQueryHookResult = ReturnType<typeof useGetBatchesQuery>;
export type GetBatchesLazyQueryHookResult = ReturnType<typeof useGetBatchesLazyQuery>;
export type GetBatchesQueryResult = Apollo.QueryResult<GetBatchesQuery, GetBatchesQueryVariables>;
export const GetZendeskBatchDocument = gql`
    query GetZendeskBatch($id: ID!) {
  zendeskBatch(id: $id) {
    id
    name
    displayName
    value
    card {
      id
      externalId
      attributes {
        batchValue
        creatorId
        responseId
      }
    }
    columnName
    status
    statusOrder
    topic {
      id
      name
    }
    metrics {
      openTickets
      medianAge
      oldestDate
    }
    latestExecution {
      id
      userId
      status
      macroId
      runAt
      createdAt
      ticketIds
      pqTicketIds
    }
    latestBulkApiSend {
      id
      status
      createdAt
      scheduledAt
    }
  }
}
    `;

/**
 * __useGetZendeskBatchQuery__
 *
 * To run a query within a React component, call `useGetZendeskBatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetZendeskBatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetZendeskBatchQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetZendeskBatchQuery(baseOptions: Apollo.QueryHookOptions<GetZendeskBatchQuery, GetZendeskBatchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetZendeskBatchQuery, GetZendeskBatchQueryVariables>(GetZendeskBatchDocument, options);
      }
export function useGetZendeskBatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetZendeskBatchQuery, GetZendeskBatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetZendeskBatchQuery, GetZendeskBatchQueryVariables>(GetZendeskBatchDocument, options);
        }
export type GetZendeskBatchQueryHookResult = ReturnType<typeof useGetZendeskBatchQuery>;
export type GetZendeskBatchLazyQueryHookResult = ReturnType<typeof useGetZendeskBatchLazyQuery>;
export type GetZendeskBatchQueryResult = Apollo.QueryResult<GetZendeskBatchQuery, GetZendeskBatchQueryVariables>;
export const GetTopicsDocument = gql`
    query GetTopics {
  zendeskTopics(limit: 1000) {
    collection {
      id
      name
      rawName
    }
  }
}
    `;

/**
 * __useGetTopicsQuery__
 *
 * To run a query within a React component, call `useGetTopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopicsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTopicsQuery(baseOptions?: Apollo.QueryHookOptions<GetTopicsQuery, GetTopicsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTopicsQuery, GetTopicsQueryVariables>(GetTopicsDocument, options);
      }
export function useGetTopicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTopicsQuery, GetTopicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTopicsQuery, GetTopicsQueryVariables>(GetTopicsDocument, options);
        }
export type GetTopicsQueryHookResult = ReturnType<typeof useGetTopicsQuery>;
export type GetTopicsLazyQueryHookResult = ReturnType<typeof useGetTopicsLazyQuery>;
export type GetTopicsQueryResult = Apollo.QueryResult<GetTopicsQuery, GetTopicsQueryVariables>;
export const SearchApplyMacroDocument = gql`
    mutation SearchApplyMacro($input: SearchApplyMacroInput!) {
  searchApplyMacro(input: $input) {
    numPrintQueue
    numAppliedTickets
    ticketIds
  }
}
    `;
export type SearchApplyMacroMutationFn = Apollo.MutationFunction<SearchApplyMacroMutation, SearchApplyMacroMutationVariables>;

/**
 * __useSearchApplyMacroMutation__
 *
 * To run a mutation, you first call `useSearchApplyMacroMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSearchApplyMacroMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [searchApplyMacroMutation, { data, loading, error }] = useSearchApplyMacroMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchApplyMacroMutation(baseOptions?: Apollo.MutationHookOptions<SearchApplyMacroMutation, SearchApplyMacroMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SearchApplyMacroMutation, SearchApplyMacroMutationVariables>(SearchApplyMacroDocument, options);
      }
export type SearchApplyMacroMutationHookResult = ReturnType<typeof useSearchApplyMacroMutation>;
export type SearchApplyMacroMutationResult = Apollo.MutationResult<SearchApplyMacroMutation>;
export type SearchApplyMacroMutationOptions = Apollo.BaseMutationOptions<SearchApplyMacroMutation, SearchApplyMacroMutationVariables>;
export const BatchExecuteDocument = gql`
    mutation batchExecute($input: BatchExecuteInput!) {
  batchExecute(input: $input) {
    batchExecution {
      id
      userId
      status
      macroId
      runAt
      createdAt
      pqTicketIds
    }
    batch {
      id
      name
      displayName
      value
      card {
        id
        externalId
        attributes {
          batchValue
          creatorId
          responseId
        }
      }
      columnName
      status
      statusOrder
      topic {
        id
        name
      }
      metrics {
        openTickets
        medianAge
        oldestDate
      }
      latestExecution {
        id
        userId
        status
        macroId
        runAt
        createdAt
        ticketIds
        pqTicketIds
      }
      latestBulkApiSend {
        id
        status
        createdAt
        scheduledAt
      }
    }
  }
}
    `;
export type BatchExecuteMutationFn = Apollo.MutationFunction<BatchExecuteMutation, BatchExecuteMutationVariables>;

/**
 * __useBatchExecuteMutation__
 *
 * To run a mutation, you first call `useBatchExecuteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchExecuteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchExecuteMutation, { data, loading, error }] = useBatchExecuteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBatchExecuteMutation(baseOptions?: Apollo.MutationHookOptions<BatchExecuteMutation, BatchExecuteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BatchExecuteMutation, BatchExecuteMutationVariables>(BatchExecuteDocument, options);
      }
export type BatchExecuteMutationHookResult = ReturnType<typeof useBatchExecuteMutation>;
export type BatchExecuteMutationResult = Apollo.MutationResult<BatchExecuteMutation>;
export type BatchExecuteMutationOptions = Apollo.BaseMutationOptions<BatchExecuteMutation, BatchExecuteMutationVariables>;
export const BatchesScheduleSendDocument = gql`
    mutation BatchesScheduleSend($input: BatchesScheduleSendInput!) {
  batchesScheduleSend(input: $input) {
    success
    failedBatches
  }
}
    `;
export type BatchesScheduleSendMutationFn = Apollo.MutationFunction<BatchesScheduleSendMutation, BatchesScheduleSendMutationVariables>;

/**
 * __useBatchesScheduleSendMutation__
 *
 * To run a mutation, you first call `useBatchesScheduleSendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchesScheduleSendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchesScheduleSendMutation, { data, loading, error }] = useBatchesScheduleSendMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBatchesScheduleSendMutation(baseOptions?: Apollo.MutationHookOptions<BatchesScheduleSendMutation, BatchesScheduleSendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BatchesScheduleSendMutation, BatchesScheduleSendMutationVariables>(BatchesScheduleSendDocument, options);
      }
export type BatchesScheduleSendMutationHookResult = ReturnType<typeof useBatchesScheduleSendMutation>;
export type BatchesScheduleSendMutationResult = Apollo.MutationResult<BatchesScheduleSendMutation>;
export type BatchesScheduleSendMutationOptions = Apollo.BaseMutationOptions<BatchesScheduleSendMutation, BatchesScheduleSendMutationVariables>;
export const BatchCreateDocument = gql`
    mutation BatchCreate($input: BatchCreateInput!) {
  batchCreate(input: $input) {
    errors {
      message
    }
    batch {
      id
    }
  }
}
    `;
export type BatchCreateMutationFn = Apollo.MutationFunction<BatchCreateMutation, BatchCreateMutationVariables>;

/**
 * __useBatchCreateMutation__
 *
 * To run a mutation, you first call `useBatchCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchCreateMutation, { data, loading, error }] = useBatchCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBatchCreateMutation(baseOptions?: Apollo.MutationHookOptions<BatchCreateMutation, BatchCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BatchCreateMutation, BatchCreateMutationVariables>(BatchCreateDocument, options);
      }
export type BatchCreateMutationHookResult = ReturnType<typeof useBatchCreateMutation>;
export type BatchCreateMutationResult = Apollo.MutationResult<BatchCreateMutation>;
export type BatchCreateMutationOptions = Apollo.BaseMutationOptions<BatchCreateMutation, BatchCreateMutationVariables>;
export const AssignBatchDocument = gql`
    mutation AssignBatch($input: BatchResponseAttachInput!) {
  batchResponseAttach(input: $input) {
    batch {
      id
      name
      displayName
      value
      card {
        id
        externalId
        attributes {
          batchValue
          creatorId
          responseId
        }
      }
      columnName
      status
      statusOrder
      topic {
        id
        name
      }
      metrics {
        openTickets
        medianAge
        oldestDate
      }
      latestExecution {
        id
        userId
        status
        macroId
        runAt
        createdAt
        ticketIds
        pqTicketIds
      }
      latestBulkApiSend {
        id
        status
        createdAt
        scheduledAt
      }
    }
  }
}
    `;
export type AssignBatchMutationFn = Apollo.MutationFunction<AssignBatchMutation, AssignBatchMutationVariables>;

/**
 * __useAssignBatchMutation__
 *
 * To run a mutation, you first call `useAssignBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignBatchMutation, { data, loading, error }] = useAssignBatchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignBatchMutation(baseOptions?: Apollo.MutationHookOptions<AssignBatchMutation, AssignBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignBatchMutation, AssignBatchMutationVariables>(AssignBatchDocument, options);
      }
export type AssignBatchMutationHookResult = ReturnType<typeof useAssignBatchMutation>;
export type AssignBatchMutationResult = Apollo.MutationResult<AssignBatchMutation>;
export type AssignBatchMutationOptions = Apollo.BaseMutationOptions<AssignBatchMutation, AssignBatchMutationVariables>;
export const ZendeskResponseCardsDocument = gql`
    query ZendeskResponseCards {
  zendeskResponseCards(filter: {activeEq: true, approvedEq: true}, limit: 10000) {
    collection {
      id
      attributes {
        batchValue
        responseId
      }
      title
    }
  }
}
    `;

/**
 * __useZendeskResponseCardsQuery__
 *
 * To run a query within a React component, call `useZendeskResponseCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useZendeskResponseCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZendeskResponseCardsQuery({
 *   variables: {
 *   },
 * });
 */
export function useZendeskResponseCardsQuery(baseOptions?: Apollo.QueryHookOptions<ZendeskResponseCardsQuery, ZendeskResponseCardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ZendeskResponseCardsQuery, ZendeskResponseCardsQueryVariables>(ZendeskResponseCardsDocument, options);
      }
export function useZendeskResponseCardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ZendeskResponseCardsQuery, ZendeskResponseCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ZendeskResponseCardsQuery, ZendeskResponseCardsQueryVariables>(ZendeskResponseCardsDocument, options);
        }
export type ZendeskResponseCardsQueryHookResult = ReturnType<typeof useZendeskResponseCardsQuery>;
export type ZendeskResponseCardsLazyQueryHookResult = ReturnType<typeof useZendeskResponseCardsLazyQuery>;
export type ZendeskResponseCardsQueryResult = Apollo.QueryResult<ZendeskResponseCardsQuery, ZendeskResponseCardsQueryVariables>;
export const BatchCancelSendDocument = gql`
    mutation BatchCancelSend($batchId: ID!) {
  batchCancelSend(batchId: $batchId) {
    success
  }
}
    `;
export type BatchCancelSendMutationFn = Apollo.MutationFunction<BatchCancelSendMutation, BatchCancelSendMutationVariables>;

/**
 * __useBatchCancelSendMutation__
 *
 * To run a mutation, you first call `useBatchCancelSendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchCancelSendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchCancelSendMutation, { data, loading, error }] = useBatchCancelSendMutation({
 *   variables: {
 *      batchId: // value for 'batchId'
 *   },
 * });
 */
export function useBatchCancelSendMutation(baseOptions?: Apollo.MutationHookOptions<BatchCancelSendMutation, BatchCancelSendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BatchCancelSendMutation, BatchCancelSendMutationVariables>(BatchCancelSendDocument, options);
      }
export type BatchCancelSendMutationHookResult = ReturnType<typeof useBatchCancelSendMutation>;
export type BatchCancelSendMutationResult = Apollo.MutationResult<BatchCancelSendMutation>;
export type BatchCancelSendMutationOptions = Apollo.BaseMutationOptions<BatchCancelSendMutation, BatchCancelSendMutationVariables>;
export const BatchDeleteDocument = gql`
    mutation BatchDelete($input: BatchDeleteInput!) {
  batchDelete(input: $input) {
    errors {
      message
    }
  }
}
    `;
export type BatchDeleteMutationFn = Apollo.MutationFunction<BatchDeleteMutation, BatchDeleteMutationVariables>;

/**
 * __useBatchDeleteMutation__
 *
 * To run a mutation, you first call `useBatchDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchDeleteMutation, { data, loading, error }] = useBatchDeleteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBatchDeleteMutation(baseOptions?: Apollo.MutationHookOptions<BatchDeleteMutation, BatchDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BatchDeleteMutation, BatchDeleteMutationVariables>(BatchDeleteDocument, options);
      }
export type BatchDeleteMutationHookResult = ReturnType<typeof useBatchDeleteMutation>;
export type BatchDeleteMutationResult = Apollo.MutationResult<BatchDeleteMutation>;
export type BatchDeleteMutationOptions = Apollo.BaseMutationOptions<BatchDeleteMutation, BatchDeleteMutationVariables>;
export const BatchUpdateDocument = gql`
    mutation BatchUpdate($input: BatchUpdateInput!) {
  batchUpdate(input: $input) {
    batch {
      id
      name
      displayName
      value
      card {
        id
        externalId
        attributes {
          batchValue
          creatorId
          responseId
        }
      }
      columnName
      status
      statusOrder
      topic {
        id
        name
      }
      metrics {
        openTickets
        medianAge
        oldestDate
      }
      latestExecution {
        id
        userId
        status
        macroId
        runAt
        createdAt
        ticketIds
        pqTicketIds
      }
      latestBulkApiSend {
        id
        status
        createdAt
        scheduledAt
      }
    }
  }
}
    `;
export type BatchUpdateMutationFn = Apollo.MutationFunction<BatchUpdateMutation, BatchUpdateMutationVariables>;

/**
 * __useBatchUpdateMutation__
 *
 * To run a mutation, you first call `useBatchUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchUpdateMutation, { data, loading, error }] = useBatchUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBatchUpdateMutation(baseOptions?: Apollo.MutationHookOptions<BatchUpdateMutation, BatchUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BatchUpdateMutation, BatchUpdateMutationVariables>(BatchUpdateDocument, options);
      }
export type BatchUpdateMutationHookResult = ReturnType<typeof useBatchUpdateMutation>;
export type BatchUpdateMutationResult = Apollo.MutationResult<BatchUpdateMutation>;
export type BatchUpdateMutationOptions = Apollo.BaseMutationOptions<BatchUpdateMutation, BatchUpdateMutationVariables>;
export const CampaignDocument = gql`
    query campaign($id: ID!) {
  campaign(id: $id) {
    id
    subject
    deliveryMethod
    audienceListId
    addTicketTags
    message
    html
    surveyId
    audienceFound
    audienceSize
    audienceSearchStartedAt
    tags
    physicalMailTemplate
    userTags
    excludedUserTags
    isEmailValidationEnabled
    isExcludeNewsSubEnabled
    isOnlyNewsSubEnabled
    scheduledAt
    isOnlyInDistrictVerifiedEnabled
    lastCampaignDate
    topics
    zipCodes
    counties
    status
    audienceList {
      name
      isArchived
      groups {
        createdAt
      }
      criteria {
        createdAt
      }
    }
  }
}
    `;

/**
 * __useCampaignQuery__
 *
 * To run a query within a React component, call `useCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCampaignQuery(baseOptions: Apollo.QueryHookOptions<CampaignQuery, CampaignQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignQuery, CampaignQueryVariables>(CampaignDocument, options);
      }
export function useCampaignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignQuery, CampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignQuery, CampaignQueryVariables>(CampaignDocument, options);
        }
export type CampaignQueryHookResult = ReturnType<typeof useCampaignQuery>;
export type CampaignLazyQueryHookResult = ReturnType<typeof useCampaignLazyQuery>;
export type CampaignQueryResult = Apollo.QueryResult<CampaignQuery, CampaignQueryVariables>;
export const CampaignsDocument = gql`
    query Campaigns($page: Int, $limit: Int, $query: String, $statusIn: [CampaignStatus!], $statusNotIn: [CampaignStatus!]) {
  campaigns(
    limit: $limit
    page: $page
    query: $query
    statusIn: $statusIn
    statusNotIn: $statusNotIn
  ) {
    collection {
      id
      subject
      name
      deliveryMethod
      audienceFound
      physicalMailJID
      jobsCompletedCount
      scheduledAt
      lastActionTakenAt
      jobsFailedCount
      jobsTotalCount
      status
      audienceSize
      audienceListId
      analytics {
        open
        linkClick
      }
    }
    metadata {
      currentPage
      totalPages
      totalCount
    }
  }
}
    `;

/**
 * __useCampaignsQuery__
 *
 * To run a query within a React component, call `useCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      query: // value for 'query'
 *      statusIn: // value for 'statusIn'
 *      statusNotIn: // value for 'statusNotIn'
 *   },
 * });
 */
export function useCampaignsQuery(baseOptions?: Apollo.QueryHookOptions<CampaignsQuery, CampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignsQuery, CampaignsQueryVariables>(CampaignsDocument, options);
      }
export function useCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignsQuery, CampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignsQuery, CampaignsQueryVariables>(CampaignsDocument, options);
        }
export type CampaignsQueryHookResult = ReturnType<typeof useCampaignsQuery>;
export type CampaignsLazyQueryHookResult = ReturnType<typeof useCampaignsLazyQuery>;
export type CampaignsQueryResult = Apollo.QueryResult<CampaignsQuery, CampaignsQueryVariables>;
export const CampaignDeleteDocument = gql`
    mutation campaignDelete($id: ID!) {
  campaignDelete(id: $id) {
    id
    isDeleted
  }
}
    `;
export type CampaignDeleteMutationFn = Apollo.MutationFunction<CampaignDeleteMutation, CampaignDeleteMutationVariables>;

/**
 * __useCampaignDeleteMutation__
 *
 * To run a mutation, you first call `useCampaignDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignDeleteMutation, { data, loading, error }] = useCampaignDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCampaignDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CampaignDeleteMutation, CampaignDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignDeleteMutation, CampaignDeleteMutationVariables>(CampaignDeleteDocument, options);
      }
export type CampaignDeleteMutationHookResult = ReturnType<typeof useCampaignDeleteMutation>;
export type CampaignDeleteMutationResult = Apollo.MutationResult<CampaignDeleteMutation>;
export type CampaignDeleteMutationOptions = Apollo.BaseMutationOptions<CampaignDeleteMutation, CampaignDeleteMutationVariables>;
export const DuplicateMailerDocument = gql`
    mutation duplicateMailer($campaignId: ID!, $subject: String!) {
  campaignDuplicate(input: {campaignId: $campaignId, subject: $subject}) {
    id
    subject
  }
}
    `;
export type DuplicateMailerMutationFn = Apollo.MutationFunction<DuplicateMailerMutation, DuplicateMailerMutationVariables>;

/**
 * __useDuplicateMailerMutation__
 *
 * To run a mutation, you first call `useDuplicateMailerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateMailerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateMailerMutation, { data, loading, error }] = useDuplicateMailerMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      subject: // value for 'subject'
 *   },
 * });
 */
export function useDuplicateMailerMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateMailerMutation, DuplicateMailerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateMailerMutation, DuplicateMailerMutationVariables>(DuplicateMailerDocument, options);
      }
export type DuplicateMailerMutationHookResult = ReturnType<typeof useDuplicateMailerMutation>;
export type DuplicateMailerMutationResult = Apollo.MutationResult<DuplicateMailerMutation>;
export type DuplicateMailerMutationOptions = Apollo.BaseMutationOptions<DuplicateMailerMutation, DuplicateMailerMutationVariables>;
export const UserUploadsDocument = gql`
    query UserUploads($page: Int, $limit: Int, $query: String) {
  userUploads(limit: $limit, page: $page, query: $query) {
    collection {
      id
      uploadTag
      status
      updatedAt
      jobsCompletedCount
      jobsFailedCount
      jobsTotalCount
      emailsAvailable
      uniqueHouseholds
      userCounts {
        queued
        failed
        created
        updated
      }
      error
    }
    metadata {
      currentPage
      currentPage
      totalPages
      totalCount
    }
  }
}
    `;

/**
 * __useUserUploadsQuery__
 *
 * To run a query within a React component, call `useUserUploadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserUploadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserUploadsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useUserUploadsQuery(baseOptions?: Apollo.QueryHookOptions<UserUploadsQuery, UserUploadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserUploadsQuery, UserUploadsQueryVariables>(UserUploadsDocument, options);
      }
export function useUserUploadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserUploadsQuery, UserUploadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserUploadsQuery, UserUploadsQueryVariables>(UserUploadsDocument, options);
        }
export type UserUploadsQueryHookResult = ReturnType<typeof useUserUploadsQuery>;
export type UserUploadsLazyQueryHookResult = ReturnType<typeof useUserUploadsLazyQuery>;
export type UserUploadsQueryResult = Apollo.QueryResult<UserUploadsQuery, UserUploadsQueryVariables>;
export const RefreshCampaignJobStatusDocument = gql`
    query refreshCampaignJobStatus($campaignId: ID!) {
  campaign(id: $campaignId) {
    id
    jobsFailedCount
    jobsTotalCount
    jobsCompletedCount
    status
    scheduledAt
    lastActionTakenAt
  }
}
    `;

/**
 * __useRefreshCampaignJobStatusQuery__
 *
 * To run a query within a React component, call `useRefreshCampaignJobStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useRefreshCampaignJobStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRefreshCampaignJobStatusQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useRefreshCampaignJobStatusQuery(baseOptions: Apollo.QueryHookOptions<RefreshCampaignJobStatusQuery, RefreshCampaignJobStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RefreshCampaignJobStatusQuery, RefreshCampaignJobStatusQueryVariables>(RefreshCampaignJobStatusDocument, options);
      }
export function useRefreshCampaignJobStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RefreshCampaignJobStatusQuery, RefreshCampaignJobStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RefreshCampaignJobStatusQuery, RefreshCampaignJobStatusQueryVariables>(RefreshCampaignJobStatusDocument, options);
        }
export type RefreshCampaignJobStatusQueryHookResult = ReturnType<typeof useRefreshCampaignJobStatusQuery>;
export type RefreshCampaignJobStatusLazyQueryHookResult = ReturnType<typeof useRefreshCampaignJobStatusLazyQuery>;
export type RefreshCampaignJobStatusQueryResult = Apollo.QueryResult<RefreshCampaignJobStatusQuery, RefreshCampaignJobStatusQueryVariables>;
export const L2UniversesDocument = gql`
    query l2Universes {
  universes(limit: 1000) {
    collection {
      id
      name
      cardinality
      dateCreated
      dateModified
      username
      csv {
        key
      }
    }
  }
}
    `;

/**
 * __useL2UniversesQuery__
 *
 * To run a query within a React component, call `useL2UniversesQuery` and pass it any options that fit your needs.
 * When your component renders, `useL2UniversesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useL2UniversesQuery({
 *   variables: {
 *   },
 * });
 */
export function useL2UniversesQuery(baseOptions?: Apollo.QueryHookOptions<L2UniversesQuery, L2UniversesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<L2UniversesQuery, L2UniversesQueryVariables>(L2UniversesDocument, options);
      }
export function useL2UniversesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<L2UniversesQuery, L2UniversesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<L2UniversesQuery, L2UniversesQueryVariables>(L2UniversesDocument, options);
        }
export type L2UniversesQueryHookResult = ReturnType<typeof useL2UniversesQuery>;
export type L2UniversesLazyQueryHookResult = ReturnType<typeof useL2UniversesLazyQuery>;
export type L2UniversesQueryResult = Apollo.QueryResult<L2UniversesQuery, L2UniversesQueryVariables>;
export const UpdateAudienceListDocument = gql`
    mutation UpdateAudienceList($input: AudienceListUpdateInput!) {
  audienceListUpdate(input: $input) {
    id
    name
    updatedAt
    groups {
      criteria {
        content
      }
    }
    criteria {
      content
    }
  }
}
    `;
export type UpdateAudienceListMutationFn = Apollo.MutationFunction<UpdateAudienceListMutation, UpdateAudienceListMutationVariables>;

/**
 * __useUpdateAudienceListMutation__
 *
 * To run a mutation, you first call `useUpdateAudienceListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAudienceListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAudienceListMutation, { data, loading, error }] = useUpdateAudienceListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAudienceListMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAudienceListMutation, UpdateAudienceListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAudienceListMutation, UpdateAudienceListMutationVariables>(UpdateAudienceListDocument, options);
      }
export type UpdateAudienceListMutationHookResult = ReturnType<typeof useUpdateAudienceListMutation>;
export type UpdateAudienceListMutationResult = Apollo.MutationResult<UpdateAudienceListMutation>;
export type UpdateAudienceListMutationOptions = Apollo.BaseMutationOptions<UpdateAudienceListMutation, UpdateAudienceListMutationVariables>;
export const AudienceListDocument = gql`
    query AudienceList($id: ID!) {
  audienceList(id: $id) {
    id
    name
    status
    totalAudienceSize
    isDraft
    searchedAt
    queryString
    groups {
      criteria {
        content
      }
    }
    criteria {
      content
    }
  }
}
    `;

/**
 * __useAudienceListQuery__
 *
 * To run a query within a React component, call `useAudienceListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAudienceListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAudienceListQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAudienceListQuery(baseOptions: Apollo.QueryHookOptions<AudienceListQuery, AudienceListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AudienceListQuery, AudienceListQueryVariables>(AudienceListDocument, options);
      }
export function useAudienceListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AudienceListQuery, AudienceListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AudienceListQuery, AudienceListQueryVariables>(AudienceListDocument, options);
        }
export type AudienceListQueryHookResult = ReturnType<typeof useAudienceListQuery>;
export type AudienceListLazyQueryHookResult = ReturnType<typeof useAudienceListLazyQuery>;
export type AudienceListQueryResult = Apollo.QueryResult<AudienceListQuery, AudienceListQueryVariables>;
export const UpdateAudienceListNameDocument = gql`
    mutation UpdateAudienceListName($input: AudienceListUpdateInput!) {
  audienceListUpdate(input: $input) {
    id
    name
    updatedAt
    isDraft
  }
}
    `;
export type UpdateAudienceListNameMutationFn = Apollo.MutationFunction<UpdateAudienceListNameMutation, UpdateAudienceListNameMutationVariables>;

/**
 * __useUpdateAudienceListNameMutation__
 *
 * To run a mutation, you first call `useUpdateAudienceListNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAudienceListNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAudienceListNameMutation, { data, loading, error }] = useUpdateAudienceListNameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAudienceListNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAudienceListNameMutation, UpdateAudienceListNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAudienceListNameMutation, UpdateAudienceListNameMutationVariables>(UpdateAudienceListNameDocument, options);
      }
export type UpdateAudienceListNameMutationHookResult = ReturnType<typeof useUpdateAudienceListNameMutation>;
export type UpdateAudienceListNameMutationResult = Apollo.MutationResult<UpdateAudienceListNameMutation>;
export type UpdateAudienceListNameMutationOptions = Apollo.BaseMutationOptions<UpdateAudienceListNameMutation, UpdateAudienceListNameMutationVariables>;
export const AudienceListCreateDocument = gql`
    mutation AudienceListCreate($input: AudienceListCreateInput!) {
  audienceListCreate(input: $input) {
    id
    isArchived
    status
    name
    createdAt
    updatedAt
    criteria {
      content
    }
    groups {
      criteria {
        content
      }
    }
  }
}
    `;
export type AudienceListCreateMutationFn = Apollo.MutationFunction<AudienceListCreateMutation, AudienceListCreateMutationVariables>;

/**
 * __useAudienceListCreateMutation__
 *
 * To run a mutation, you first call `useAudienceListCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAudienceListCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [audienceListCreateMutation, { data, loading, error }] = useAudienceListCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAudienceListCreateMutation(baseOptions?: Apollo.MutationHookOptions<AudienceListCreateMutation, AudienceListCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AudienceListCreateMutation, AudienceListCreateMutationVariables>(AudienceListCreateDocument, options);
      }
export type AudienceListCreateMutationHookResult = ReturnType<typeof useAudienceListCreateMutation>;
export type AudienceListCreateMutationResult = Apollo.MutationResult<AudienceListCreateMutation>;
export type AudienceListCreateMutationOptions = Apollo.BaseMutationOptions<AudienceListCreateMutation, AudienceListCreateMutationVariables>;
export const GenerateAudienceListPreviewDocument = gql`
    mutation GenerateAudienceListPreview($input: AudienceListPopulatePreviewInput!) {
  audienceListPopulatePreview(input: $input) {
    status
    id
    totalAudienceSize
    searchedAt
  }
}
    `;
export type GenerateAudienceListPreviewMutationFn = Apollo.MutationFunction<GenerateAudienceListPreviewMutation, GenerateAudienceListPreviewMutationVariables>;

/**
 * __useGenerateAudienceListPreviewMutation__
 *
 * To run a mutation, you first call `useGenerateAudienceListPreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateAudienceListPreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateAudienceListPreviewMutation, { data, loading, error }] = useGenerateAudienceListPreviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateAudienceListPreviewMutation(baseOptions?: Apollo.MutationHookOptions<GenerateAudienceListPreviewMutation, GenerateAudienceListPreviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateAudienceListPreviewMutation, GenerateAudienceListPreviewMutationVariables>(GenerateAudienceListPreviewDocument, options);
      }
export type GenerateAudienceListPreviewMutationHookResult = ReturnType<typeof useGenerateAudienceListPreviewMutation>;
export type GenerateAudienceListPreviewMutationResult = Apollo.MutationResult<GenerateAudienceListPreviewMutation>;
export type GenerateAudienceListPreviewMutationOptions = Apollo.BaseMutationOptions<GenerateAudienceListPreviewMutation, GenerateAudienceListPreviewMutationVariables>;
export const AudienceListStatusDocument = gql`
    query AudienceListStatus($id: ID!) {
  audienceList(id: $id) {
    id
    status
    totalAudienceSize
  }
}
    `;

/**
 * __useAudienceListStatusQuery__
 *
 * To run a query within a React component, call `useAudienceListStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useAudienceListStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAudienceListStatusQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAudienceListStatusQuery(baseOptions: Apollo.QueryHookOptions<AudienceListStatusQuery, AudienceListStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AudienceListStatusQuery, AudienceListStatusQueryVariables>(AudienceListStatusDocument, options);
      }
export function useAudienceListStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AudienceListStatusQuery, AudienceListStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AudienceListStatusQuery, AudienceListStatusQueryVariables>(AudienceListStatusDocument, options);
        }
export type AudienceListStatusQueryHookResult = ReturnType<typeof useAudienceListStatusQuery>;
export type AudienceListStatusLazyQueryHookResult = ReturnType<typeof useAudienceListStatusLazyQuery>;
export type AudienceListStatusQueryResult = Apollo.QueryResult<AudienceListStatusQuery, AudienceListStatusQueryVariables>;
export const AudienceListPreviewDocument = gql`
    query AudienceListPreview($id: ID!, $usersPage: Int!) {
  audienceList(id: $id) {
    id
    searchedAt
    users(limit: 50, page: $usersPage) {
      collection {
        id
        zendeskUser {
          id
          email
          name
          userFields
        }
      }
      metadata {
        totalCount
        totalPages
        currentPage
      }
    }
  }
}
    `;

/**
 * __useAudienceListPreviewQuery__
 *
 * To run a query within a React component, call `useAudienceListPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useAudienceListPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAudienceListPreviewQuery({
 *   variables: {
 *      id: // value for 'id'
 *      usersPage: // value for 'usersPage'
 *   },
 * });
 */
export function useAudienceListPreviewQuery(baseOptions: Apollo.QueryHookOptions<AudienceListPreviewQuery, AudienceListPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AudienceListPreviewQuery, AudienceListPreviewQueryVariables>(AudienceListPreviewDocument, options);
      }
export function useAudienceListPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AudienceListPreviewQuery, AudienceListPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AudienceListPreviewQuery, AudienceListPreviewQueryVariables>(AudienceListPreviewDocument, options);
        }
export type AudienceListPreviewQueryHookResult = ReturnType<typeof useAudienceListPreviewQuery>;
export type AudienceListPreviewLazyQueryHookResult = ReturnType<typeof useAudienceListPreviewLazyQuery>;
export type AudienceListPreviewQueryResult = Apollo.QueryResult<AudienceListPreviewQuery, AudienceListPreviewQueryVariables>;
export const AudienceListsDocument = gql`
    query AudienceLists($page: Int, $limit: Int, $query: String) {
  audienceLists(
    limit: $limit
    page: $page
    query: $query
    isDraft: false
    isArchived: false
  ) {
    collection {
      id
      name
      isDraft
      createdAt
      totalAudienceSize
      status
      totalAudienceSize
      searchedAt
      criteria {
        content
      }
      groups {
        criteria {
          content
        }
      }
    }
    metadata {
      currentPage
      limitValue
      totalCount
      totalPages
    }
  }
}
    `;

/**
 * __useAudienceListsQuery__
 *
 * To run a query within a React component, call `useAudienceListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAudienceListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAudienceListsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useAudienceListsQuery(baseOptions?: Apollo.QueryHookOptions<AudienceListsQuery, AudienceListsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AudienceListsQuery, AudienceListsQueryVariables>(AudienceListsDocument, options);
      }
export function useAudienceListsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AudienceListsQuery, AudienceListsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AudienceListsQuery, AudienceListsQueryVariables>(AudienceListsDocument, options);
        }
export type AudienceListsQueryHookResult = ReturnType<typeof useAudienceListsQuery>;
export type AudienceListsLazyQueryHookResult = ReturnType<typeof useAudienceListsLazyQuery>;
export type AudienceListsQueryResult = Apollo.QueryResult<AudienceListsQuery, AudienceListsQueryVariables>;
export const RenameListDocument = gql`
    mutation RenameList($input: AudienceListUpdateInput!) {
  audienceListUpdate(input: $input) {
    id
    name
  }
}
    `;
export type RenameListMutationFn = Apollo.MutationFunction<RenameListMutation, RenameListMutationVariables>;

/**
 * __useRenameListMutation__
 *
 * To run a mutation, you first call `useRenameListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameListMutation, { data, loading, error }] = useRenameListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRenameListMutation(baseOptions?: Apollo.MutationHookOptions<RenameListMutation, RenameListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenameListMutation, RenameListMutationVariables>(RenameListDocument, options);
      }
export type RenameListMutationHookResult = ReturnType<typeof useRenameListMutation>;
export type RenameListMutationResult = Apollo.MutationResult<RenameListMutation>;
export type RenameListMutationOptions = Apollo.BaseMutationOptions<RenameListMutation, RenameListMutationVariables>;
export const RefreshListImportJobStatusDocument = gql`
    query refreshListImportJobStatus($userUploadId: Int!) {
  userUpload(id: $userUploadId) {
    id
    status
    userCounts {
      queued
      failed
      created
      updated
    }
  }
}
    `;

/**
 * __useRefreshListImportJobStatusQuery__
 *
 * To run a query within a React component, call `useRefreshListImportJobStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useRefreshListImportJobStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRefreshListImportJobStatusQuery({
 *   variables: {
 *      userUploadId: // value for 'userUploadId'
 *   },
 * });
 */
export function useRefreshListImportJobStatusQuery(baseOptions: Apollo.QueryHookOptions<RefreshListImportJobStatusQuery, RefreshListImportJobStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RefreshListImportJobStatusQuery, RefreshListImportJobStatusQueryVariables>(RefreshListImportJobStatusDocument, options);
      }
export function useRefreshListImportJobStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RefreshListImportJobStatusQuery, RefreshListImportJobStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RefreshListImportJobStatusQuery, RefreshListImportJobStatusQueryVariables>(RefreshListImportJobStatusDocument, options);
        }
export type RefreshListImportJobStatusQueryHookResult = ReturnType<typeof useRefreshListImportJobStatusQuery>;
export type RefreshListImportJobStatusLazyQueryHookResult = ReturnType<typeof useRefreshListImportJobStatusLazyQuery>;
export type RefreshListImportJobStatusQueryResult = Apollo.QueryResult<RefreshListImportJobStatusQuery, RefreshListImportJobStatusQueryVariables>;
export const PhysicalMailerTemplatesDocument = gql`
    query physicalMailerTemplates {
  physicalMailerTemplates {
    collection {
      name
      templatesPerPage
      template {
        filename
        id
        key
        name
      }
    }
  }
}
    `;

/**
 * __usePhysicalMailerTemplatesQuery__
 *
 * To run a query within a React component, call `usePhysicalMailerTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePhysicalMailerTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePhysicalMailerTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePhysicalMailerTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<PhysicalMailerTemplatesQuery, PhysicalMailerTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PhysicalMailerTemplatesQuery, PhysicalMailerTemplatesQueryVariables>(PhysicalMailerTemplatesDocument, options);
      }
export function usePhysicalMailerTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PhysicalMailerTemplatesQuery, PhysicalMailerTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PhysicalMailerTemplatesQuery, PhysicalMailerTemplatesQueryVariables>(PhysicalMailerTemplatesDocument, options);
        }
export type PhysicalMailerTemplatesQueryHookResult = ReturnType<typeof usePhysicalMailerTemplatesQuery>;
export type PhysicalMailerTemplatesLazyQueryHookResult = ReturnType<typeof usePhysicalMailerTemplatesLazyQuery>;
export type PhysicalMailerTemplatesQueryResult = Apollo.QueryResult<PhysicalMailerTemplatesQuery, PhysicalMailerTemplatesQueryVariables>;
export const ExternalDataConstituentTagDataDocument = gql`
    query ExternalDataConstituentTagData {
  constituentTags(limit: 100000000) {
    id
    slug
    name
    constituentTagCategory {
      id
      name
    }
  }
  constituentTagCategories(limit: 100000000) {
    id
    name
  }
}
    `;

/**
 * __useExternalDataConstituentTagDataQuery__
 *
 * To run a query within a React component, call `useExternalDataConstituentTagDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalDataConstituentTagDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExternalDataConstituentTagDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useExternalDataConstituentTagDataQuery(baseOptions?: Apollo.QueryHookOptions<ExternalDataConstituentTagDataQuery, ExternalDataConstituentTagDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExternalDataConstituentTagDataQuery, ExternalDataConstituentTagDataQueryVariables>(ExternalDataConstituentTagDataDocument, options);
      }
export function useExternalDataConstituentTagDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExternalDataConstituentTagDataQuery, ExternalDataConstituentTagDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExternalDataConstituentTagDataQuery, ExternalDataConstituentTagDataQueryVariables>(ExternalDataConstituentTagDataDocument, options);
        }
export type ExternalDataConstituentTagDataQueryHookResult = ReturnType<typeof useExternalDataConstituentTagDataQuery>;
export type ExternalDataConstituentTagDataLazyQueryHookResult = ReturnType<typeof useExternalDataConstituentTagDataLazyQuery>;
export type ExternalDataConstituentTagDataQueryResult = Apollo.QueryResult<ExternalDataConstituentTagDataQuery, ExternalDataConstituentTagDataQueryVariables>;
export const ExternalDataCreateConstituentTagDocument = gql`
    mutation ExternalDataCreateConstituentTag($input: ConstituentTagCreateInput!) {
  constituentTagCreate(input: $input) {
    constituentTag {
      id
      slug
      name
      constituentTagCategory {
        id
        name
      }
    }
    errors {
      message
    }
  }
}
    `;
export type ExternalDataCreateConstituentTagMutationFn = Apollo.MutationFunction<ExternalDataCreateConstituentTagMutation, ExternalDataCreateConstituentTagMutationVariables>;

/**
 * __useExternalDataCreateConstituentTagMutation__
 *
 * To run a mutation, you first call `useExternalDataCreateConstituentTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExternalDataCreateConstituentTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [externalDataCreateConstituentTagMutation, { data, loading, error }] = useExternalDataCreateConstituentTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExternalDataCreateConstituentTagMutation(baseOptions?: Apollo.MutationHookOptions<ExternalDataCreateConstituentTagMutation, ExternalDataCreateConstituentTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExternalDataCreateConstituentTagMutation, ExternalDataCreateConstituentTagMutationVariables>(ExternalDataCreateConstituentTagDocument, options);
      }
export type ExternalDataCreateConstituentTagMutationHookResult = ReturnType<typeof useExternalDataCreateConstituentTagMutation>;
export type ExternalDataCreateConstituentTagMutationResult = Apollo.MutationResult<ExternalDataCreateConstituentTagMutation>;
export type ExternalDataCreateConstituentTagMutationOptions = Apollo.BaseMutationOptions<ExternalDataCreateConstituentTagMutation, ExternalDataCreateConstituentTagMutationVariables>;
export const ArchiveListDocument = gql`
    mutation ArchiveList($id: ID!) {
  audienceListArchive(id: $id) {
    id
    isArchived
  }
}
    `;
export type ArchiveListMutationFn = Apollo.MutationFunction<ArchiveListMutation, ArchiveListMutationVariables>;

/**
 * __useArchiveListMutation__
 *
 * To run a mutation, you first call `useArchiveListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveListMutation, { data, loading, error }] = useArchiveListMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveListMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveListMutation, ArchiveListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveListMutation, ArchiveListMutationVariables>(ArchiveListDocument, options);
      }
export type ArchiveListMutationHookResult = ReturnType<typeof useArchiveListMutation>;
export type ArchiveListMutationResult = Apollo.MutationResult<ArchiveListMutation>;
export type ArchiveListMutationOptions = Apollo.BaseMutationOptions<ArchiveListMutation, ArchiveListMutationVariables>;
export const GetPhysicalMailDownloadUrlDocument = gql`
    query getPhysicalMailDownloadUrl($jid: ID!) {
  physicalMailer(jid: $jid) {
    url
  }
}
    `;

/**
 * __useGetPhysicalMailDownloadUrlQuery__
 *
 * To run a query within a React component, call `useGetPhysicalMailDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPhysicalMailDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPhysicalMailDownloadUrlQuery({
 *   variables: {
 *      jid: // value for 'jid'
 *   },
 * });
 */
export function useGetPhysicalMailDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<GetPhysicalMailDownloadUrlQuery, GetPhysicalMailDownloadUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPhysicalMailDownloadUrlQuery, GetPhysicalMailDownloadUrlQueryVariables>(GetPhysicalMailDownloadUrlDocument, options);
      }
export function useGetPhysicalMailDownloadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPhysicalMailDownloadUrlQuery, GetPhysicalMailDownloadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPhysicalMailDownloadUrlQuery, GetPhysicalMailDownloadUrlQueryVariables>(GetPhysicalMailDownloadUrlDocument, options);
        }
export type GetPhysicalMailDownloadUrlQueryHookResult = ReturnType<typeof useGetPhysicalMailDownloadUrlQuery>;
export type GetPhysicalMailDownloadUrlLazyQueryHookResult = ReturnType<typeof useGetPhysicalMailDownloadUrlLazyQuery>;
export type GetPhysicalMailDownloadUrlQueryResult = Apollo.QueryResult<GetPhysicalMailDownloadUrlQuery, GetPhysicalMailDownloadUrlQueryVariables>;
export const CampaignReportModalDocument = gql`
    query campaignReportModal($id: ID!) {
  campaign(id: $id) {
    id
    createdAt
    audienceFound
    deliveryMethod
    audienceSize
    totalAcceptedRecipients
    subject
    status
    surveyId
    analyticsSyncedAt
    totalUnsubscribes
    analytics {
      open
      linkClick
      bounce
      invalidatedByCansend
      deliveries
      subscribes
      injected
    }
    subscribers
  }
}
    `;

/**
 * __useCampaignReportModalQuery__
 *
 * To run a query within a React component, call `useCampaignReportModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignReportModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignReportModalQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCampaignReportModalQuery(baseOptions: Apollo.QueryHookOptions<CampaignReportModalQuery, CampaignReportModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignReportModalQuery, CampaignReportModalQueryVariables>(CampaignReportModalDocument, options);
      }
export function useCampaignReportModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignReportModalQuery, CampaignReportModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignReportModalQuery, CampaignReportModalQueryVariables>(CampaignReportModalDocument, options);
        }
export type CampaignReportModalQueryHookResult = ReturnType<typeof useCampaignReportModalQuery>;
export type CampaignReportModalLazyQueryHookResult = ReturnType<typeof useCampaignReportModalLazyQuery>;
export type CampaignReportModalQueryResult = Apollo.QueryResult<CampaignReportModalQuery, CampaignReportModalQueryVariables>;
export const SearchResultCountsDocument = gql`
    query SearchResultCounts($query: String) {
  draftCampaigns: campaigns(query: $query, limit: 0, statusIn: [draft, scheduled]) {
    metadata {
      totalCount
    }
  }
  completedCampaigns: campaigns(
    query: $query
    limit: 0
    statusNotIn: [draft, scheduled, found]
  ) {
    metadata {
      totalCount
    }
  }
  userUploads(query: $query, limit: 0) {
    metadata {
      totalCount
    }
  }
  audienceLists(query: $query, limit: 0) {
    metadata {
      totalCount
    }
  }
}
    `;

/**
 * __useSearchResultCountsQuery__
 *
 * To run a query within a React component, call `useSearchResultCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchResultCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchResultCountsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSearchResultCountsQuery(baseOptions?: Apollo.QueryHookOptions<SearchResultCountsQuery, SearchResultCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchResultCountsQuery, SearchResultCountsQueryVariables>(SearchResultCountsDocument, options);
      }
export function useSearchResultCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchResultCountsQuery, SearchResultCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchResultCountsQuery, SearchResultCountsQueryVariables>(SearchResultCountsDocument, options);
        }
export type SearchResultCountsQueryHookResult = ReturnType<typeof useSearchResultCountsQuery>;
export type SearchResultCountsLazyQueryHookResult = ReturnType<typeof useSearchResultCountsLazyQuery>;
export type SearchResultCountsQueryResult = Apollo.QueryResult<SearchResultCountsQuery, SearchResultCountsQueryVariables>;
export const UpdateCampaignInStep2Document = gql`
    mutation updateCampaignInStep2($input: CampaignInput!) {
  campaignUpdate(input: $input) {
    id
    status
    deliveryMethod
    audienceSize
    isOnlyNewsSubEnabled
    isEmailValidationEnabled
    isOnlyInDistrictVerifiedEnabled
    isExcludeNewsSubEnabled
    lastCampaignDate
    audienceSearchStartedAt
  }
}
    `;
export type UpdateCampaignInStep2MutationFn = Apollo.MutationFunction<UpdateCampaignInStep2Mutation, UpdateCampaignInStep2MutationVariables>;

/**
 * __useUpdateCampaignInStep2Mutation__
 *
 * To run a mutation, you first call `useUpdateCampaignInStep2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampaignInStep2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampaignInStep2Mutation, { data, loading, error }] = useUpdateCampaignInStep2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCampaignInStep2Mutation(baseOptions?: Apollo.MutationHookOptions<UpdateCampaignInStep2Mutation, UpdateCampaignInStep2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCampaignInStep2Mutation, UpdateCampaignInStep2MutationVariables>(UpdateCampaignInStep2Document, options);
      }
export type UpdateCampaignInStep2MutationHookResult = ReturnType<typeof useUpdateCampaignInStep2Mutation>;
export type UpdateCampaignInStep2MutationResult = Apollo.MutationResult<UpdateCampaignInStep2Mutation>;
export type UpdateCampaignInStep2MutationOptions = Apollo.BaseMutationOptions<UpdateCampaignInStep2Mutation, UpdateCampaignInStep2MutationVariables>;
export const CreateCampaignInStep2Document = gql`
    mutation createCampaignInStep2($input: CampaignCreateInput!) {
  campaignCreate(input: $input) {
    id
    status
    deliveryMethod
    audienceSize
    isOnlyNewsSubEnabled
    isEmailValidationEnabled
    isOnlyInDistrictVerifiedEnabled
    isExcludeNewsSubEnabled
    lastCampaignDate
    audienceSearchStartedAt
  }
}
    `;
export type CreateCampaignInStep2MutationFn = Apollo.MutationFunction<CreateCampaignInStep2Mutation, CreateCampaignInStep2MutationVariables>;

/**
 * __useCreateCampaignInStep2Mutation__
 *
 * To run a mutation, you first call `useCreateCampaignInStep2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCampaignInStep2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCampaignInStep2Mutation, { data, loading, error }] = useCreateCampaignInStep2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCampaignInStep2Mutation(baseOptions?: Apollo.MutationHookOptions<CreateCampaignInStep2Mutation, CreateCampaignInStep2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCampaignInStep2Mutation, CreateCampaignInStep2MutationVariables>(CreateCampaignInStep2Document, options);
      }
export type CreateCampaignInStep2MutationHookResult = ReturnType<typeof useCreateCampaignInStep2Mutation>;
export type CreateCampaignInStep2MutationResult = Apollo.MutationResult<CreateCampaignInStep2Mutation>;
export type CreateCampaignInStep2MutationOptions = Apollo.BaseMutationOptions<CreateCampaignInStep2Mutation, CreateCampaignInStep2MutationVariables>;
export const PopulateAudienceForCampaignDocument = gql`
    mutation populateAudienceForCampaign($input: AudienceListPopulateBulkMailInput!) {
  audienceListPopulateBulkMail(input: $input) {
    bulkMail {
      id
      status
      audienceSize
      audienceFound
      audienceSearchStartedAt
    }
    audienceList {
      id
      status
    }
  }
}
    `;
export type PopulateAudienceForCampaignMutationFn = Apollo.MutationFunction<PopulateAudienceForCampaignMutation, PopulateAudienceForCampaignMutationVariables>;

/**
 * __usePopulateAudienceForCampaignMutation__
 *
 * To run a mutation, you first call `usePopulateAudienceForCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePopulateAudienceForCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [populateAudienceForCampaignMutation, { data, loading, error }] = usePopulateAudienceForCampaignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePopulateAudienceForCampaignMutation(baseOptions?: Apollo.MutationHookOptions<PopulateAudienceForCampaignMutation, PopulateAudienceForCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PopulateAudienceForCampaignMutation, PopulateAudienceForCampaignMutationVariables>(PopulateAudienceForCampaignDocument, options);
      }
export type PopulateAudienceForCampaignMutationHookResult = ReturnType<typeof usePopulateAudienceForCampaignMutation>;
export type PopulateAudienceForCampaignMutationResult = Apollo.MutationResult<PopulateAudienceForCampaignMutation>;
export type PopulateAudienceForCampaignMutationOptions = Apollo.BaseMutationOptions<PopulateAudienceForCampaignMutation, PopulateAudienceForCampaignMutationVariables>;
export const AudienceListsForSearchDocument = gql`
    query audienceListsForSearch {
  audienceLists(limit: 10000, page: 1, isDraft: false, isArchived: false) {
    collection {
      id
      name
      status
      totalAudienceSize
    }
  }
}
    `;

/**
 * __useAudienceListsForSearchQuery__
 *
 * To run a query within a React component, call `useAudienceListsForSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useAudienceListsForSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAudienceListsForSearchQuery({
 *   variables: {
 *   },
 * });
 */
export function useAudienceListsForSearchQuery(baseOptions?: Apollo.QueryHookOptions<AudienceListsForSearchQuery, AudienceListsForSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AudienceListsForSearchQuery, AudienceListsForSearchQueryVariables>(AudienceListsForSearchDocument, options);
      }
export function useAudienceListsForSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AudienceListsForSearchQuery, AudienceListsForSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AudienceListsForSearchQuery, AudienceListsForSearchQueryVariables>(AudienceListsForSearchDocument, options);
        }
export type AudienceListsForSearchQueryHookResult = ReturnType<typeof useAudienceListsForSearchQuery>;
export type AudienceListsForSearchLazyQueryHookResult = ReturnType<typeof useAudienceListsForSearchLazyQuery>;
export type AudienceListsForSearchQueryResult = Apollo.QueryResult<AudienceListsForSearchQuery, AudienceListsForSearchQueryVariables>;
export const StatusOfCampaignDocument = gql`
    query statusOfCampaign($id: ID!) {
  campaign(id: $id) {
    id
    status
    audienceFound
  }
}
    `;

/**
 * __useStatusOfCampaignQuery__
 *
 * To run a query within a React component, call `useStatusOfCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useStatusOfCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStatusOfCampaignQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStatusOfCampaignQuery(baseOptions: Apollo.QueryHookOptions<StatusOfCampaignQuery, StatusOfCampaignQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StatusOfCampaignQuery, StatusOfCampaignQueryVariables>(StatusOfCampaignDocument, options);
      }
export function useStatusOfCampaignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StatusOfCampaignQuery, StatusOfCampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StatusOfCampaignQuery, StatusOfCampaignQueryVariables>(StatusOfCampaignDocument, options);
        }
export type StatusOfCampaignQueryHookResult = ReturnType<typeof useStatusOfCampaignQuery>;
export type StatusOfCampaignLazyQueryHookResult = ReturnType<typeof useStatusOfCampaignLazyQuery>;
export type StatusOfCampaignQueryResult = Apollo.QueryResult<StatusOfCampaignQuery, StatusOfCampaignQueryVariables>;
export const ShowBatchJobDocument = gql`
    query showBatchJob($id: ID!) {
  asyncBatchJob(id: $id) {
    id
    isComplete
    successPct
  }
}
    `;

/**
 * __useShowBatchJobQuery__
 *
 * To run a query within a React component, call `useShowBatchJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useShowBatchJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShowBatchJobQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useShowBatchJobQuery(baseOptions: Apollo.QueryHookOptions<ShowBatchJobQuery, ShowBatchJobQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShowBatchJobQuery, ShowBatchJobQueryVariables>(ShowBatchJobDocument, options);
      }
export function useShowBatchJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShowBatchJobQuery, ShowBatchJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShowBatchJobQuery, ShowBatchJobQueryVariables>(ShowBatchJobDocument, options);
        }
export type ShowBatchJobQueryHookResult = ReturnType<typeof useShowBatchJobQuery>;
export type ShowBatchJobLazyQueryHookResult = ReturnType<typeof useShowBatchJobLazyQuery>;
export type ShowBatchJobQueryResult = Apollo.QueryResult<ShowBatchJobQuery, ShowBatchJobQueryVariables>;
export const RefreshUniversesDocument = gql`
    mutation refreshUniverses($clientMutationId: String!) {
  universesRefreshJob(
    input: {enableDownload: true, enableSync: true, clientMutationId: $clientMutationId}
  ) {
    jobId
  }
}
    `;
export type RefreshUniversesMutationFn = Apollo.MutationFunction<RefreshUniversesMutation, RefreshUniversesMutationVariables>;

/**
 * __useRefreshUniversesMutation__
 *
 * To run a mutation, you first call `useRefreshUniversesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshUniversesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshUniversesMutation, { data, loading, error }] = useRefreshUniversesMutation({
 *   variables: {
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useRefreshUniversesMutation(baseOptions?: Apollo.MutationHookOptions<RefreshUniversesMutation, RefreshUniversesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshUniversesMutation, RefreshUniversesMutationVariables>(RefreshUniversesDocument, options);
      }
export type RefreshUniversesMutationHookResult = ReturnType<typeof useRefreshUniversesMutation>;
export type RefreshUniversesMutationResult = Apollo.MutationResult<RefreshUniversesMutation>;
export type RefreshUniversesMutationOptions = Apollo.BaseMutationOptions<RefreshUniversesMutation, RefreshUniversesMutationVariables>;
export const SaveScheduleDocument = gql`
    mutation saveSchedule($id: ID!, $status: CampaignStatus, $scheduledAt: ISO8601DateTime) {
  campaignUpdate(input: {id: $id, status: $status, scheduledAt: $scheduledAt}) {
    id
    status
    scheduledAt
  }
}
    `;
export type SaveScheduleMutationFn = Apollo.MutationFunction<SaveScheduleMutation, SaveScheduleMutationVariables>;

/**
 * __useSaveScheduleMutation__
 *
 * To run a mutation, you first call `useSaveScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveScheduleMutation, { data, loading, error }] = useSaveScheduleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *      scheduledAt: // value for 'scheduledAt'
 *   },
 * });
 */
export function useSaveScheduleMutation(baseOptions?: Apollo.MutationHookOptions<SaveScheduleMutation, SaveScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveScheduleMutation, SaveScheduleMutationVariables>(SaveScheduleDocument, options);
      }
export type SaveScheduleMutationHookResult = ReturnType<typeof useSaveScheduleMutation>;
export type SaveScheduleMutationResult = Apollo.MutationResult<SaveScheduleMutation>;
export type SaveScheduleMutationOptions = Apollo.BaseMutationOptions<SaveScheduleMutation, SaveScheduleMutationVariables>;
export const GetCampaignScheduleDocument = gql`
    query getCampaignSchedule($id: ID!) {
  campaign(id: $id) {
    id
    scheduledAt
    status
    subject
    html
  }
}
    `;

/**
 * __useGetCampaignScheduleQuery__
 *
 * To run a query within a React component, call `useGetCampaignScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignScheduleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCampaignScheduleQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignScheduleQuery, GetCampaignScheduleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignScheduleQuery, GetCampaignScheduleQueryVariables>(GetCampaignScheduleDocument, options);
      }
export function useGetCampaignScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignScheduleQuery, GetCampaignScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignScheduleQuery, GetCampaignScheduleQueryVariables>(GetCampaignScheduleDocument, options);
        }
export type GetCampaignScheduleQueryHookResult = ReturnType<typeof useGetCampaignScheduleQuery>;
export type GetCampaignScheduleLazyQueryHookResult = ReturnType<typeof useGetCampaignScheduleLazyQuery>;
export type GetCampaignScheduleQueryResult = Apollo.QueryResult<GetCampaignScheduleQuery, GetCampaignScheduleQueryVariables>;
export const SaveDraftStep3Document = gql`
    mutation saveDraftStep3($id: ID!, $status: CampaignStatus, $subject: String, $message: String, $html: String, $addTicketTags: [String!], $delivery_method: DeliveryMethod, $physicalMailTemplate: String, $skipSurveyCheck: Boolean) {
  campaignUpdate(
    input: {id: $id, subject: $subject, deliveryMethod: $delivery_method, message: $message, html: $html, addTicketTags: $addTicketTags, status: $status, physicalMailTemplate: $physicalMailTemplate, skipSurveyCheck: $skipSurveyCheck}
  ) {
    id
    status
    subject
    message
    html
    deliveryMethod
    physicalMailTemplate
    lastActionTakenAt
    status
  }
}
    `;
export type SaveDraftStep3MutationFn = Apollo.MutationFunction<SaveDraftStep3Mutation, SaveDraftStep3MutationVariables>;

/**
 * __useSaveDraftStep3Mutation__
 *
 * To run a mutation, you first call `useSaveDraftStep3Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveDraftStep3Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveDraftStep3Mutation, { data, loading, error }] = useSaveDraftStep3Mutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *      subject: // value for 'subject'
 *      message: // value for 'message'
 *      html: // value for 'html'
 *      addTicketTags: // value for 'addTicketTags'
 *      delivery_method: // value for 'delivery_method'
 *      physicalMailTemplate: // value for 'physicalMailTemplate'
 *      skipSurveyCheck: // value for 'skipSurveyCheck'
 *   },
 * });
 */
export function useSaveDraftStep3Mutation(baseOptions?: Apollo.MutationHookOptions<SaveDraftStep3Mutation, SaveDraftStep3MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveDraftStep3Mutation, SaveDraftStep3MutationVariables>(SaveDraftStep3Document, options);
      }
export type SaveDraftStep3MutationHookResult = ReturnType<typeof useSaveDraftStep3Mutation>;
export type SaveDraftStep3MutationResult = Apollo.MutationResult<SaveDraftStep3Mutation>;
export type SaveDraftStep3MutationOptions = Apollo.BaseMutationOptions<SaveDraftStep3Mutation, SaveDraftStep3MutationVariables>;
export const CreatePhysicalMailerDocument = gql`
    mutation createPhysicalMailer($input: PhysicalMailInput!) {
  campaignPhysicalMailCreate(input: $input) {
    jid
    status
  }
}
    `;
export type CreatePhysicalMailerMutationFn = Apollo.MutationFunction<CreatePhysicalMailerMutation, CreatePhysicalMailerMutationVariables>;

/**
 * __useCreatePhysicalMailerMutation__
 *
 * To run a mutation, you first call `useCreatePhysicalMailerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePhysicalMailerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPhysicalMailerMutation, { data, loading, error }] = useCreatePhysicalMailerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePhysicalMailerMutation(baseOptions?: Apollo.MutationHookOptions<CreatePhysicalMailerMutation, CreatePhysicalMailerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePhysicalMailerMutation, CreatePhysicalMailerMutationVariables>(CreatePhysicalMailerDocument, options);
      }
export type CreatePhysicalMailerMutationHookResult = ReturnType<typeof useCreatePhysicalMailerMutation>;
export type CreatePhysicalMailerMutationResult = Apollo.MutationResult<CreatePhysicalMailerMutation>;
export type CreatePhysicalMailerMutationOptions = Apollo.BaseMutationOptions<CreatePhysicalMailerMutation, CreatePhysicalMailerMutationVariables>;
export const PreviewPhysicalMailerDocument = gql`
    mutation PreviewPhysicalMailer($input: PhysicalMailInput!) {
  campaignPhysicalMailPreview(input: $input) {
    content
  }
}
    `;
export type PreviewPhysicalMailerMutationFn = Apollo.MutationFunction<PreviewPhysicalMailerMutation, PreviewPhysicalMailerMutationVariables>;

/**
 * __usePreviewPhysicalMailerMutation__
 *
 * To run a mutation, you first call `usePreviewPhysicalMailerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePreviewPhysicalMailerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [previewPhysicalMailerMutation, { data, loading, error }] = usePreviewPhysicalMailerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePreviewPhysicalMailerMutation(baseOptions?: Apollo.MutationHookOptions<PreviewPhysicalMailerMutation, PreviewPhysicalMailerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PreviewPhysicalMailerMutation, PreviewPhysicalMailerMutationVariables>(PreviewPhysicalMailerDocument, options);
      }
export type PreviewPhysicalMailerMutationHookResult = ReturnType<typeof usePreviewPhysicalMailerMutation>;
export type PreviewPhysicalMailerMutationResult = Apollo.MutationResult<PreviewPhysicalMailerMutation>;
export type PreviewPhysicalMailerMutationOptions = Apollo.BaseMutationOptions<PreviewPhysicalMailerMutation, PreviewPhysicalMailerMutationVariables>;
export const GetCampaignDocument = gql`
    query getCampaign($id: ID!) {
  campaign(id: $id) {
    id
    scheduledAt
    status
  }
}
    `;

/**
 * __useGetCampaignQuery__
 *
 * To run a query within a React component, call `useGetCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCampaignQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignQuery, GetCampaignQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignQuery, GetCampaignQueryVariables>(GetCampaignDocument, options);
      }
export function useGetCampaignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignQuery, GetCampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignQuery, GetCampaignQueryVariables>(GetCampaignDocument, options);
        }
export type GetCampaignQueryHookResult = ReturnType<typeof useGetCampaignQuery>;
export type GetCampaignLazyQueryHookResult = ReturnType<typeof useGetCampaignLazyQuery>;
export type GetCampaignQueryResult = Apollo.QueryResult<GetCampaignQuery, GetCampaignQueryVariables>;
export const CampaignTestSendDocument = gql`
    mutation campaignTestSend($input: CampaignTestSendInput!) {
  campaignTestSend(input: $input) {
    id
    name
    status
  }
}
    `;
export type CampaignTestSendMutationFn = Apollo.MutationFunction<CampaignTestSendMutation, CampaignTestSendMutationVariables>;

/**
 * __useCampaignTestSendMutation__
 *
 * To run a mutation, you first call `useCampaignTestSendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignTestSendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignTestSendMutation, { data, loading, error }] = useCampaignTestSendMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCampaignTestSendMutation(baseOptions?: Apollo.MutationHookOptions<CampaignTestSendMutation, CampaignTestSendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignTestSendMutation, CampaignTestSendMutationVariables>(CampaignTestSendDocument, options);
      }
export type CampaignTestSendMutationHookResult = ReturnType<typeof useCampaignTestSendMutation>;
export type CampaignTestSendMutationResult = Apollo.MutationResult<CampaignTestSendMutation>;
export type CampaignTestSendMutationOptions = Apollo.BaseMutationOptions<CampaignTestSendMutation, CampaignTestSendMutationVariables>;
export const SnapshotConstituentTagsDocument = gql`
    query SnapshotConstituentTags {
  constituentTags(limit: 100000000) {
    id
    slug
    name
    constituentTagCategory {
      id
      name
    }
  }
}
    `;

/**
 * __useSnapshotConstituentTagsQuery__
 *
 * To run a query within a React component, call `useSnapshotConstituentTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSnapshotConstituentTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSnapshotConstituentTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSnapshotConstituentTagsQuery(baseOptions?: Apollo.QueryHookOptions<SnapshotConstituentTagsQuery, SnapshotConstituentTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SnapshotConstituentTagsQuery, SnapshotConstituentTagsQueryVariables>(SnapshotConstituentTagsDocument, options);
      }
export function useSnapshotConstituentTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SnapshotConstituentTagsQuery, SnapshotConstituentTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SnapshotConstituentTagsQuery, SnapshotConstituentTagsQueryVariables>(SnapshotConstituentTagsDocument, options);
        }
export type SnapshotConstituentTagsQueryHookResult = ReturnType<typeof useSnapshotConstituentTagsQuery>;
export type SnapshotConstituentTagsLazyQueryHookResult = ReturnType<typeof useSnapshotConstituentTagsLazyQuery>;
export type SnapshotConstituentTagsQueryResult = Apollo.QueryResult<SnapshotConstituentTagsQuery, SnapshotConstituentTagsQueryVariables>;
export const SnapshotConstituentCategoriesDocument = gql`
    query SnapshotConstituentCategories {
  constituentTagCategories(limit: 100000000) {
    id
    name
  }
}
    `;

/**
 * __useSnapshotConstituentCategoriesQuery__
 *
 * To run a query within a React component, call `useSnapshotConstituentCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSnapshotConstituentCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSnapshotConstituentCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSnapshotConstituentCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<SnapshotConstituentCategoriesQuery, SnapshotConstituentCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SnapshotConstituentCategoriesQuery, SnapshotConstituentCategoriesQueryVariables>(SnapshotConstituentCategoriesDocument, options);
      }
export function useSnapshotConstituentCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SnapshotConstituentCategoriesQuery, SnapshotConstituentCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SnapshotConstituentCategoriesQuery, SnapshotConstituentCategoriesQueryVariables>(SnapshotConstituentCategoriesDocument, options);
        }
export type SnapshotConstituentCategoriesQueryHookResult = ReturnType<typeof useSnapshotConstituentCategoriesQuery>;
export type SnapshotConstituentCategoriesLazyQueryHookResult = ReturnType<typeof useSnapshotConstituentCategoriesLazyQuery>;
export type SnapshotConstituentCategoriesQueryResult = Apollo.QueryResult<SnapshotConstituentCategoriesQuery, SnapshotConstituentCategoriesQueryVariables>;
export const SnapshotCreateConstituentTagDocument = gql`
    mutation SnapshotCreateConstituentTag($input: ConstituentTagCreateInput!) {
  constituentTagCreate(input: $input) {
    constituentTag {
      id
      slug
      name
      constituentTagCategory {
        id
        name
      }
    }
    errors {
      message
    }
  }
}
    `;
export type SnapshotCreateConstituentTagMutationFn = Apollo.MutationFunction<SnapshotCreateConstituentTagMutation, SnapshotCreateConstituentTagMutationVariables>;

/**
 * __useSnapshotCreateConstituentTagMutation__
 *
 * To run a mutation, you first call `useSnapshotCreateConstituentTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSnapshotCreateConstituentTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [snapshotCreateConstituentTagMutation, { data, loading, error }] = useSnapshotCreateConstituentTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSnapshotCreateConstituentTagMutation(baseOptions?: Apollo.MutationHookOptions<SnapshotCreateConstituentTagMutation, SnapshotCreateConstituentTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SnapshotCreateConstituentTagMutation, SnapshotCreateConstituentTagMutationVariables>(SnapshotCreateConstituentTagDocument, options);
      }
export type SnapshotCreateConstituentTagMutationHookResult = ReturnType<typeof useSnapshotCreateConstituentTagMutation>;
export type SnapshotCreateConstituentTagMutationResult = Apollo.MutationResult<SnapshotCreateConstituentTagMutation>;
export type SnapshotCreateConstituentTagMutationOptions = Apollo.BaseMutationOptions<SnapshotCreateConstituentTagMutation, SnapshotCreateConstituentTagMutationVariables>;
export const ConstituentTagsDocument = gql`
    query ConstituentTags($page: Int, $limit: Int, $filter: ConstituentTagFilter) {
  constituentTags(limit: $limit, page: $page, filter: $filter) {
    id
    name
    slug
    createdAt
    updatedAt
    constituentTagCategory {
      id
      name
      updatedAt
      createdAt
    }
  }
}
    `;

/**
 * __useConstituentTagsQuery__
 *
 * To run a query within a React component, call `useConstituentTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConstituentTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConstituentTagsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useConstituentTagsQuery(baseOptions?: Apollo.QueryHookOptions<ConstituentTagsQuery, ConstituentTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConstituentTagsQuery, ConstituentTagsQueryVariables>(ConstituentTagsDocument, options);
      }
export function useConstituentTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConstituentTagsQuery, ConstituentTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConstituentTagsQuery, ConstituentTagsQueryVariables>(ConstituentTagsDocument, options);
        }
export type ConstituentTagsQueryHookResult = ReturnType<typeof useConstituentTagsQuery>;
export type ConstituentTagsLazyQueryHookResult = ReturnType<typeof useConstituentTagsLazyQuery>;
export type ConstituentTagsQueryResult = Apollo.QueryResult<ConstituentTagsQuery, ConstituentTagsQueryVariables>;
export const ConstituentTagCategoriesDocument = gql`
    query ConstituentTagCategories($page: Int, $limit: Int, $filter: ConstituentTagCategoryFilter) {
  constituentTagCategories(limit: $limit, page: $page, filter: $filter) {
    id
    name
    updatedAt
    createdAt
  }
}
    `;

/**
 * __useConstituentTagCategoriesQuery__
 *
 * To run a query within a React component, call `useConstituentTagCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useConstituentTagCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConstituentTagCategoriesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useConstituentTagCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<ConstituentTagCategoriesQuery, ConstituentTagCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConstituentTagCategoriesQuery, ConstituentTagCategoriesQueryVariables>(ConstituentTagCategoriesDocument, options);
      }
export function useConstituentTagCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConstituentTagCategoriesQuery, ConstituentTagCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConstituentTagCategoriesQuery, ConstituentTagCategoriesQueryVariables>(ConstituentTagCategoriesDocument, options);
        }
export type ConstituentTagCategoriesQueryHookResult = ReturnType<typeof useConstituentTagCategoriesQuery>;
export type ConstituentTagCategoriesLazyQueryHookResult = ReturnType<typeof useConstituentTagCategoriesLazyQuery>;
export type ConstituentTagCategoriesQueryResult = Apollo.QueryResult<ConstituentTagCategoriesQuery, ConstituentTagCategoriesQueryVariables>;
export const CreateConstituentTagCategoryDocument = gql`
    mutation CreateConstituentTagCategory($input: ConstituentTagCategoryCreateInput!) {
  constituentTagCategoryCreate(input: $input) {
    constituentTagCategory {
      id
    }
    errors {
      message
    }
  }
}
    `;
export type CreateConstituentTagCategoryMutationFn = Apollo.MutationFunction<CreateConstituentTagCategoryMutation, CreateConstituentTagCategoryMutationVariables>;

/**
 * __useCreateConstituentTagCategoryMutation__
 *
 * To run a mutation, you first call `useCreateConstituentTagCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConstituentTagCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConstituentTagCategoryMutation, { data, loading, error }] = useCreateConstituentTagCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateConstituentTagCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateConstituentTagCategoryMutation, CreateConstituentTagCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateConstituentTagCategoryMutation, CreateConstituentTagCategoryMutationVariables>(CreateConstituentTagCategoryDocument, options);
      }
export type CreateConstituentTagCategoryMutationHookResult = ReturnType<typeof useCreateConstituentTagCategoryMutation>;
export type CreateConstituentTagCategoryMutationResult = Apollo.MutationResult<CreateConstituentTagCategoryMutation>;
export type CreateConstituentTagCategoryMutationOptions = Apollo.BaseMutationOptions<CreateConstituentTagCategoryMutation, CreateConstituentTagCategoryMutationVariables>;
export const CreateConstituentTagDocument = gql`
    mutation CreateConstituentTag($input: ConstituentTagCreateInput!) {
  constituentTagCreate(input: $input) {
    constituentTag {
      id
    }
    errors {
      message
    }
  }
}
    `;
export type CreateConstituentTagMutationFn = Apollo.MutationFunction<CreateConstituentTagMutation, CreateConstituentTagMutationVariables>;

/**
 * __useCreateConstituentTagMutation__
 *
 * To run a mutation, you first call `useCreateConstituentTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConstituentTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConstituentTagMutation, { data, loading, error }] = useCreateConstituentTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateConstituentTagMutation(baseOptions?: Apollo.MutationHookOptions<CreateConstituentTagMutation, CreateConstituentTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateConstituentTagMutation, CreateConstituentTagMutationVariables>(CreateConstituentTagDocument, options);
      }
export type CreateConstituentTagMutationHookResult = ReturnType<typeof useCreateConstituentTagMutation>;
export type CreateConstituentTagMutationResult = Apollo.MutationResult<CreateConstituentTagMutation>;
export type CreateConstituentTagMutationOptions = Apollo.BaseMutationOptions<CreateConstituentTagMutation, CreateConstituentTagMutationVariables>;
export const DeleteConstituentTagDocument = gql`
    mutation DeleteConstituentTag($input: ConstituentTagDeleteInput!) {
  constituentTagDelete(input: $input) {
    constituentTag {
      id
    }
  }
}
    `;
export type DeleteConstituentTagMutationFn = Apollo.MutationFunction<DeleteConstituentTagMutation, DeleteConstituentTagMutationVariables>;

/**
 * __useDeleteConstituentTagMutation__
 *
 * To run a mutation, you first call `useDeleteConstituentTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteConstituentTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteConstituentTagMutation, { data, loading, error }] = useDeleteConstituentTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteConstituentTagMutation(baseOptions?: Apollo.MutationHookOptions<DeleteConstituentTagMutation, DeleteConstituentTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteConstituentTagMutation, DeleteConstituentTagMutationVariables>(DeleteConstituentTagDocument, options);
      }
export type DeleteConstituentTagMutationHookResult = ReturnType<typeof useDeleteConstituentTagMutation>;
export type DeleteConstituentTagMutationResult = Apollo.MutationResult<DeleteConstituentTagMutation>;
export type DeleteConstituentTagMutationOptions = Apollo.BaseMutationOptions<DeleteConstituentTagMutation, DeleteConstituentTagMutationVariables>;
export const PrintCommentUpdateDocument = gql`
    mutation PrintCommentUpdate($input: PrintCommentUpdateInput!) {
  printCommentUpdate(input: $input) {
    id
    commentHtml
  }
}
    `;
export type PrintCommentUpdateMutationFn = Apollo.MutationFunction<PrintCommentUpdateMutation, PrintCommentUpdateMutationVariables>;

/**
 * __usePrintCommentUpdateMutation__
 *
 * To run a mutation, you first call `usePrintCommentUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrintCommentUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [printCommentUpdateMutation, { data, loading, error }] = usePrintCommentUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePrintCommentUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PrintCommentUpdateMutation, PrintCommentUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrintCommentUpdateMutation, PrintCommentUpdateMutationVariables>(PrintCommentUpdateDocument, options);
      }
export type PrintCommentUpdateMutationHookResult = ReturnType<typeof usePrintCommentUpdateMutation>;
export type PrintCommentUpdateMutationResult = Apollo.MutationResult<PrintCommentUpdateMutation>;
export type PrintCommentUpdateMutationOptions = Apollo.BaseMutationOptions<PrintCommentUpdateMutation, PrintCommentUpdateMutationVariables>;
export const PrintQueueJobsFetchDocument = gql`
    query PrintQueueJobsFetch($limit: Int!, $offset: Int, $sort: PrintQueueJobSort, $filter: PrintQueueJobFilter) {
  printQueueJobsFetch(
    limit: $limit
    offset: $offset
    sort: $sort
    filter: $filter
  ) {
    printJobs {
      createdAt
      id
      ticketResolution
      updatedAt
      failedCommentCount
      documentUrls
      downloadable
      creator {
        id
        name
        zendeskId
      }
      printComments {
        id
        commentHtml
        createdAt
        printed
        updatedAt
        zendeskTicket {
          id
          zendeskId
          status
          formType
          requester {
            id
            name
            zendeskId
            hasValidAddress
            districtStatus
          }
          assignee {
            id
            name
            zendeskId
          }
        }
      }
    }
    totalJobs
  }
}
    `;

/**
 * __usePrintQueueJobsFetchQuery__
 *
 * To run a query within a React component, call `usePrintQueueJobsFetchQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrintQueueJobsFetchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrintQueueJobsFetchQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePrintQueueJobsFetchQuery(baseOptions: Apollo.QueryHookOptions<PrintQueueJobsFetchQuery, PrintQueueJobsFetchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrintQueueJobsFetchQuery, PrintQueueJobsFetchQueryVariables>(PrintQueueJobsFetchDocument, options);
      }
export function usePrintQueueJobsFetchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrintQueueJobsFetchQuery, PrintQueueJobsFetchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrintQueueJobsFetchQuery, PrintQueueJobsFetchQueryVariables>(PrintQueueJobsFetchDocument, options);
        }
export type PrintQueueJobsFetchQueryHookResult = ReturnType<typeof usePrintQueueJobsFetchQuery>;
export type PrintQueueJobsFetchLazyQueryHookResult = ReturnType<typeof usePrintQueueJobsFetchLazyQuery>;
export type PrintQueueJobsFetchQueryResult = Apollo.QueryResult<PrintQueueJobsFetchQuery, PrintQueueJobsFetchQueryVariables>;
export const PrintCommentsFetchDocument = gql`
    query PrintCommentsFetch($limit: Int!, $offset: Int, $filter: PrintCommentFilter, $sort: PrintCommentSort) {
  printCommentsFetch(limit: $limit, offset: $offset, filter: $filter, sort: $sort) {
    totalComments
    printComments {
      commentHtml
      id
      printed
      createdAt
      updatedAt
      zendeskTicket {
        id
        zendeskId
        formType
        batchName
        status
        requester {
          id
          zendeskId
          name
          hasValidAddress
          districtStatus
        }
      }
    }
  }
}
    `;

/**
 * __usePrintCommentsFetchQuery__
 *
 * To run a query within a React component, call `usePrintCommentsFetchQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrintCommentsFetchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrintCommentsFetchQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePrintCommentsFetchQuery(baseOptions: Apollo.QueryHookOptions<PrintCommentsFetchQuery, PrintCommentsFetchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrintCommentsFetchQuery, PrintCommentsFetchQueryVariables>(PrintCommentsFetchDocument, options);
      }
export function usePrintCommentsFetchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrintCommentsFetchQuery, PrintCommentsFetchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrintCommentsFetchQuery, PrintCommentsFetchQueryVariables>(PrintCommentsFetchDocument, options);
        }
export type PrintCommentsFetchQueryHookResult = ReturnType<typeof usePrintCommentsFetchQuery>;
export type PrintCommentsFetchLazyQueryHookResult = ReturnType<typeof usePrintCommentsFetchLazyQuery>;
export type PrintCommentsFetchQueryResult = Apollo.QueryResult<PrintCommentsFetchQuery, PrintCommentsFetchQueryVariables>;
export const PrintCommentsCloseDocument = gql`
    mutation PrintCommentsClose($input: PrintCommentsCloseInput!) {
  printCommentsClose(input: $input) {
    updateTicketsJobIds
  }
}
    `;
export type PrintCommentsCloseMutationFn = Apollo.MutationFunction<PrintCommentsCloseMutation, PrintCommentsCloseMutationVariables>;

/**
 * __usePrintCommentsCloseMutation__
 *
 * To run a mutation, you first call `usePrintCommentsCloseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrintCommentsCloseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [printCommentsCloseMutation, { data, loading, error }] = usePrintCommentsCloseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePrintCommentsCloseMutation(baseOptions?: Apollo.MutationHookOptions<PrintCommentsCloseMutation, PrintCommentsCloseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrintCommentsCloseMutation, PrintCommentsCloseMutationVariables>(PrintCommentsCloseDocument, options);
      }
export type PrintCommentsCloseMutationHookResult = ReturnType<typeof usePrintCommentsCloseMutation>;
export type PrintCommentsCloseMutationResult = Apollo.MutationResult<PrintCommentsCloseMutation>;
export type PrintCommentsCloseMutationOptions = Apollo.BaseMutationOptions<PrintCommentsCloseMutation, PrintCommentsCloseMutationVariables>;
export const PrintCommentsPrintDocument = gql`
    mutation PrintCommentsPrint($input: PrintCommentsPrintInput!) {
  printCommentsPrint(input: $input) {
    printQueueJob {
      id
    }
  }
}
    `;
export type PrintCommentsPrintMutationFn = Apollo.MutationFunction<PrintCommentsPrintMutation, PrintCommentsPrintMutationVariables>;

/**
 * __usePrintCommentsPrintMutation__
 *
 * To run a mutation, you first call `usePrintCommentsPrintMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrintCommentsPrintMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [printCommentsPrintMutation, { data, loading, error }] = usePrintCommentsPrintMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePrintCommentsPrintMutation(baseOptions?: Apollo.MutationHookOptions<PrintCommentsPrintMutation, PrintCommentsPrintMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrintCommentsPrintMutation, PrintCommentsPrintMutationVariables>(PrintCommentsPrintDocument, options);
      }
export type PrintCommentsPrintMutationHookResult = ReturnType<typeof usePrintCommentsPrintMutation>;
export type PrintCommentsPrintMutationResult = Apollo.MutationResult<PrintCommentsPrintMutation>;
export type PrintCommentsPrintMutationOptions = Apollo.BaseMutationOptions<PrintCommentsPrintMutation, PrintCommentsPrintMutationVariables>;
export const PrintQueueJobFetchDocument = gql`
    query printQueueJobFetch($id: ID!) {
  printQueueJobFetch(id: $id) {
    id
    failedCommentCount
    succeededCommentCount
    documentUrls
    printComments {
      id
      printed
    }
  }
}
    `;

/**
 * __usePrintQueueJobFetchQuery__
 *
 * To run a query within a React component, call `usePrintQueueJobFetchQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrintQueueJobFetchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrintQueueJobFetchQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePrintQueueJobFetchQuery(baseOptions: Apollo.QueryHookOptions<PrintQueueJobFetchQuery, PrintQueueJobFetchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrintQueueJobFetchQuery, PrintQueueJobFetchQueryVariables>(PrintQueueJobFetchDocument, options);
      }
export function usePrintQueueJobFetchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrintQueueJobFetchQuery, PrintQueueJobFetchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrintQueueJobFetchQuery, PrintQueueJobFetchQueryVariables>(PrintQueueJobFetchDocument, options);
        }
export type PrintQueueJobFetchQueryHookResult = ReturnType<typeof usePrintQueueJobFetchQuery>;
export type PrintQueueJobFetchLazyQueryHookResult = ReturnType<typeof usePrintQueueJobFetchLazyQuery>;
export type PrintQueueJobFetchQueryResult = Apollo.QueryResult<PrintQueueJobFetchQuery, PrintQueueJobFetchQueryVariables>;
export const ListDigitalTemplatesDocument = gql`
    query ListDigitalTemplates {
  digitalTemplates {
    letters {
      etag
      name
      fileName
    }
    envelopes {
      etag
      name
      fileName
    }
  }
}
    `;

/**
 * __useListDigitalTemplatesQuery__
 *
 * To run a query within a React component, call `useListDigitalTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDigitalTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDigitalTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useListDigitalTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<ListDigitalTemplatesQuery, ListDigitalTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListDigitalTemplatesQuery, ListDigitalTemplatesQueryVariables>(ListDigitalTemplatesDocument, options);
      }
export function useListDigitalTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListDigitalTemplatesQuery, ListDigitalTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListDigitalTemplatesQuery, ListDigitalTemplatesQueryVariables>(ListDigitalTemplatesDocument, options);
        }
export type ListDigitalTemplatesQueryHookResult = ReturnType<typeof useListDigitalTemplatesQuery>;
export type ListDigitalTemplatesLazyQueryHookResult = ReturnType<typeof useListDigitalTemplatesLazyQuery>;
export type ListDigitalTemplatesQueryResult = Apollo.QueryResult<ListDigitalTemplatesQuery, ListDigitalTemplatesQueryVariables>;
export const PrintTemplatePreviewDocument = gql`
    mutation PrintTemplatePreview($input: PrintTemplatePreviewInput!) {
  printTemplatePreview(input: $input) {
    url
  }
}
    `;
export type PrintTemplatePreviewMutationFn = Apollo.MutationFunction<PrintTemplatePreviewMutation, PrintTemplatePreviewMutationVariables>;

/**
 * __usePrintTemplatePreviewMutation__
 *
 * To run a mutation, you first call `usePrintTemplatePreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrintTemplatePreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [printTemplatePreviewMutation, { data, loading, error }] = usePrintTemplatePreviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePrintTemplatePreviewMutation(baseOptions?: Apollo.MutationHookOptions<PrintTemplatePreviewMutation, PrintTemplatePreviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrintTemplatePreviewMutation, PrintTemplatePreviewMutationVariables>(PrintTemplatePreviewDocument, options);
      }
export type PrintTemplatePreviewMutationHookResult = ReturnType<typeof usePrintTemplatePreviewMutation>;
export type PrintTemplatePreviewMutationResult = Apollo.MutationResult<PrintTemplatePreviewMutation>;
export type PrintTemplatePreviewMutationOptions = Apollo.BaseMutationOptions<PrintTemplatePreviewMutation, PrintTemplatePreviewMutationVariables>;
export const PrintUserUpdateDocument = gql`
    mutation PrintUserUpdate($input: PrintUserUpdateInput!) {
  printUserUpdate(input: $input) {
    success
  }
}
    `;
export type PrintUserUpdateMutationFn = Apollo.MutationFunction<PrintUserUpdateMutation, PrintUserUpdateMutationVariables>;

/**
 * __usePrintUserUpdateMutation__
 *
 * To run a mutation, you first call `usePrintUserUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrintUserUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [printUserUpdateMutation, { data, loading, error }] = usePrintUserUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePrintUserUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PrintUserUpdateMutation, PrintUserUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrintUserUpdateMutation, PrintUserUpdateMutationVariables>(PrintUserUpdateDocument, options);
      }
export type PrintUserUpdateMutationHookResult = ReturnType<typeof usePrintUserUpdateMutation>;
export type PrintUserUpdateMutationResult = Apollo.MutationResult<PrintUserUpdateMutation>;
export type PrintUserUpdateMutationOptions = Apollo.BaseMutationOptions<PrintUserUpdateMutation, PrintUserUpdateMutationVariables>;
export const CreatePrintCommentDocument = gql`
    mutation CreatePrintComment($input: PrintCommentCreateInput!) {
  printCommentCreate(input: $input) {
    id
    zendeskTicket {
      id
      zendeskId
      requester {
        name
        districtStatus
      }
    }
    commentHtml
  }
}
    `;
export type CreatePrintCommentMutationFn = Apollo.MutationFunction<CreatePrintCommentMutation, CreatePrintCommentMutationVariables>;

/**
 * __useCreatePrintCommentMutation__
 *
 * To run a mutation, you first call `useCreatePrintCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePrintCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPrintCommentMutation, { data, loading, error }] = useCreatePrintCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePrintCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreatePrintCommentMutation, CreatePrintCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePrintCommentMutation, CreatePrintCommentMutationVariables>(CreatePrintCommentDocument, options);
      }
export type CreatePrintCommentMutationHookResult = ReturnType<typeof useCreatePrintCommentMutation>;
export type CreatePrintCommentMutationResult = Apollo.MutationResult<CreatePrintCommentMutation>;
export type CreatePrintCommentMutationOptions = Apollo.BaseMutationOptions<CreatePrintCommentMutation, CreatePrintCommentMutationVariables>;
export const PrintTicketCommentDocument = gql`
    mutation PrintTicketComment($input: PrintTicketCommentInput!) {
  printTicketComment(input: $input) {
    file {
      fileName
      content
    }
  }
}
    `;
export type PrintTicketCommentMutationFn = Apollo.MutationFunction<PrintTicketCommentMutation, PrintTicketCommentMutationVariables>;

/**
 * __usePrintTicketCommentMutation__
 *
 * To run a mutation, you first call `usePrintTicketCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrintTicketCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [printTicketCommentMutation, { data, loading, error }] = usePrintTicketCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePrintTicketCommentMutation(baseOptions?: Apollo.MutationHookOptions<PrintTicketCommentMutation, PrintTicketCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrintTicketCommentMutation, PrintTicketCommentMutationVariables>(PrintTicketCommentDocument, options);
      }
export type PrintTicketCommentMutationHookResult = ReturnType<typeof usePrintTicketCommentMutation>;
export type PrintTicketCommentMutationResult = Apollo.MutationResult<PrintTicketCommentMutation>;
export type PrintTicketCommentMutationOptions = Apollo.BaseMutationOptions<PrintTicketCommentMutation, PrintTicketCommentMutationVariables>;
export const CurrentEditorDocument = gql`
    query CurrentEditor($input: GetCurrentEditorInput!) {
  currentEditor(input: $input) {
    currentEditor {
      id
      currentEditorId
      objectCurrentlyEditedId
      subdomain {
        name
      }
      appName
      createdAt
      updatedAt
      deletedAt
    }
  }
}
    `;

/**
 * __useCurrentEditorQuery__
 *
 * To run a query within a React component, call `useCurrentEditorQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentEditorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentEditorQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCurrentEditorQuery(baseOptions: Apollo.QueryHookOptions<CurrentEditorQuery, CurrentEditorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentEditorQuery, CurrentEditorQueryVariables>(CurrentEditorDocument, options);
      }
export function useCurrentEditorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentEditorQuery, CurrentEditorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentEditorQuery, CurrentEditorQueryVariables>(CurrentEditorDocument, options);
        }
export type CurrentEditorQueryHookResult = ReturnType<typeof useCurrentEditorQuery>;
export type CurrentEditorLazyQueryHookResult = ReturnType<typeof useCurrentEditorLazyQuery>;
export type CurrentEditorQueryResult = Apollo.QueryResult<CurrentEditorQuery, CurrentEditorQueryVariables>;
export const CurrentEditorAddOrUpdateDocument = gql`
    mutation currentEditorAddOrUpdate($input: AddOrUpdateCurrentEditorInput!) {
  currentEditorAddOrUpdate(input: $input) {
    id
    currentEditorId
    objectCurrentlyEditedId
    subdomain {
      name
    }
    appName
    createdAt
    updatedAt
    deletedAt
  }
}
    `;
export type CurrentEditorAddOrUpdateMutationFn = Apollo.MutationFunction<CurrentEditorAddOrUpdateMutation, CurrentEditorAddOrUpdateMutationVariables>;

/**
 * __useCurrentEditorAddOrUpdateMutation__
 *
 * To run a mutation, you first call `useCurrentEditorAddOrUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCurrentEditorAddOrUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [currentEditorAddOrUpdateMutation, { data, loading, error }] = useCurrentEditorAddOrUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCurrentEditorAddOrUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CurrentEditorAddOrUpdateMutation, CurrentEditorAddOrUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CurrentEditorAddOrUpdateMutation, CurrentEditorAddOrUpdateMutationVariables>(CurrentEditorAddOrUpdateDocument, options);
      }
export type CurrentEditorAddOrUpdateMutationHookResult = ReturnType<typeof useCurrentEditorAddOrUpdateMutation>;
export type CurrentEditorAddOrUpdateMutationResult = Apollo.MutationResult<CurrentEditorAddOrUpdateMutation>;
export type CurrentEditorAddOrUpdateMutationOptions = Apollo.BaseMutationOptions<CurrentEditorAddOrUpdateMutation, CurrentEditorAddOrUpdateMutationVariables>;
export const CurrentEditorDeleteDocument = gql`
    mutation currentEditorDelete($currentEditorDeleteId: ID!) {
  currentEditorDelete(id: $currentEditorDeleteId) {
    id
  }
}
    `;
export type CurrentEditorDeleteMutationFn = Apollo.MutationFunction<CurrentEditorDeleteMutation, CurrentEditorDeleteMutationVariables>;

/**
 * __useCurrentEditorDeleteMutation__
 *
 * To run a mutation, you first call `useCurrentEditorDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCurrentEditorDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [currentEditorDeleteMutation, { data, loading, error }] = useCurrentEditorDeleteMutation({
 *   variables: {
 *      currentEditorDeleteId: // value for 'currentEditorDeleteId'
 *   },
 * });
 */
export function useCurrentEditorDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CurrentEditorDeleteMutation, CurrentEditorDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CurrentEditorDeleteMutation, CurrentEditorDeleteMutationVariables>(CurrentEditorDeleteDocument, options);
      }
export type CurrentEditorDeleteMutationHookResult = ReturnType<typeof useCurrentEditorDeleteMutation>;
export type CurrentEditorDeleteMutationResult = Apollo.MutationResult<CurrentEditorDeleteMutation>;
export type CurrentEditorDeleteMutationOptions = Apollo.BaseMutationOptions<CurrentEditorDeleteMutation, CurrentEditorDeleteMutationVariables>;
export const GetBatchByBatchTagDocument = gql`
    query GetBatchByBatchTag($batchTag: String!) {
  getBatchByBatchTag(batchTag: $batchTag) {
    default
    id
    name
    rawName
    value
  }
}
    `;

/**
 * __useGetBatchByBatchTagQuery__
 *
 * To run a query within a React component, call `useGetBatchByBatchTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBatchByBatchTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBatchByBatchTagQuery({
 *   variables: {
 *      batchTag: // value for 'batchTag'
 *   },
 * });
 */
export function useGetBatchByBatchTagQuery(baseOptions: Apollo.QueryHookOptions<GetBatchByBatchTagQuery, GetBatchByBatchTagQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBatchByBatchTagQuery, GetBatchByBatchTagQueryVariables>(GetBatchByBatchTagDocument, options);
      }
export function useGetBatchByBatchTagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBatchByBatchTagQuery, GetBatchByBatchTagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBatchByBatchTagQuery, GetBatchByBatchTagQueryVariables>(GetBatchByBatchTagDocument, options);
        }
export type GetBatchByBatchTagQueryHookResult = ReturnType<typeof useGetBatchByBatchTagQuery>;
export type GetBatchByBatchTagLazyQueryHookResult = ReturnType<typeof useGetBatchByBatchTagLazyQuery>;
export type GetBatchByBatchTagQueryResult = Apollo.QueryResult<GetBatchByBatchTagQuery, GetBatchByBatchTagQueryVariables>;
export const ResponseCardMoveDocument = gql`
    mutation ResponseCardMove($input: ResponseCardMoveInput!) {
  responseCardMove(input: $input) {
    errors {
      message
    }
  }
}
    `;
export type ResponseCardMoveMutationFn = Apollo.MutationFunction<ResponseCardMoveMutation, ResponseCardMoveMutationVariables>;

/**
 * __useResponseCardMoveMutation__
 *
 * To run a mutation, you first call `useResponseCardMoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResponseCardMoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [responseCardMoveMutation, { data, loading, error }] = useResponseCardMoveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResponseCardMoveMutation(baseOptions?: Apollo.MutationHookOptions<ResponseCardMoveMutation, ResponseCardMoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResponseCardMoveMutation, ResponseCardMoveMutationVariables>(ResponseCardMoveDocument, options);
      }
export type ResponseCardMoveMutationHookResult = ReturnType<typeof useResponseCardMoveMutation>;
export type ResponseCardMoveMutationResult = Apollo.MutationResult<ResponseCardMoveMutation>;
export type ResponseCardMoveMutationOptions = Apollo.BaseMutationOptions<ResponseCardMoveMutation, ResponseCardMoveMutationVariables>;
export const ResponseDeleteDocument = gql`
    mutation ResponseDelete($input: ResponseDeleteInput!) {
  responseDelete(input: $input) {
    errors {
      message
    }
    response {
      id
    }
  }
}
    `;
export type ResponseDeleteMutationFn = Apollo.MutationFunction<ResponseDeleteMutation, ResponseDeleteMutationVariables>;

/**
 * __useResponseDeleteMutation__
 *
 * To run a mutation, you first call `useResponseDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResponseDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [responseDeleteMutation, { data, loading, error }] = useResponseDeleteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResponseDeleteMutation(baseOptions?: Apollo.MutationHookOptions<ResponseDeleteMutation, ResponseDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResponseDeleteMutation, ResponseDeleteMutationVariables>(ResponseDeleteDocument, options);
      }
export type ResponseDeleteMutationHookResult = ReturnType<typeof useResponseDeleteMutation>;
export type ResponseDeleteMutationResult = Apollo.MutationResult<ResponseDeleteMutation>;
export type ResponseDeleteMutationOptions = Apollo.BaseMutationOptions<ResponseDeleteMutation, ResponseDeleteMutationVariables>;
export const TicketCountMatchingTriggerDocument = gql`
    query TicketCountMatchingTrigger($input: TicketCountMatchingTriggerInput!) {
  ticketCountMatchingTrigger(input: $input) {
    count
  }
}
    `;

/**
 * __useTicketCountMatchingTriggerQuery__
 *
 * To run a query within a React component, call `useTicketCountMatchingTriggerQuery` and pass it any options that fit your needs.
 * When your component renders, `useTicketCountMatchingTriggerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTicketCountMatchingTriggerQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTicketCountMatchingTriggerQuery(baseOptions: Apollo.QueryHookOptions<TicketCountMatchingTriggerQuery, TicketCountMatchingTriggerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TicketCountMatchingTriggerQuery, TicketCountMatchingTriggerQueryVariables>(TicketCountMatchingTriggerDocument, options);
      }
export function useTicketCountMatchingTriggerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TicketCountMatchingTriggerQuery, TicketCountMatchingTriggerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TicketCountMatchingTriggerQuery, TicketCountMatchingTriggerQueryVariables>(TicketCountMatchingTriggerDocument, options);
        }
export type TicketCountMatchingTriggerQueryHookResult = ReturnType<typeof useTicketCountMatchingTriggerQuery>;
export type TicketCountMatchingTriggerLazyQueryHookResult = ReturnType<typeof useTicketCountMatchingTriggerLazyQuery>;
export type TicketCountMatchingTriggerQueryResult = Apollo.QueryResult<TicketCountMatchingTriggerQuery, TicketCountMatchingTriggerQueryVariables>;
export const TicketSearchByTriggerApplyResponseDocument = gql`
    mutation TicketSearchByTriggerApplyResponse($input: TicketSearchByTriggerApplyResponseInput!) {
  ticketSearchByTriggerApplyResponse(input: $input) {
    success
  }
}
    `;
export type TicketSearchByTriggerApplyResponseMutationFn = Apollo.MutationFunction<TicketSearchByTriggerApplyResponseMutation, TicketSearchByTriggerApplyResponseMutationVariables>;

/**
 * __useTicketSearchByTriggerApplyResponseMutation__
 *
 * To run a mutation, you first call `useTicketSearchByTriggerApplyResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTicketSearchByTriggerApplyResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ticketSearchByTriggerApplyResponseMutation, { data, loading, error }] = useTicketSearchByTriggerApplyResponseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTicketSearchByTriggerApplyResponseMutation(baseOptions?: Apollo.MutationHookOptions<TicketSearchByTriggerApplyResponseMutation, TicketSearchByTriggerApplyResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TicketSearchByTriggerApplyResponseMutation, TicketSearchByTriggerApplyResponseMutationVariables>(TicketSearchByTriggerApplyResponseDocument, options);
      }
export type TicketSearchByTriggerApplyResponseMutationHookResult = ReturnType<typeof useTicketSearchByTriggerApplyResponseMutation>;
export type TicketSearchByTriggerApplyResponseMutationResult = Apollo.MutationResult<TicketSearchByTriggerApplyResponseMutation>;
export type TicketSearchByTriggerApplyResponseMutationOptions = Apollo.BaseMutationOptions<TicketSearchByTriggerApplyResponseMutation, TicketSearchByTriggerApplyResponseMutationVariables>;
export const TicketSearchByTriggerAddBatchDocument = gql`
    mutation TicketSearchByTriggerAddBatch($input: TicketSearchByTriggerAddBatchInput!) {
  ticketSearchByTriggerAddBatch(input: $input) {
    success
  }
}
    `;
export type TicketSearchByTriggerAddBatchMutationFn = Apollo.MutationFunction<TicketSearchByTriggerAddBatchMutation, TicketSearchByTriggerAddBatchMutationVariables>;

/**
 * __useTicketSearchByTriggerAddBatchMutation__
 *
 * To run a mutation, you first call `useTicketSearchByTriggerAddBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTicketSearchByTriggerAddBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ticketSearchByTriggerAddBatchMutation, { data, loading, error }] = useTicketSearchByTriggerAddBatchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTicketSearchByTriggerAddBatchMutation(baseOptions?: Apollo.MutationHookOptions<TicketSearchByTriggerAddBatchMutation, TicketSearchByTriggerAddBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TicketSearchByTriggerAddBatchMutation, TicketSearchByTriggerAddBatchMutationVariables>(TicketSearchByTriggerAddBatchDocument, options);
      }
export type TicketSearchByTriggerAddBatchMutationHookResult = ReturnType<typeof useTicketSearchByTriggerAddBatchMutation>;
export type TicketSearchByTriggerAddBatchMutationResult = Apollo.MutationResult<TicketSearchByTriggerAddBatchMutation>;
export type TicketSearchByTriggerAddBatchMutationOptions = Apollo.BaseMutationOptions<TicketSearchByTriggerAddBatchMutation, TicketSearchByTriggerAddBatchMutationVariables>;
export const TriggerCreateAutoResponseDocument = gql`
    mutation TriggerCreateAutoResponse($input: TriggerCreateAutoResponseInput!) {
  triggerCreateAutoResponse(input: $input) {
    errors {
      message
    }
    trigger {
      id
      name
      active
    }
  }
}
    `;
export type TriggerCreateAutoResponseMutationFn = Apollo.MutationFunction<TriggerCreateAutoResponseMutation, TriggerCreateAutoResponseMutationVariables>;

/**
 * __useTriggerCreateAutoResponseMutation__
 *
 * To run a mutation, you first call `useTriggerCreateAutoResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerCreateAutoResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerCreateAutoResponseMutation, { data, loading, error }] = useTriggerCreateAutoResponseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTriggerCreateAutoResponseMutation(baseOptions?: Apollo.MutationHookOptions<TriggerCreateAutoResponseMutation, TriggerCreateAutoResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerCreateAutoResponseMutation, TriggerCreateAutoResponseMutationVariables>(TriggerCreateAutoResponseDocument, options);
      }
export type TriggerCreateAutoResponseMutationHookResult = ReturnType<typeof useTriggerCreateAutoResponseMutation>;
export type TriggerCreateAutoResponseMutationResult = Apollo.MutationResult<TriggerCreateAutoResponseMutation>;
export type TriggerCreateAutoResponseMutationOptions = Apollo.BaseMutationOptions<TriggerCreateAutoResponseMutation, TriggerCreateAutoResponseMutationVariables>;
export const TriggerCreateAutoBatchDocument = gql`
    mutation TriggerCreateAutoBatch($input: TriggerCreateAutoBatchInput!) {
  triggerCreateAutoBatch(input: $input) {
    errors {
      message
    }
    trigger {
      id
      name
      active
    }
  }
}
    `;
export type TriggerCreateAutoBatchMutationFn = Apollo.MutationFunction<TriggerCreateAutoBatchMutation, TriggerCreateAutoBatchMutationVariables>;

/**
 * __useTriggerCreateAutoBatchMutation__
 *
 * To run a mutation, you first call `useTriggerCreateAutoBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerCreateAutoBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerCreateAutoBatchMutation, { data, loading, error }] = useTriggerCreateAutoBatchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTriggerCreateAutoBatchMutation(baseOptions?: Apollo.MutationHookOptions<TriggerCreateAutoBatchMutation, TriggerCreateAutoBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerCreateAutoBatchMutation, TriggerCreateAutoBatchMutationVariables>(TriggerCreateAutoBatchDocument, options);
      }
export type TriggerCreateAutoBatchMutationHookResult = ReturnType<typeof useTriggerCreateAutoBatchMutation>;
export type TriggerCreateAutoBatchMutationResult = Apollo.MutationResult<TriggerCreateAutoBatchMutation>;
export type TriggerCreateAutoBatchMutationOptions = Apollo.BaseMutationOptions<TriggerCreateAutoBatchMutation, TriggerCreateAutoBatchMutationVariables>;
export const TicketEditorSideConversationsDocument = gql`
    query TicketEditorSideConversations($ticketId: String!) {
  sideConversations(parentTicketId: $ticketId) {
    collection {
      subject
      messages {
        id
        createdBy {
          email
        }
        message
        sentAt
        attachments {
          filename
          url
        }
      }
    }
  }
}
    `;

/**
 * __useTicketEditorSideConversationsQuery__
 *
 * To run a query within a React component, call `useTicketEditorSideConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTicketEditorSideConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTicketEditorSideConversationsQuery({
 *   variables: {
 *      ticketId: // value for 'ticketId'
 *   },
 * });
 */
export function useTicketEditorSideConversationsQuery(baseOptions: Apollo.QueryHookOptions<TicketEditorSideConversationsQuery, TicketEditorSideConversationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TicketEditorSideConversationsQuery, TicketEditorSideConversationsQueryVariables>(TicketEditorSideConversationsDocument, options);
      }
export function useTicketEditorSideConversationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TicketEditorSideConversationsQuery, TicketEditorSideConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TicketEditorSideConversationsQuery, TicketEditorSideConversationsQueryVariables>(TicketEditorSideConversationsDocument, options);
        }
export type TicketEditorSideConversationsQueryHookResult = ReturnType<typeof useTicketEditorSideConversationsQuery>;
export type TicketEditorSideConversationsLazyQueryHookResult = ReturnType<typeof useTicketEditorSideConversationsLazyQuery>;
export type TicketEditorSideConversationsQueryResult = Apollo.QueryResult<TicketEditorSideConversationsQuery, TicketEditorSideConversationsQueryVariables>;
export const ConversationDetailsDocument = gql`
    query conversationDetails($conversationId: ID!) {
  sideConversation(id: $conversationId) {
    id
    messages {
      id
      messageStatus
      messageType
      sentAt
      createdBy {
        email
      }
      message
      isRead
      recipients {
        id
        email
        name
      }
      attachments {
        filename
        url
      }
    }
  }
}
    `;

/**
 * __useConversationDetailsQuery__
 *
 * To run a query within a React component, call `useConversationDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConversationDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConversationDetailsQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useConversationDetailsQuery(baseOptions: Apollo.QueryHookOptions<ConversationDetailsQuery, ConversationDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConversationDetailsQuery, ConversationDetailsQueryVariables>(ConversationDetailsDocument, options);
      }
export function useConversationDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConversationDetailsQuery, ConversationDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConversationDetailsQuery, ConversationDetailsQueryVariables>(ConversationDetailsDocument, options);
        }
export type ConversationDetailsQueryHookResult = ReturnType<typeof useConversationDetailsQuery>;
export type ConversationDetailsLazyQueryHookResult = ReturnType<typeof useConversationDetailsLazyQuery>;
export type ConversationDetailsQueryResult = Apollo.QueryResult<ConversationDetailsQuery, ConversationDetailsQueryVariables>;
export const ParticipantSuggestionsDocument = gql`
    query participantSuggestions($query: String!) {
  zendeskUsers(filter: {nameCont: $query}, limit: 10) {
    collection {
      id
      email
      name
    }
  }
}
    `;

/**
 * __useParticipantSuggestionsQuery__
 *
 * To run a query within a React component, call `useParticipantSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useParticipantSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParticipantSuggestionsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useParticipantSuggestionsQuery(baseOptions: Apollo.QueryHookOptions<ParticipantSuggestionsQuery, ParticipantSuggestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ParticipantSuggestionsQuery, ParticipantSuggestionsQueryVariables>(ParticipantSuggestionsDocument, options);
      }
export function useParticipantSuggestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ParticipantSuggestionsQuery, ParticipantSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ParticipantSuggestionsQuery, ParticipantSuggestionsQueryVariables>(ParticipantSuggestionsDocument, options);
        }
export type ParticipantSuggestionsQueryHookResult = ReturnType<typeof useParticipantSuggestionsQuery>;
export type ParticipantSuggestionsLazyQueryHookResult = ReturnType<typeof useParticipantSuggestionsLazyQuery>;
export type ParticipantSuggestionsQueryResult = Apollo.QueryResult<ParticipantSuggestionsQuery, ParticipantSuggestionsQueryVariables>;
export const SideConversationsDocument = gql`
    query sideConversations($ticketId: String) {
  sideConversations(parentTicketId: $ticketId) {
    collection {
      id
      subject
      hasNewMessage
      mostRecentMessage {
        sentAt
        createdBy {
          email
        }
        message
        recipients {
          id
          zendeskId
          email
          name
        }
      }
    }
  }
}
    `;

/**
 * __useSideConversationsQuery__
 *
 * To run a query within a React component, call `useSideConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSideConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSideConversationsQuery({
 *   variables: {
 *      ticketId: // value for 'ticketId'
 *   },
 * });
 */
export function useSideConversationsQuery(baseOptions?: Apollo.QueryHookOptions<SideConversationsQuery, SideConversationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SideConversationsQuery, SideConversationsQueryVariables>(SideConversationsDocument, options);
      }
export function useSideConversationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SideConversationsQuery, SideConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SideConversationsQuery, SideConversationsQueryVariables>(SideConversationsDocument, options);
        }
export type SideConversationsQueryHookResult = ReturnType<typeof useSideConversationsQuery>;
export type SideConversationsLazyQueryHookResult = ReturnType<typeof useSideConversationsLazyQuery>;
export type SideConversationsQueryResult = Apollo.QueryResult<SideConversationsQuery, SideConversationsQueryVariables>;
export const CreateSideConversationDocument = gql`
    mutation CreateSideConversation($input: CreateSideConversationInput!) {
  createSideConversation(input: $input) {
    id
  }
}
    `;
export type CreateSideConversationMutationFn = Apollo.MutationFunction<CreateSideConversationMutation, CreateSideConversationMutationVariables>;

/**
 * __useCreateSideConversationMutation__
 *
 * To run a mutation, you first call `useCreateSideConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSideConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSideConversationMutation, { data, loading, error }] = useCreateSideConversationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSideConversationMutation(baseOptions?: Apollo.MutationHookOptions<CreateSideConversationMutation, CreateSideConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSideConversationMutation, CreateSideConversationMutationVariables>(CreateSideConversationDocument, options);
      }
export type CreateSideConversationMutationHookResult = ReturnType<typeof useCreateSideConversationMutation>;
export type CreateSideConversationMutationResult = Apollo.MutationResult<CreateSideConversationMutation>;
export type CreateSideConversationMutationOptions = Apollo.BaseMutationOptions<CreateSideConversationMutation, CreateSideConversationMutationVariables>;
export const GetResponseVersionsDocument = gql`
    query getResponseVersions($responseId: ID!) {
  response(id: $responseId) {
    versions(page: 1, limit: 1000) {
      collection {
        id
        actions
        actor {
          email
          name
          photo {
            contentUrl
          }
        }
        createdAt
      }
      metadata {
        totalPages
        totalCount
      }
    }
  }
}
    `;

/**
 * __useGetResponseVersionsQuery__
 *
 * To run a query within a React component, call `useGetResponseVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResponseVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResponseVersionsQuery({
 *   variables: {
 *      responseId: // value for 'responseId'
 *   },
 * });
 */
export function useGetResponseVersionsQuery(baseOptions: Apollo.QueryHookOptions<GetResponseVersionsQuery, GetResponseVersionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetResponseVersionsQuery, GetResponseVersionsQueryVariables>(GetResponseVersionsDocument, options);
      }
export function useGetResponseVersionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetResponseVersionsQuery, GetResponseVersionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetResponseVersionsQuery, GetResponseVersionsQueryVariables>(GetResponseVersionsDocument, options);
        }
export type GetResponseVersionsQueryHookResult = ReturnType<typeof useGetResponseVersionsQuery>;
export type GetResponseVersionsLazyQueryHookResult = ReturnType<typeof useGetResponseVersionsLazyQuery>;
export type GetResponseVersionsQueryResult = Apollo.QueryResult<GetResponseVersionsQuery, GetResponseVersionsQueryVariables>;
export const MakeResponseCommentDocument = gql`
    mutation makeResponseComment($responseId: ID!, $comment: String!) {
  responseCommentCreate(input: {responseId: $responseId, comment: $comment}) {
    errors {
      message
      path
    }
    response {
      id
      comments {
        id
        actor {
          id
          name
          email
        }
        comment
        createdAt
      }
    }
  }
}
    `;
export type MakeResponseCommentMutationFn = Apollo.MutationFunction<MakeResponseCommentMutation, MakeResponseCommentMutationVariables>;

/**
 * __useMakeResponseCommentMutation__
 *
 * To run a mutation, you first call `useMakeResponseCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeResponseCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeResponseCommentMutation, { data, loading, error }] = useMakeResponseCommentMutation({
 *   variables: {
 *      responseId: // value for 'responseId'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useMakeResponseCommentMutation(baseOptions?: Apollo.MutationHookOptions<MakeResponseCommentMutation, MakeResponseCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MakeResponseCommentMutation, MakeResponseCommentMutationVariables>(MakeResponseCommentDocument, options);
      }
export type MakeResponseCommentMutationHookResult = ReturnType<typeof useMakeResponseCommentMutation>;
export type MakeResponseCommentMutationResult = Apollo.MutationResult<MakeResponseCommentMutation>;
export type MakeResponseCommentMutationOptions = Apollo.BaseMutationOptions<MakeResponseCommentMutation, MakeResponseCommentMutationVariables>;
export const GetResponseCommentsDocument = gql`
    query getResponseComments($responseId: ID!) {
  response(id: $responseId) {
    id
    comments {
      id
      actor {
        id
        name
        email
      }
      comment
      createdAt
    }
  }
}
    `;

/**
 * __useGetResponseCommentsQuery__
 *
 * To run a query within a React component, call `useGetResponseCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResponseCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResponseCommentsQuery({
 *   variables: {
 *      responseId: // value for 'responseId'
 *   },
 * });
 */
export function useGetResponseCommentsQuery(baseOptions: Apollo.QueryHookOptions<GetResponseCommentsQuery, GetResponseCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetResponseCommentsQuery, GetResponseCommentsQueryVariables>(GetResponseCommentsDocument, options);
      }
export function useGetResponseCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetResponseCommentsQuery, GetResponseCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetResponseCommentsQuery, GetResponseCommentsQueryVariables>(GetResponseCommentsDocument, options);
        }
export type GetResponseCommentsQueryHookResult = ReturnType<typeof useGetResponseCommentsQuery>;
export type GetResponseCommentsLazyQueryHookResult = ReturnType<typeof useGetResponseCommentsLazyQuery>;
export type GetResponseCommentsQueryResult = Apollo.QueryResult<GetResponseCommentsQuery, GetResponseCommentsQueryVariables>;
export const MakeResponseViewDocument = gql`
    mutation makeResponseView($responseId: ID!) {
  responseViewUpdate(input: {responseId: $responseId}) {
    errors {
      message
      path
    }
  }
}
    `;
export type MakeResponseViewMutationFn = Apollo.MutationFunction<MakeResponseViewMutation, MakeResponseViewMutationVariables>;

/**
 * __useMakeResponseViewMutation__
 *
 * To run a mutation, you first call `useMakeResponseViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeResponseViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeResponseViewMutation, { data, loading, error }] = useMakeResponseViewMutation({
 *   variables: {
 *      responseId: // value for 'responseId'
 *   },
 * });
 */
export function useMakeResponseViewMutation(baseOptions?: Apollo.MutationHookOptions<MakeResponseViewMutation, MakeResponseViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MakeResponseViewMutation, MakeResponseViewMutationVariables>(MakeResponseViewDocument, options);
      }
export type MakeResponseViewMutationHookResult = ReturnType<typeof useMakeResponseViewMutation>;
export type MakeResponseViewMutationResult = Apollo.MutationResult<MakeResponseViewMutation>;
export type MakeResponseViewMutationOptions = Apollo.BaseMutationOptions<MakeResponseViewMutation, MakeResponseViewMutationVariables>;
export const ListBatchesDocument = gql`
    query listBatches {
  batches(limit: 1000) {
    collection {
      name
    }
  }
}
    `;

/**
 * __useListBatchesQuery__
 *
 * To run a query within a React component, call `useListBatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListBatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListBatchesQuery({
 *   variables: {
 *   },
 * });
 */
export function useListBatchesQuery(baseOptions?: Apollo.QueryHookOptions<ListBatchesQuery, ListBatchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListBatchesQuery, ListBatchesQueryVariables>(ListBatchesDocument, options);
      }
export function useListBatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListBatchesQuery, ListBatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListBatchesQuery, ListBatchesQueryVariables>(ListBatchesDocument, options);
        }
export type ListBatchesQueryHookResult = ReturnType<typeof useListBatchesQuery>;
export type ListBatchesLazyQueryHookResult = ReturnType<typeof useListBatchesLazyQuery>;
export type ListBatchesQueryResult = Apollo.QueryResult<ListBatchesQuery, ListBatchesQueryVariables>;
export const ListTagsDocument = gql`
    query listTags {
  tags(limit: 1000) {
    collection {
      id
      name
      topic {
        name
      }
    }
  }
}
    `;

/**
 * __useListTagsQuery__
 *
 * To run a query within a React component, call `useListTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListTagsQuery(baseOptions?: Apollo.QueryHookOptions<ListTagsQuery, ListTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListTagsQuery, ListTagsQueryVariables>(ListTagsDocument, options);
      }
export function useListTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListTagsQuery, ListTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListTagsQuery, ListTagsQueryVariables>(ListTagsDocument, options);
        }
export type ListTagsQueryHookResult = ReturnType<typeof useListTagsQuery>;
export type ListTagsLazyQueryHookResult = ReturnType<typeof useListTagsLazyQuery>;
export type ListTagsQueryResult = Apollo.QueryResult<ListTagsQuery, ListTagsQueryVariables>;
export const GetTopicsDropdownDocument = gql`
    query getTopicsDropdown {
  topics(limit: 1000) {
    collection {
      id
      name
    }
  }
}
    `;

/**
 * __useGetTopicsDropdownQuery__
 *
 * To run a query within a React component, call `useGetTopicsDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopicsDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopicsDropdownQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTopicsDropdownQuery(baseOptions?: Apollo.QueryHookOptions<GetTopicsDropdownQuery, GetTopicsDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTopicsDropdownQuery, GetTopicsDropdownQueryVariables>(GetTopicsDropdownDocument, options);
      }
export function useGetTopicsDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTopicsDropdownQuery, GetTopicsDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTopicsDropdownQuery, GetTopicsDropdownQueryVariables>(GetTopicsDropdownDocument, options);
        }
export type GetTopicsDropdownQueryHookResult = ReturnType<typeof useGetTopicsDropdownQuery>;
export type GetTopicsDropdownLazyQueryHookResult = ReturnType<typeof useGetTopicsDropdownLazyQuery>;
export type GetTopicsDropdownQueryResult = Apollo.QueryResult<GetTopicsDropdownQuery, GetTopicsDropdownQueryVariables>;
export const GetApprovedResponseDocument = gql`
    query getApprovedResponse($responseId: ID!) {
  response(id: $responseId) {
    id
    batches {
      id
      name
      metrics {
        numTicketsOpen
      }
      topic {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetApprovedResponseQuery__
 *
 * To run a query within a React component, call `useGetApprovedResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApprovedResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApprovedResponseQuery({
 *   variables: {
 *      responseId: // value for 'responseId'
 *   },
 * });
 */
export function useGetApprovedResponseQuery(baseOptions: Apollo.QueryHookOptions<GetApprovedResponseQuery, GetApprovedResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApprovedResponseQuery, GetApprovedResponseQueryVariables>(GetApprovedResponseDocument, options);
      }
export function useGetApprovedResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApprovedResponseQuery, GetApprovedResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApprovedResponseQuery, GetApprovedResponseQueryVariables>(GetApprovedResponseDocument, options);
        }
export type GetApprovedResponseQueryHookResult = ReturnType<typeof useGetApprovedResponseQuery>;
export type GetApprovedResponseLazyQueryHookResult = ReturnType<typeof useGetApprovedResponseLazyQuery>;
export type GetApprovedResponseQueryResult = Apollo.QueryResult<GetApprovedResponseQuery, GetApprovedResponseQueryVariables>;
export const UnassignBatchDocument = gql`
    mutation unassignBatch($batchId: ID!) {
  batchResponseUnassign(input: {id: $batchId}) {
    batch {
      id
      name
      displayName
      value
      card {
        attributes {
          batchValue
          creatorId
          responseId
        }
      }
      columnName
      status
      statusOrder
      topic {
        id
        name
      }
      metrics {
        openTickets
        medianAge
        oldestDate
      }
    }
  }
}
    `;
export type UnassignBatchMutationFn = Apollo.MutationFunction<UnassignBatchMutation, UnassignBatchMutationVariables>;

/**
 * __useUnassignBatchMutation__
 *
 * To run a mutation, you first call `useUnassignBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignBatchMutation, { data, loading, error }] = useUnassignBatchMutation({
 *   variables: {
 *      batchId: // value for 'batchId'
 *   },
 * });
 */
export function useUnassignBatchMutation(baseOptions?: Apollo.MutationHookOptions<UnassignBatchMutation, UnassignBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnassignBatchMutation, UnassignBatchMutationVariables>(UnassignBatchDocument, options);
      }
export type UnassignBatchMutationHookResult = ReturnType<typeof useUnassignBatchMutation>;
export type UnassignBatchMutationResult = Apollo.MutationResult<UnassignBatchMutation>;
export type UnassignBatchMutationOptions = Apollo.BaseMutationOptions<UnassignBatchMutation, UnassignBatchMutationVariables>;
export const GetResponseTitleDocument = gql`
    query getResponseTitle($responseId: ID!) {
  response(id: $responseId) {
    id
    title
  }
}
    `;

/**
 * __useGetResponseTitleQuery__
 *
 * To run a query within a React component, call `useGetResponseTitleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResponseTitleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResponseTitleQuery({
 *   variables: {
 *      responseId: // value for 'responseId'
 *   },
 * });
 */
export function useGetResponseTitleQuery(baseOptions: Apollo.QueryHookOptions<GetResponseTitleQuery, GetResponseTitleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetResponseTitleQuery, GetResponseTitleQueryVariables>(GetResponseTitleDocument, options);
      }
export function useGetResponseTitleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetResponseTitleQuery, GetResponseTitleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetResponseTitleQuery, GetResponseTitleQueryVariables>(GetResponseTitleDocument, options);
        }
export type GetResponseTitleQueryHookResult = ReturnType<typeof useGetResponseTitleQuery>;
export type GetResponseTitleLazyQueryHookResult = ReturnType<typeof useGetResponseTitleLazyQuery>;
export type GetResponseTitleQueryResult = Apollo.QueryResult<GetResponseTitleQuery, GetResponseTitleQueryVariables>;
export const DeleteResponseDocument = gql`
    mutation deleteResponse($responseId: ID!) {
  responseDelete(input: {id: $responseId}) {
    errors {
      message
      path
    }
  }
}
    `;
export type DeleteResponseMutationFn = Apollo.MutationFunction<DeleteResponseMutation, DeleteResponseMutationVariables>;

/**
 * __useDeleteResponseMutation__
 *
 * To run a mutation, you first call `useDeleteResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteResponseMutation, { data, loading, error }] = useDeleteResponseMutation({
 *   variables: {
 *      responseId: // value for 'responseId'
 *   },
 * });
 */
export function useDeleteResponseMutation(baseOptions?: Apollo.MutationHookOptions<DeleteResponseMutation, DeleteResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteResponseMutation, DeleteResponseMutationVariables>(DeleteResponseDocument, options);
      }
export type DeleteResponseMutationHookResult = ReturnType<typeof useDeleteResponseMutation>;
export type DeleteResponseMutationResult = Apollo.MutationResult<DeleteResponseMutation>;
export type DeleteResponseMutationOptions = Apollo.BaseMutationOptions<DeleteResponseMutation, DeleteResponseMutationVariables>;